const doses = {
  "Acetyl L-Carnitine": 500,
  "Alpha GPC": 300,
  "Apigenin": 50,
  "Ashwagandha": 900,
  "Berberine": 400,
  "Biotin": 10000,
  "Calcium": 1000,
  "CoQ10": 200,
  "Curcumin": 500,
  "Folic Acid": 800,
  "Ginseng": 1000,
  "Inositol": 1000,
  "Iron": 65,
  "L-Theanine": 200,
  "L-Tyrosine": 500,
  "Magnesium": 400,
  "Omega 3": 3000,
  "Probiotics": 136,
  "Resveratrol": 500,
  "Rhodiola Rosea": 500,
  "Tongkat Ali": 800,
  "Vitamin B12": 1000,
  "Vitamin B2": 400,
  "Vitamin B6": 200,
  "Vitamin C": 1000,
  "Vitamin D": 125,
  "Vitamin E": 360,
  "Zinc": 50,
};


window.doses = doses;

const unit = {
  "Acetyl L-Carnitine": 'mg',
  "Alpha GPC": 'mg',
  "Apigenin": 'mg',
  "Ashwagandha": 'mg',
  "Berberine": 'mg',
  "Biotin": 'mcg',
  "Calcium": 'mg',
  "CoQ10": 'mg',
  "Curcumin": 'mg',
  "Folic Acid": 'mcg',
  "Ginseng": 'mg',
  "Inositol": 'mg',
  "Iron": 'mg',
  "L-Theanine": 'mg',
  "L-Tyrosine": 'mg',
  "Magnesium": 'mg',
  "Omega 3": 'mg',
  "Probiotics": 'mg',
  "Resveratrol": 'mg',
  "Rhodiola Rosea": 'mg',
  "Tongkat Ali": 'mg',
  "Vitamin B12": 'mcg',
  "Vitamin B2": 'mg',
  "Vitamin B6": 'mg',
  "Vitamin C": 'mg',
  "Vitamin D": 'mcg',
  "Vitamin E": 'mg',
  "Zinc": 'mg'
};
window.unit = unit;

const pills = {
  "Acetyl L-Carnitine": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Acetyl_L-Carnitine.png?v=1774684027",
  "Alpha GPC": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Alpha_GCP.png?v=1774684027",
  "Apigenin": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/apigenin.png?v=1774684026",
  "Ashwagandha": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/ashwagandha.webp?v=1776843239",
  "Berberine": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Berberine.png?v=1774684065",
  "Biotin": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/biotin.webp?v=1776843238",
  "Calcium": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/calcium.webp?v=1776843239",
  "CoQ10": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/coq10.webp?v=1776843239",
  "Curcumin": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/curcumin.png?v=1774684027",
  "Folic Acid": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/folic-acid.webp?v=1776843238",
  "Inositol": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Inositol.png?v=1774684026",
  "Iron": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/iron.webp?v=1776843239",
  "L-Theanine": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/L-Theanine.png?v=1774684027",
  "L-Tyrosine": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/L-Tyrosine.png?v=1774684027",
  "Magnesium": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/magnesium.webp?v=1776843238",
  "Omega 3": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/omega-3.webp?v=1776843238",
  "Probiotics": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/probiotics.webp?v=1776843238",
  "Resveratrol": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Resveratrol.png?v=1774684027",
  "Rhodiola Rosea": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Rhodiola_Rosea.png?v=1774684027",
  "Tongkat Ali": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/tongkat_ali.png?v=1774684027",
  "Vitamin B12": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitamin-b12.webp?v=1776843238",
  "Vitamin B2": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitamin-b2.webp?v=1776843239",
  "Vitamin B6": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitamin-b6.webp?v=1776843238",
  "Vitamin C": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitamin-c.webp?v=1776843238",
  "Vitamin D": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitamin-d.webp?v=1776843237",
  "Vitamin E": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitamin-e.webp?v=1776843238",
  "Zinc": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/zinc.webp?v=1776843225"
};


  window.pills = pills;

  const pills_shadow = {
      "Ashwagandha": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/ashwagandha_shadow.png?v=1745055820",
      "Biotin": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/biotin_shadow.png?v=1745055820",
      "Calcium": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/calcium_shadow.png?v=1745055820",
      "CoQ10": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/coq10_shadow.png?v=1745055820",
      "Folic Acid": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/folic_acid_shadow.png?v=1745055820",
      "Ginseng": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/ginseng.png?v=1705478271",
      "Iron": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/iron_shadow.png?v=1745055820",
      "Magnesium": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/magnesium_shadow.png?v=1745055820",
      "Omega 3": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/omega3_shadow.png?v=1745055821",
      "Probiotics": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/probiotics_shadow.png?v=1745055820",
      "Vitamin B12": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminB12_shadow.png?v=1745055820",
      "Vitamin B2": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminB2_shadow.png?v=1745055820",
      "Vitamin B6": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminB6_shadow.png?v=1745055820",
      "Vitamin C": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminC_shadow.png?v=1745055820",
      "Vitamin D": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminD_shadow.png?v=1745055820",
      "Vitamin E": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminE_shadow.png?v=1745055820",
      "Zinc": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/zinc_shadow.png?v=1745055820",
  };

window.pills_shadow = pills_shadow;


 const pills_floating = {
            "Ashwagandha": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Ashwagandha_shadow-min.png?v=1757240346",
            "Biotin": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Biotin_shadow-min.png?v=1757240346",
            "Calcium": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Calcium_shadow-min.png?v=1757240345",
            "CoQ10": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/CoQ10_shadow-min.png?v=1757240346",
            "Folic Acid": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/FolicAcid_shadow-min.png?v=1757240346",
            "Iron": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Iron_shadow-min.png?v=1757240346",
            "Magnesium": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Magnesium_shadow-min.png?v=1757240346",
            "Omega 3": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Omega3_shadow-min.png?v=1757240346",
            "Probiotics": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Probiotics_shadow-min.png?v=1757240347",
            "Vitamin B12": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminB12_shadow-min.png?v=1757240346",
            "Vitamin B2": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminB2_shadow-min.png?v=1757240346",
            "Vitamin B6": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminB6_shadow-min.png?v=1757240346",
            "Vitamin C": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminC_shadow-min.png?v=1757240346",
            "Vitamin D": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminD_shadow-min.png?v=1757240346",
            "Vitamin E": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminE_shadow-min.png?v=1757240345",
            "Zinc": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Zinc_shadow-min.png?v=1757240346",
        };

window.pills_floating = pills_floating;

       const categories = {
    "Mental Health": {
        "Disease Specific": {
            "ADHD": {},
            "Bipolar Disorder": {},
            "Schizophrenia": {},
            "OCD": {}
        },
        "Anxiety": {},
        "Mood Improvement": {},
        "Depression": {},
        "Stress": {}
    },
    "Cognitive Performance": {
        "Memory": {},
        "Reaction Time": {},
        "Focus": {},
        "Fatigue": {}
    },
    "Organ Health": {
        "Eye Health": {},
        "Brain Health": {},
        "Heart & Circulation": {},
        "Blood Health": {},
        "Kidney Health": {},
        "Respiratory Health": {},
        "Ear Health": {},
        "Gut Health": {},
        "Liver Health": {},
        "Oral Health": {}
    },
    "Longevity": {
        "Energy": {},
        "Disease Management": {
            "Neurodegenerative": {},
            "Diabetes": {},
            "Autoimmune Diseases": {},
            "Cancer": {}
        },
        "Weight Management": {},
        "Disease Prevention": {
            "Diabetes": {},
            "Cancer": {}
        },
        "DNA Health": {}
    },
    "Sleep": {
        "Sleep Quality": {},
        "Falling Asleep": {},
        "Staying Asleep": {}
    },
    "Fitness": {
        "Endurance": {},
        "Fat Loss": {},
        "Recovery": {},
        "Strength & Power": {},
        "Muscle Mass": {},
        "Body Fat": {}
    },
    "Hormones & Reproduction": {
        "Men": {
            "Testosterone": {},
            "Sperm Health": {},
            "Peyronie's Disease": {},
            "Reproduction": {}
        },
        "Women": {
            "Reproduction": {},
            "Sexual Health": {},
            "Menstrual Health": {},
            "Pregnancy Health": {},
            "Reproductive Health": {}
        },
        "General Hormone Health": {}
    },
    "Immunity": {
        "Immune Strengthening": {},
        "Infection Management": {}
    },
    "Musculoskeletal Health": {
        "Bones": {},
        "Fibromyalgia": {},
        "Joints": {},
        "Muscle Tissue": {}
    },
    "Skin & Beauty": {
        "Skin Health": {},
        "Hair": {},
        "Nails": {}
    }
}

const new_categories = {
    "Performance" : {
        "Fitness": {
            "Endurance": {},
            "Fat Loss": {},
            "Recovery": {},
            "Strength & Power": {},
            "Muscle Mass": {},
            "Body Fat": {}
        },
        "Cognitive Performance": {
            "Memory": {},
            "Reaction Time": {},
            "Focus": {},
            "Fatigue": {}
        },
        "Sleep": {
            "Sleep Quality": {},
            "Falling Asleep": {},
            "Staying Asleep": {}
        },
    },

    "Wellness" : {
        "Mental Health": {
            "Disease Specific": {
                "ADHD": {},
                "Bipolar Disorder": {},
                "Schizophrenia": {},
                "OCD": {}
            },
            "Anxiety": {},
            "Mood Improvement": {},
            "Depression": {},
            "Stress": {}
        },
        "Hormones & Reproduction": {
            "Men": {
                "Testosterone": {},
                "Sperm Health": {},
                "Peyronie's Disease": {},
                "Reproduction": {}
            },
            "Women": {
                "Reproduction": {},
                "Sexual Health": {},
                "Menstrual Health": {},
                "Menopause": {},
                "Pregnancy Health": {},
                "Reproductive Health": {}
            },
            "General Hormone Health": {}
        },
        "Skin & Beauty": {
            "Skin Health": {},
            "Hair": {},
            "Nails": {}
        }
    },
    
    "Longevity" : {
        "Longevity": {
            "Energy": {},
            "Disease Management": {
                "Neurodegenerative": {},
                "Diabetes": {},
                "Autoimmune Diseases": {},
                "Cancer": {}
            },
            "Weight Management": {},
            "Disease Prevention": {
                "Diabetes": {},
                "Cancer": {}
            },
            "DNA Health": {}
        },
        "Immunity": {
            "Immune Strengthening": {},
            "Infection Management": {}
        },
        "Organ Health": {
            "Eye Health": {},
            "Brain Health": {},
            "Heart & Circulation": {},
            "Blood Health": {},
            "Kidney Health": {},
            "Respiratory Health": {},
            "Ear Health": {},
            "Gut Health": {},
            "Liver Health": {},
            "Oral Health": {}
        },
        "Musculoskeletal Health": {
            "Bones": {},
            "Fibromyalgia": {},
            "Joints": {},
            "Muscle Tissue": {}
        }

    }
}







const dietaryRestrictions = {
    "vegetarian": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vegetarian.png?v=1712042160",
    "vegan": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vegan.png?v=1712042160",
    "halal": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/halal.png?v=1712042160",
    "kosher": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/kosher.png?v=1712042160"
}; 

const certifications = {
    "gmp": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/gmp_certified_1.png?v=1780191515",
    "non-gmo": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/gmo_free_1.png?v=1780191515",
    "itested": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/itested.png?v=1712042753",
    "usp": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/usp_official.webp?v=1776815002",
    "ul": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/ul-certified-logo.png?v=1712042807",
    'nsf': "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/nsf-international-product-certification.png?v=1776148880"
}

const supplementCertifications = {
  "Acetyl L-Carnitine": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: [],
    allergens: []
  },
  "Alpha GPC": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: [],
    allergens: []
  },
  "Apigenin": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: [],
    allergens: []
  },
  "Ashwagandha": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: ["vegetarian", "vegan", "halal", "kosher"],
    allergens: ["gluten", "dairy", "egg", "fish", "nuts", "shellfish", "soy"]
  },
  "Berberine": {
    third_parties: ["non-gmo", "gmp"],
    dietary_restriction: [],
    allergens: []
  },
  "Biotin": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: ["vegan", "vegetarian", "sugar"],
    allergens: ["gluten", "preservatives", "artificial colors", "artificial flavors", "dairy", "egg", "nuts", "shellfish", "soy"]
  },
  "Calcium": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: [],
    allergens: ["gluten", "dairy", "egg", "fish", "nuts", "shellfish", "soy"]
  },
  "CoQ10": {
    third_parties: ["gmp", "non-gmo", "usp"],
    dietary_restriction: ["vegetarian", "vegan", "halal", "kosher"],
    allergens: [
      "gluten", "soy", "milk", "eggs", "fish", "shellfish", "tree nuts", "peanuts", "wheat", "sesame",
      "dairy", "egg", "nuts"
    ]
  },
  "Curcumin": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: [],
    allergens: []
  },
  "Folic Acid": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: ["vegetarian", "vegan", "sugar", "yeast"],
    allergens: ["preservatives", "artificial flavors", "artificial colors", "dairy", "egg", "fish", "gluten", "nuts", "shellfish", "soy"]
  },
  "Inositol": {
    third_parties: ["non-gmo", "gmp"],
    dietary_restriction: [],
    allergens: []
  },
  "Iron": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: ["yeast"],
    allergens: ["gluten", "preservatives", "artificial flavors", "dairy", "egg", "fish", "nuts", "shellfish", "soy"]
  },
  "L-Theanine": {
    third_parties: ["non-gmo", "gmp"],
    dietary_restriction: [],
    allergens: []
  },
  "L-Tyrosine": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: [],
    allergens: []
  },
  "Magnesium": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: ["halal", "kosher"],
    allergens: ["gluten", "preservatives", "dairy", "egg", "fish", "nuts", "shellfish", "soy"]
  },
  "Omega 3": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: ["halal", "kesher"],
    allergens: ["dairy", "egg", "gluten", "nuts", "shellfish", "soy"]
  },
  "Probiotics": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: ["vegetarian", "vegan"],
    allergens: ["dairy", "egg", "fish", "gluten", "nuts", "shellfish", "soy"]
  },
  "Resveratrol": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: [],
    allergens: []
  },
  "Rhodiola Rosea": {
    third_parties: ["non-gmo", "gmp"],
    dietary_restriction: [],
    allergens: []
  },
  "Tongkat Ali": {
    third_parties: ["non-gmo", "gmp"],
    dietary_restriction: [],
    allergens: []
  },
  "Vitamin B12": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: ["vegetarian", "vegan", "halal", "kosher"],
    allergens: ["dairy", "egg", "fish", "gluten", "nuts", "shellfish", "soy"]
  },
  "Vitamin B2": {
    third_parties: ["gmp", "non-gmo", "ul"],
    dietary_restriction: ["vegetarian", "vegan", "halal", "kosher"],
    allergens: ["dairy", "egg", "fish", "gluten", "nuts", "shellfish", "soy"]
  },
  "Vitamin B6": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: ["vegetarian", "vegan"],
    allergens: ["dairy", "egg", "fish", "gluten", "nuts", "shellfish", "soy"]
  },
  "Vitamin C": {
    third_parties: ["gmp", "non-gmo", "usp"],
    dietary_restriction: ["vegetarian", "vegan"],
    allergens: ["dairy", "egg", "fish", "gluten", "nuts", "shellfish", "soy"]
  },
  "Vitamin D": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: [],
    allergens: ["dairy", "egg", "gluten", "nuts", "shellfish", "soy"]
  },
  "Vitamin E": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: [],
    allergens: ["dairy", "egg", "gluten", "nuts", "shellfish"]
  },
  "Zinc": {
    third_parties: ["gmp", "non-gmo"],
    dietary_restriction: ["vegetarian", "vegan"],
    allergens: ["dairy", "egg", "fish", "gluten", "nuts", "shellfish", "soy"]
  }
};


const supplementsTopTags = {
  "Ashwagandha":["non-gmo", "vegan", "gluten"],
  "Biotin":["non-gmo", "vegan", "gluten"],
  "Calcium":["non-gmo", "gmp", "gluten"],
  "CoQ10":["usp", "itested", "vegan"],
  "Folic Acid":["non-gmo", "vegan", "gluten"],
  "Iron":["gmp", "gluten", "preservatives"],
  "Magnesium":["non-gmo", "halal", "gluten"],
  "Omega 3":["itested", "non-gmo", "halal"],
  "Probiotics":["itested", "vegan", "gluten"],
  "Vitamin B12":["vegan", "kosher", "gmp"],
  "Vitamin B2":["gluten", "non-gmo", "vegan"],
  "Vitamin B6":["vegan", "vegetarian", "gmp"],
  "Vitamin C":["usp", "itested", "non-gmo"],
  "Vitamin D":["itested", "non-gmo", "gluten"],
  "Vitamin E":["non-gmo", "gmp", "gluten"],
  "Zinc":["non-gmo", "vegan", "gluten"],
  "The Sleep Protocol":["non-gmo", "gmp", "gluten"],
  "The Fitness Protocol":["non-gmo", "gmp", "gluten"]
};


const topTagsIcon = {
  "gluten": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/gluten-free_logo.png?v=1755236011",
  "gmp": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/gmp_logo.png?v=1755236010",
  "halal": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/halah_logo.png?v=1755236011",
  "itested": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/iTested_logo.png?v=1755236011",
  "kosher": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/kosher_logo.png?v=1755236011",
  "non-gmo": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/non-gmo_logo.png?v=1755236011",
  "preservatives": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/no_preservative_logo.png?v=1755236011",
  "usp": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/usp_logo.png?v=1755236011",
  "vegan": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vegan_logo.png?v=1755236010",
  "vegetarian": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vegetarian_logo.png?v=1755236011"
};
window.supplementsTopTags = supplementsTopTags;
window.topTagsIcon = topTagsIcon;
window.supplementCertifications = supplementCertifications;
window.certifications = certifications;


const allergensNames = {
                "dairy": 'Dairy Free',
                "egg": 'No Egg',
                "fish": 'No Fish',
                "gluten": 'Gluten Free',
                "nuts": 'No Nuts',
                "shellfish": "No Shellfish",
                "soy": "Soy Free"
            };

 const genderDict = {
            "Male": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/mars.png?v=1713332420",
            "Female": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/femenine.png?v=1713332428",
        };



const healthNeedImages = {
    "Anxiety": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/anxiety.png?v=1717128712",
    "Blood Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/blood_health.png?v=1717128711",
    "Bones": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/bones.png?v=1717128711",
    "Brain Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/brain_health.png?v=1717128711",
    "Cognitive Performance": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/cognitive_performance.png?v=1717128711",
    "Depression": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/depression.png?v=1717128711",
    "Disease Management": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/disease_management.png?v=1717128711",
    "Disease Prevention": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/disease_prevention.png?v=1717128711",
    "DNA Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/dna_health.png?v=1717128712",
    "Ear Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/ear_health.png?v=1717128712",
    "Endurance": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/endurance.png?v=1717128711",
    "Energy": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/energy.png?v=1717128711",
    "Eye Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/eye_health.png?v=1717128711",
    "Falling Asleep": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/falling_asleep.png?v=1717128711",
    "Fat Loss": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/fat_loss.png?v=1717128711",
    "Fatigue": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/fatigue.png?v=1717128711",
    "Fibromyalgia": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/fibromyalgia.png?v=1717128711",
    "Fitness": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/fitness.png?v=1717128711",
    "Focus": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/focus.png?v=1717128711",
    "General Hormone Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/general_hormone_health.png?v=1717128712",
    "Gut Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/gut_health.png?v=1717128711",
    "Hair": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/hair.png?v=1717128711",
    "Heart Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/heart_health.png?v=1717128711",
    "Heart & Circulation": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/heart_health.png?v=1717128711",
    "Hormones & Reproduction": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/hormones_reproduction.png?v=1717128711",
    "Immune Strengthening": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/immune_strengthening.png?v=1717128711",
    "Immunity": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/immunity.png?v=1717128712",
    "Infection Management": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/infection_management.png?v=1717128711",
    "Joints": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/joints.png?v=1717128712",
    "Kidney Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/kidney_health.png?v=1717128711",
    "Liver Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/liver_health.png?v=1717128711",
    "Longevity": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/longevity.png?v=1717128711",
    "Men": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/man.png?v=1717128711",
    "Memory": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/memory.png?v=1717128711",
    "Mental Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/mental_health.png?v=1717128711",
    "Mood Improvement": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/mood_improvement.png?v=1717128711",
    "Muscle Mass": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/muscle_mass.png?v=1717128711",
    "Muscle Tissue": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/muscle_tissue.png?v=1717128710",
    "Musculoskeletal Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/musculoskeletal_health.png?v=1717128711",
    "Nails": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/nails.png?v=1717128711",
    "Oral Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/oral_health.png?v=1717128711",
    "Organ Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/organ_health.png?v=1717128711",
    "Reaction Time": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/reaction_time.png?v=1717128711",
    "Recovery": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/recovry.png?v=1717128711",
    "Respiratory Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/respiratory_health.png?v=1717128711",
    "Skin & Beauty": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/skin_beauty.png?v=1717128711",
    "Skin Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/skin.png?v=1717128711",
    "Sleep Quality": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/sleep_quality.png?v=1717128711",
    "Sleep": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/sleep.png?v=1717128712",
    "Staying Asleep": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/staying_asleep.png?v=1717128712",
    "Strength & Power": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/strength.png?v=1717128712",
    "Stress": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/stress.png?v=1717128712",
    "Weight Management": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/weight_management.png?v=1717128711",
    "Women": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/woman.png?v=1717128711"
};



const healthNeedImagesCOLORED = {
    "Anxiety": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/anxiety-min.jpg?v=1758341060",
    "Blood Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/blood_health-min.jpg?v=1758341060",
    "Bones": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/bones-min.jpg?v=1758341060",
    "Brain Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/brain_health-min.jpg?v=1758341447",
    "Cognitive Performance": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/cognitive_performance-min.jpg?v=1758341060",
    "Depression": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/depression-min.jpg?v=1758341447",
    "Disease Management": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/disease_management-min.jpg?v=1758341447",
    "Disease Prevention": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/disease_prevention-min.jpg?v=1758341447",
    "DNA Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/dna_health-min.jpg?v=1758341447",
    "Ear Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/ear_health-min.jpg?v=1758341060",
    "Endurance": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/endurance-min.jpg?v=1758341060",
    "Energy": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/energy-min.jpg?v=1758341060",
    "Eye Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/eye_health-min.jpg?v=1758341060",
    "Falling Asleep": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/falling_asleep-min.jpg?v=1758341060",
    "Fat Loss": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/fat_loss-min.jpg?v=1758341060",
    "Fatigue": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/fatigue-min.jpg?v=1758341060",
    "Fibromyalgia": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Fibromyalgia-min.jpg?v=1758341447",
    "Fitness": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/fitness-min.jpg?v=1758341448",
    "Focus": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/focus-min.jpg?v=1758341447",
    "General Hormone Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/general_hormone_health-min.jpg?v=1758341448",
    "Gut Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/gut_health-min.jpg?v=1758341447",
    "Hair": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/hair-min.jpg?v=1758341448",
    "Heart Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/heart_health-min.jpg?v=1758341060",
    "Heart & Circulation": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/heart_circulation.jpg?v=1758341925",
    "Hormones & Reproduction": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/hormones_reproduction-min.jpg?v=1758341447",
    "Immune Strengthening": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/immune_strengthening-min.jpg?v=1758341060",
    "Immunity": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/immunity-min.jpg?v=1758341447",
    "Infection Management": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/infection_management-min.jpg?v=1758341060",
    "Joints": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/joints-min.jpg?v=1758341060",
    "Kidney Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/kidney_health-min.jpg?v=1758341447",
    "Liver Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/liver_health-min.jpg?v=1758341447",
    "Longevity": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/longeviety-min.jpg?v=1758341448",
    "Men": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/man-min.jpg?v=1758341060",
    "Memory": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/memory-min.jpg?v=1758341060",
    "Mental Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/mental_health-min.jpg?v=1758341447",
    "Mood Improvement": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/mood_improvement-min.jpg?v=1758341061",
    "Muscle Mass": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/muscle_mass-min.jpg?v=1758341447",
    "Muscle Tissue": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/muscle_tissue-min.jpg?v=1758341061",
    "Musculoskeletal Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Musculoskeletal_Health-min.jpg?v=1758341060",
    "Nails": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/nails-min.jpg?v=1758341447",
    "Oral Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/oral_health-min.jpg?v=1758341447",
    "Organ Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/organ_health-min.jpg?v=1758341447",
    "Reaction Time": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/reaction_time-min.jpg?v=1758341060",
    "Recovery": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/recovery-min.jpg?v=1758341313",
    "Respiratory Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/respiratory_health-min.jpg?v=1758341369",
    "Skin & Beauty": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/skin_beauty-min.jpg?v=1758341369",
    "Skin Health": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/skin-min.jpg?v=1758341369",
    "Sleep Quality": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/sleep_quality-min.jpg?v=1758341369",
    "Sleep": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/sleep-min.jpg?v=1758341313",
    "Staying Asleep": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/staying_alseep-min.jpg?v=1758341313",
    "Strength & Power": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/strength-min.jpg?v=1758341369",
    "Stress": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/stress-min.jpg?v=1758341369",
    "Weight Management": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/weight_management-min.jpg?v=1758341369",
    "Women": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/woman-min.jpg?v=1758341313"
};





const treeHealthNeed = {
    "Ashwagandha": {"focusAreas":{"Cognitive Performance":{"layer2":{"Reaction Time":{"layer3":{}}}},"Mental Health":{"layer2":{"Disease Specific":{"layer3":{"Bipolar Disorder":{},"OCD":{}}},"Mood Improvement":{"layer3":{}},"Depression":{"layer3":{}},"Anxiety":{"layer3":{}},"Stress":{"layer3":{}}}},"Fitness":{"layer2":{"Endurance":{"layer3":{}},"Strength & Power":{"layer3":{}},"Recovery":{"layer3":{}}}},"Longevity":{"layer2":{"Energy":{"layer3":{}},"Disease Management":{"layer3":{"Cancer":{},"Diabetes":{}}},"Disease Prevention":{"layer3":{}}}},"Hormones & Reproduction":{"layer2":{"Men":{"layer3":{"Testosterone":{},"Sperm Health":{}}},"Women":{"layer3":{"Sexual Health":{}}},"General Hormone Health":{"layer3":{"Cortisol":{}}}}},"Immunity":{"layer2":{"Immune Strengthening":{"layer3":{}}}},"Musculoskeletal Health":{"layer2":{"Joints":{"layer3":{}}}},"Sleep":{"layer2":{"Sleep Quality":{"layer3":{}},"Falling Asleep":{"layer3":{}}}}}},
    "Biotin": {"focusAreas":{"Longevity":{"layer2":{"Disease Management":{"layer3":{"Diabetes":{}}}}},"Organ Health":{"layer2":{"Heart & Circulation":{"layer3":{}}}},"Skin & Beauty":{"layer2":{"Nails":{"layer3":{}}}}}},
    "Calcium": {"focusAreas":{"Hormones & Reproduction":{"layer2":{"Women":{"layer3":{"Menstrual Health":{},"Pregnancy Health":{}}}}},"Organ Health":{"layer2":{"Gut Health":{"layer3":{}},"Heart & Circulation":{"layer3":{}}}},"Musculoskeletal Health":{"layer2":{"Bones":{"layer3":{}}}}}},
    "CoQ10": {"focusAreas":{"Organ Health":{"layer2":{"Eye Health":{"layer3":{}},"Heart & Circulation":{"layer3":{}},"Brain Health":{"layer3":{"Migraines":{}}}}},"Fitness":{"layer2":{"Endurance":{"layer3":{}},"Recovery":{"layer3":{}}}},"Longevity":{"layer2":{"Energy":{"layer3":{}},"Disease Prevention":{"layer3":{}},"Disease Management":{"layer3":{"Diabetes":{},"Neurodegenerative":{}}}}},"Hormones & Reproduction":{"layer2":{"Men":{"layer3":{"Sperm Health":{},"Peyronie's Disease":{},"Reproduction":{}}},"Women":{"layer3":{"Pregnancy Health":{},"Reproductive Health":{}}}}},"Musculoskeletal Health":{"layer2":{"Fibromyalgia":{"layer3":{}}}},"Mental Health":{"layer2":{"Mood Improvement":{"layer3":{}},"Depression":{"layer3":{}},"Disease Specific":{"layer3":{"Bipolar Disorder":{}}}}},"Skin & Beauty":{"layer2":{"Skin Health":{"layer3":{"Wrinkles":{}}}}}}},
    "Folic Acid": {"focusAreas":{"Longevity":{"layer2":{"Disease Prevention":{"layer3":{"Diabetes":{}}}}},"Organ Health":{"layer2":{"Heart & Circulation":{"layer3":{}}}},"Mental Health":{"layer2":{"Depression":{"layer3":{}},"Disease Specific":{"layer3":{"Schizophrenia":{}}}}}}},
    "Iron": {"focusAreas":{"Longevity":{"layer2":{"Energy":{"layer3":{}}}},"Organ Health":{"layer2":{"Blood Health":{"layer3":{}},"Heart & Circulation":{"layer3":{}},"Brain Health":{"layer3":{}}}},"Cognitive Performance":{"layer2":{"Fatigue":{"layer3":{}},"Focus":{"layer3":{}},"Memory":{"layer3":{}}}},"Mental Health":{"layer2":{"Stress":{"layer3":{}}}},"Fitness":{"layer2":{"Endurance":{"layer3":{}}}},"Hormones & Reproduction":{"layer2":{"Women":{"layer3":{"Pregnancy Health":{},"Menstrual Health":{}}}}},"Musculoskeletal Health":{"layer2":{"Fibromyalgia":{"layer3":{}}}}}},
    "Magnesium": {"focusAreas":{"Organ Health":{"layer2":{"Brain Health":{"layer3":{"Migraines":{}}},"Heart & Circulation":{"layer3":{}},"Blood Health":{"layer3":{}},"Kidney Health":{"layer3":{}},"Respiratory Health":{"layer3":{}},"Ear Health":{"layer3":{}}}},"Fitness":{"layer2":{"Strength & Power":{"layer3":{}},"Recovery":{"layer3":{}},"Endurance":{"layer3":{}}}},"Longevity":{"layer2":{"Disease Prevention":{"layer3":{"Diabetes":{}}},"Energy":{"layer3":{}},"Disease Management":{"layer3":{"Diabetes":{}}},"Weight Management":{"layer3":{}}}},"Hormones & Reproduction":{"layer2":{"Women":{"layer3":{"Reproductive Health":{},"Menstrual Health":{}}}}},"Sleep":{"layer2":{"Sleep Quality":{"layer3":{}},"Falling Asleep":{"layer3":{}}}},"Musculoskeletal Health":{"layer2":{"Bones":{"layer3":{}},"Fibromyalgia":{"layer3":{}}}},"Mental Health":{"layer2":{"Anxiety":{"layer3":{}},"Depression":{"layer3":{}},"Stress":{"layer3":{}}}}}},
    "Omega 3": {"focusAreas":{"Mental Health":{"layer2":{"Disease Specific":{"layer3":{"ADHD":{},"Bipolar Disorder":{},"Schizophrenia":{}}},"Anxiety":{"layer3":{}},"Mood Improvement":{"layer3":{}},"Depression":{"layer3":{}},"Stress":{"layer3":{}}}},"Cognitive Performance":{"layer2":{"Memory":{"layer3":{}},"Reaction Time":{"layer3":{}},"Focus":{"layer3":{}}}},"Longevity":{"layer2":{"Energy":{"layer3":{}},"Weight Management":{"layer3":{}},"Disease Prevention":{"layer3":{"Diabetes":{}}},"Disease Management":{"layer3":{"Diabetes":{},"Autoimmune Diseases":{},"Cancer":{}}}}},"Organ Health":{"layer2":{"Brain Health":{"layer3":{"Migraines":{}}},"Blood Health":{"layer3":{}},"Heart & Circulation":{"layer3":{}},"Respiratory Health":{"layer3":{}},"Kidney Health":{"layer3":{}},"Eye Health":{"layer3":{}}}},"Fitness":{"layer2":{"Fat Loss":{"layer3":{}},"Endurance":{"layer3":{}},"Recovery":{"layer3":{}},"Body Fat":{"layer3":{}}}},"Immunity":{"layer2":{"Immune Strengthening":{"layer3":{}}}},"Hormones & Reproduction":{"layer2":{"Women":{"layer3":{"Pregnancy Health":{},"Reproductive Health":{},"Menstrual Health":{}}}}},"Sleep":{"layer2":{"Falling Asleep":{"layer3":{}},"Sleep Quality":{"layer3":{}}}},"Skin & Beauty":{"layer2":{"Skin Health":{"layer3":{}}}}}},
    "Probiotics": {"focusAreas":{"Organ Health":{"layer2":{"Gut Health":{"layer3":{}}}}}},
    "Vitamin B12": {"focusAreas":{"Organ Health":{"layer2":{"Heart & Circulation":{"layer3":{}}}}}},
    "Vitamin B2": {"focusAreas":{"Organ Health":{"layer2":{"Heart & Circulation":{"layer3":{}},"Brain Health":{"layer3":{"Migraines":{}}}}}}},
    "Vitamin B6": {"focusAreas":{"Sleep":{"layer2":{"Sleep Quality":{"layer3":{}}}},"Fitness":{"layer2":{"Recovery":{"layer3":{}},"Endurance":{"layer3":{}}}},"Hormones & Reproduction":{"layer2":{"Women":{"layer3":{"Reproduction":{},"Menstrual Health":{}}}}}}},
    "Vitamin C": {"focusAreas":{"Fitness":{"layer2":{"Recovery":{"layer3":{}},"Endurance":{"layer3":{}}}},"Longevity":{"layer2":{"Disease Prevention":{"layer3":{}},"Disease Management":{"layer3":{"Diabetes":{}}},"Weight Management":{"layer3":{}},"DNA Health":{"layer3":{}}}},"Cognitive Performance":{"layer2":{"Fatigue":{"layer3":{}}}},"Hormones & Reproduction":{"layer2":{"Men":{"layer3":{"Sperm Health":{}}},"Women":{"layer3":{"Sexual Health":{},"Reproductive Health":{}}},"General Hormone Health":{"layer3":{"Cortisol":{}}}}},"Mental Health":{"layer2":{"Depression":{"layer3":{}}}},"Organ Health":{"layer2":{"Heart & Circulation":{"layer3":{}},"Respiratory Health":{"layer3":{}},"Blood Health":{"layer3":{}}}},"Immunity":{"layer2":{"Infection Management":{"layer3":{"Common Cold":{}}},"Immune Strengthening":{"layer3":{}}}},"Musculoskeletal Health":{"layer2":{"Bones":{"layer3":{}}}}}},
    "Vitamin D": {"focusAreas":{"Longevity":{"layer2":{"Disease Management":{"layer3":{"Neurodegenerative":{},"Cancer":{},"Diabetes":{}}},"Weight Management":{"layer3":{}},"Disease Prevention":{"layer3":{"Diabetes":{},"Cancer":{}}}}},"Fitness":{"layer2":{"Fat Loss":{"layer3":{}},"Strength & Power":{"layer3":{}},"Recovery":{"layer3":{}},"Muscle Mass":{"layer3":{}}}},"Hormones & Reproduction":{"layer2":{"Men":{"layer3":{"Testosterone":{}}},"Women":{"layer3":{"Menstrual Health":{},"Pregnancy Health":{}}}}},"Immunity":{"layer2":{"Immune Strengthening":{"layer3":{}},"Infection Management":{"layer3":{"COVID-19":{},"Respiratory Infections":{}}}}},"Organ Health":{"layer2":{"Ear Health":{"layer3":{}},"Heart & Circulation":{"layer3":{}},"Respiratory Health":{"layer3":{}}}},"Musculoskeletal Health":{"layer2":{"Fibromyalgia":{"layer3":{}},"Muscle Tissue":{"layer3":{}},"Bones":{"layer3":{}}}},"Mental Health":{"layer2":{"Depression":{"layer3":{}}}},"Sleep":{"layer2":{"Sleep Quality":{"layer3":{}},"Staying Asleep":{"layer3":{}}}}}},
    "Vitamin E": {"focusAreas":{"Longevity":{"layer2":{"Disease Management":{"layer3":{"Neurodegenerative":{},"Diabetes":{}}},"Disease Prevention":{"layer3":{}}}},"Hormones & Reproduction":{"layer2":{"Women":{"layer3":{"Menstrual Health":{}}}}},"Organ Health":{"layer2":{"Kidney Health":{"layer3":{}},"Heart & Circulation":{"layer3":{}},"Liver Health":{"layer3":{}},"Gut Health":{"layer3":{}}}},"Immunity":{"layer2":{"Immune Strengthening":{"layer3":{}}}},"Skin & Beauty":{"layer2":{"Hair":{"layer3":{}}}}}},
    "Zinc": {"focusAreas":{"Organ Health":{"layer2":{"Heart & Circulation":{"layer3":{}},"Blood Health":{"layer3":{}},"Kidney Health":{"layer3":{}},"Liver Health":{"layer3":{}},"Oral Health":{"layer3":{}},"Ear Health":{"layer3":{}}}},"Cognitive Performance":{"layer2":{"Focus":{"layer3":{}},"Reaction Time":{"layer3":{}},"Memory":{"layer3":{}}}},"Fitness":{"layer2":{"Endurance":{"layer3":{}},"Strength & Power":{"layer3":{}},"Recovery":{"layer3":{}}}},"Hormones & Reproduction":{"layer2":{"Men":{"layer3":{"Testosterone":{},"Sperm Health":{}}},"Women":{"layer3":{"Menstrual Health":{}}},"General Hormone Health":{"layer3":{"Leptin":{}}}}},"Longevity":{"layer2":{"Disease Prevention":{"layer3":{}},"Weight Management":{"layer3":{}},"Disease Management":{"layer3":{"Diabetes":{}}}}},"Immunity":{"layer2":{"Infection Management":{"layer3":{"Common Cold":{}}},"Immune Strengthening":{"layer3":{}}}},"Skin & Beauty":{"layer2":{"Skin Health":{"layer3":{"Acne":{}}}}},"Mental Health":{"layer2":{"Depression":{"layer3":{}},"Disease Specific":{"layer3":{"OCD":{}}}}}}}
}


const explanationParagraph = {
    "Ashwagandha": {
      "focusAreas": {
        "Cognitive Performance": {
          "Summary Papers": "Ashwagandha significantly enhances cognitive performance by improving reaction times in cognitive and psychomotor tasks, indicating its potential as a natural supplement to boost mental alertness and responsiveness.",
          "layer2": {
            "Reaction Time": {
              "Summary Papers": "Ashwagandha has been shown to significantly enhance reaction time, making it a valuable supplement for improving the speed and efficiency of cognitive and psychomotor responses.",
              "layer3": {}
            }
          }
        },
        "Mental Health": {
          "Summary Papers": "Ashwagandha has been shown to significantly reduce stress, anxiety, and symptoms of certain mental health conditions by regulating the body's stress response and improving sleep quality, making it a beneficial natural supplement for enhancing mental well-being.",
          "layer2": {
            "Disease Specific": {
              "Summary Papers": "Ashwagandha has shown notable benefits for mental health, specifically by enhancing working memory in individuals with bipolar disorder (helping with tasks like listening and remembering) and reducing the intensity of compulsions and anxieties in those with OCD (Obsessive-Compulsive Disorder), making daily routines less stressful.",
              "layer3": {
                "Bipolar Disorder": {
                  "Summary Papers": "Ashwagandha has been found to significantly enhance cognitive functions, such as auditory-verbal working memory, in individuals with bipolar disorder. This improvement highlight its potential as a supportive treatment in managing cognitive aspects of mental health conditions."
                },
                "OCD": {
                  "Summary Papers": "Ashwagandha extract has shown effectiveness in significantly reducing symptoms of Obsessive-Compulsive Disorder (OCD), such as repetitive thoughts and behaviors, providing a promising natural approach to managing this challenging condition."
                }
              }
            },
            "Mood Improvement": {
              "Summary Papers": "\nAshwagandha significantly improves mood by reducing stress and enhancing overall quality of life, making it an effective supplement for those seeking to increase happiness and manage stress-related cravings.",
              "layer3": {}
            },
            "Depression": {
              "Summary Papers": "Ashwagandha has a significant impact on depression by improving overall quality of life and reducing symptoms of both anxiety and depression, showing its potential as a natural remedy for improving mental well-being. ",
              "layer3": {}
            },
            "Anxiety": {
              "Summary Papers": "Ashwagandha notably reduces feelings of anxiety, with studies reporting a decrease of around 30% to over 50% in anxiety symptoms. Additionally, it lowers stress hormone levels in the body by nearly 28%, indicating its effectiveness in calming the mind and body.",
              "layer3": {}
            },
            "Stress": {
              "Summary Papers": "Ashwagandha demonstrates a significant impact on reducing stress levels, as evidenced by multiple studies showing notable decreases in stress and anxiety symptoms, along with reductions in stress-related hormones like cortisol, highlighting its effectiveness in promoting stress relief and overall well-being.",
              "layer3": {}
            }
          }
        },
        "Fitness": {
          "Summary Papers": "Ashwagandha enhances muscle strength and cardiorespiratory endurance by optimizing the body's natural stress response and improving energy production, ideal for both elite and recreational athletes seeking to improve fitness outcomes.\n\n",
          "layer2": {
            "Endurance": {
              "Summary Papers": "Ashwagandha significantly enhances endurance by improving cardiorespiratory performance, as demonstrated by increases in VO2 max (the maximum amount of oxygen a person can utilize during intense exercise) and prolonged time to exhaustion in athletes, highlighting its effectiveness in boosting physical stamina and performance.",
              "layer3": {}
            },
            "Strength & Power": {
              "Summary Papers": "Ashwagandha has been shown to boost strength and power, with studies reporting significant increases in muscle strength among people taking it — whether or not they exercise.",
              "layer3": {}
            },
            "Recovery": {
              "Summary Papers": "Ashwagandha notably enhanced perceived recovery scores in participants, indicating its efficacy in facilitating quicker recovery from physical activity and advancing overall fitness development.",
              "layer3": {}
            }
          }
        },
        "Longevity": {
          "Summary Papers": "\nAshwagandha aids in longevity by enhancing immune function (e.g. better defense against illnesses), regulating thyroid health (important for energy and mood), and supporting metabolic processes (helps control blood sugar and cholesterol), collectively helping the body manage various health challenges efficiently.",
          "layer2": {
            "Energy": {
              "Summary Papers": "Ashwagandha has a notable impact on energy, as showed by significant improvements in overall quality of life and overall energy levels among individuals supplementing with it regularly.",
              "layer3": {}
            },
            "Disease Management": {
              "Summary Papers": "Ashwagandha helps manage diseases by improving thyroid hormone levels, which regulate metabolism, mood and energy. It also reduces fatigue and improves cholesterol and blood sugar levels in individuals with Type II diabetes, promoting better long-term health.",
              "layer3": {
                "Cancer": {
                  "Summary Papers": "Ashwagandha root has been found to significantly enhance the well-being of breast cancer patients by improving general function and reducing fatigue during chemotherapy. This indicates its potential as a supportive natural treatment in cancer care, aiding patients in managing the side effects of rigorous cancer treatments."
                },
                "Diabetes": {
                  "Summary Papers": "Ashwagandha has shown promising lipid-lowering and anti-glycemic effects in individuals with Type II diabetes, indicating its potential in managing blood sugar and cholesterol levels. This suggests its role as a supportive natural treatment in the management of diabetes and its associated conditions."
                }
              }
            },
            "Disease Prevention": {
              "Summary Papers": "Ashwagandha significantly boosts the body's defense mechanisms by enhancing the activation of T-cells and NK cells, crucial for identifying and eliminating harmful invaders like infections and cancer cells. This strengthens the body's ability to prevent various diseases, contributing to longer and healthier living.",
              "layer3": {}
            }
          }
        },
        "Hormones & Reproduction": {
          "Summary Papers": "Ashwagandha has been shown to positively impact hormones and reproduction by increasing testosterone levels and improving sperm quality in men, and enhancing sexual function in women, alongside reducing stress hormones that can affect fertility and mood.",
          "layer2": {
            "Men": {
              "Summary Papers": "Ashwagandha contributes to male hormonal balance and reproductive health by modestly increasing testosterone and significantly enhancing sperm parameters, underlining its importance in male fertility and hormonal regulation.",
              "layer3": {
                "Testosterone": {
                  "Summary Papers": "Ashwagandha is known to moderately increase testosterone levels in men, a vital hormone for reproductive functionality, muscle development, and general health. This boost not only aids in enhancing sperm quality, leading to better reproductive outcomes, but also plays a significant role in improving various facets of male health."
                },
                "Sperm Health": {
                  "Summary Papers": "Ashwagandha has proven effective in significantly improving sperm health, including concentration, volume, and motility, in men facing infertility challenges. This highlights its role as a beneficial natural supplement for enhancing male reproductive health and fertility."
                }
              }
            },
            "Women": {
              "Summary Papers": "Ashwagandha has shown a significant positive effect on enhancing sexual function in women, indicating its potential in supporting hormonal balance and reproductive health. This highlights its role in improving aspects of women's sexual health.",
              "layer3": {
                "Sexual Health": {
                  "Summary Papers": "Ashwagandha root extract has been shown to significantly enhance sexual function in women, improving aspects like arousal, lubrication, orgasm, and overall satisfaction. This underscores its potential as a natural and effective supplement for boosting women's sexual health"
                }
              }
            },
            "General Hormone Health": {
              "Summary Papers": "Ashwagandha effectively lowers cortisol, the body's primary stress hormone, contributing to a marked reduction in stress and anxiety. This regulation of cortisol levels underscores its vital role in maintaining hormonal balance.",
              "layer3": {
                "Cortisol": {
                  "Summary Papers": "Ashwagandha effectively lowers cortisol, the body's primary stress hormone, contributing to a marked reduction in stress and anxiety. This regulation of cortisol levels underscores its vital role in maintaining hormonal balance."
                }
              }
            }
          }
        },
        "Immunity": {
          "Summary Papers": "\nAshwagandha boosts immunity by activating T-cells and NK cells (key defenders against infections and abnormal cells), enhancing the body's ability to fight off diseases and protect against health threats.",
          "layer2": {
            "Immune Strengthening": {
              "Summary Papers": "Ashwagandha enhances the body's immune defense by boosting T-cell and NK cell activity, key players in fighting off infections and abnormal cells. This action strengthens the immune system's ability to protect against a variety of health threats.",
              "layer3": {}
            }
          }
        },
        "Musculoskeletal Health": {
          "Summary Papers": "Ashwagandha supports musculoskeletal health by significantly reducing joint pain and enhancing joint function.",
          "layer2": {
            "Joints": {
              "Summary Papers": "Ashwagandha has been shown to effectively reduce knee joint pain and enhance joint function, demonstrating its significant role in promoting musculoskeletal health and mobility. This benefit is particularly notable in providing relief and improving the quality of life for those experiencing joint discomfort.",
              "layer3": {}
            }
          }
        },
        "Sleep": {
          "Summary Papers": "Ashwagandha has been shown to shorten sleep onset latency and improve overall sleep quality, providing a natural, evidence-based approach for individuals experiencing insomnia.",
          "layer2": {
            "Sleep Quality": {
              "Summary Papers": "Ashwagandha root extract significantly improves sleep by enhancing the overall quality of sleep. It achieves this by naturally reducing anxiety levels, which is often a key barrier to restful sleep. This makes ashwagandha a natural alternative without the side effects of traditional sleep medications.",
              "layer3": {}
            },
            "Falling Asleep": {
              "Summary Papers": "Ashwagandha root extract effectively reduces the time it takes to fall asleep. It reduces anxiety, a common obstacle to initiating sleep, making it a valuable help for improving the onset of sleep and overall sleep quality.",
              "layer3": {}
            }
          }
        }
      }
    },
    "Biotin": {
      "focusAreas": {
        "Longevity": {
          "Summary Papers": "Biotin supplementation has been shown to effectively reduce harmful fats in the blood, like triglycerides, which is crucial for preventing heart-related conditions and supporting overall longevity. This highlights its role in enhancing cardiovascular health and promoting a longer, healthier life.",
          "layer2": {
            "Disease Management": {
              "Summary Papers": "Biotin supplementation has shown to effectively lower levels of harmful blood fats, such as triglycerides, aiding in the management of conditions like type II diabetes. This supports its role in promoting disease prevention and contributing to enhanced longevity.",
              "layer3": {
                "Diabetes": {
                  "Summary Papers": "Biotin supplementation has demonstrated a significant capacity to lower triglycerides and VLDL levels, crucial factors in managing and potentially improving the health outcomes for individuals with diabetes. This points to its role in supporting diabetes management."
                }
              }
            }
          }
        },
        "Organ Health": {
          "Summary Papers": "Biotin supplementation significantly reduces detrimental blood fats like triglycerides, playing a key role in maintaining organ health by preventing fat accumulation in organs. This action highlights biotin's effectiveness in protecting against health issues that could impair organ performance.",
          "layer2": {
            "Heart & Circulation": {
              "Summary Papers": "Research suggests that biotin supplementation may help lower triglycerides and very-low-density lipoprotein (VLDL), both of which can affect heart health and circulation. These potential effects highlight biotin’s role in supporting cardiovascular function and promoting healthier blood flow.",
              "layer3": {}
            }
          }
        },
        "Skin & Beauty": {
          "Summary Papers": "Research suggests that biotin supplementation may help strengthen nails and reduce brittleness, promoting healthier, more resilient nails — a simple boost with visible results.",
          "layer2": {
            "Nails": {
              "Summary Papers": "Biotin supplementation has been shown to significantly improve nail health, restoring thickness and reducing brittleness in individuals with weak nails. This highlights its beneficial impact on enhancing nail strength and appearance.",
              "layer3": {}
            }
          }
        }
      }
    },
    "Calcium": {
      "focusAreas": {
        "Hormones & Reproduction": {
          "Summary Papers": "Research suggests that calcium supplementation may help ease PMS symptoms and lower the risk of hypertension and pre-eclampsia during pregnancy, underscoring its important role in supporting hormonal balance and reproductive health.",
          "layer2": {
            "Women": {
              "Summary Papers": "Calcium supplementation in women has shown significant benefits in reducing premenstrual syndrome (PMS) symptoms and decreasing the risk of hypertension and pre-eclampsia during pregnancy. These outcomes highlight calcium's essential role in supporting women's hormonal balance and reproductive health.",
              "layer3": {
                "Menstrual Health": {
                  "Summary Papers": "Calcium supplementation has shown significant benefits in alleviating premenstrual syndrome (PMS) symptoms, including mood swings, pain, and water retention, enhancing menstrual health in women. This highlights its key role in improving women's hormonal balance and overall well-being during the menstrual cycle."
                },
                "Pregnancy Health": {
                  "Summary Papers": "Calcium supplementation in pregnant women has been linked to a lower risk of developing hypertension and pre-eclampsia, and in some cases, has contributed to a reduction in the severity of these conditions and neonatal mortality. This emphasizes calcium's crucial role in promoting healthier pregnancy outcomes and safeguarding maternal and fetal health."
                }
              }
            }
          }
        },
        "Organ Health": {
          "Summary Papers": "Research suggests that calcium supplementation may help lower fecal bile acids and lipids, which could support digestive health by reducing fat absorption and aiding in cholesterol management — benefits that may also extend to liver function and cardiovascular wellness.",
          "layer2": {
            "Gut Health": {
              "Summary Papers": "Calcium supplementation has been linked to improved gut health by reducing the absorption of fats and cholesterol, which supports better digestion and potentially lowers the risk of high cholesterol. This effect underscores the role of calcium in promoting a healthier digestive system.",
              "layer3": {}
            },
            "Heart & Circulation": {
              "Summary Papers": "Calcium intake has shown a beneficial impact on heart and circulation health by reducing the absorption of cholesterol, leading to lower levels of harmful fats in the body. This suggests calcium's significant role in enhancing cardiovascular function and reducing the risk of cholesterol-related conditions.",
              "layer3": {}
            }
          }
        },
        "Musculoskeletal Health": {
          "Summary Papers": "Calcium supplementation significantly boosts bone mineral density and content, underlining its crucial role in keeping bones strong and preventing musculoskeletal problems. This points to the importance of calcium in enhancing musculoskeletal health.",
          "layer2": {
            "Bones": {
              "Summary Papers": "Calcium supplementation has been proven to significantly enhance bone mineral density and content, indicating its crucial role in strengthening bones. This reinforces the importance of calcium in promoting bone health and preventing future bone-related issues.",
              "layer3": {}
            }
          }
        }
      }
    },
    "CoQ10": {
      "focusAreas": {
        "Organ Health": {
          "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has been linked to significant improvements in heart function, blood vessel health, and a reduction in inflammation and oxidative stress. These benefits, observed across various conditions indicates its vital role in supporting organ health.",
          "layer2": {
            "Eye Health": {
              "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has demonstrated a significant improvement in color discrimination accuracy, indicating its beneficial impact on enhancing visual functions. This underscores CoQ10's potential role in supporting overall eye health and visual acuity.",
              "layer3": {}
            },
            "Heart & Circulation": {
              "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has demonstrated significant improvements in heart function, blood vessel health, and exercise endurance, highlighting its key role in enhancing cardiovascular health. These benefits are attributed to CoQ10's ability to reduce oxidative stress and inflammation, crucial for maintaining heart and circulatory system wellness.",
              "layer3": {}
            },
            "Brain Health": {
              "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has shown to significantly reduce the frequency, severity, and duration of migraines, indicating its powerful impact on brain health by improving neurological function and reducing inflammation.",
              "layer3": {
                "Migraines": {
                  "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has been linked to a significant reduction in the frequency, severity, and duration of migraines, suggesting its potential in mitigating this brain health issue. This effect likely stems from CoQ10's ability to improve mitochondrial function and reduce oxidative stress, offering a promising approach for those seeking relief from migraines."
                }
              }
            }
          }
        },
        "Fitness": {
          "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has been shown to enhance exercise endurance and recovery, with users experiencing less fatigue and improved antioxidant defense during physical activity. These effects underscore CoQ10's role in boosting overall fitness and reducing the risk of exercise-induced muscular damage.",
          "layer2": {
            "Endurance": {
              "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has been linked to significant enhancements in exercise endurance, including increased VO2 max and reduced fatigue during physical activity. This indicates CoQ10's role in boosting energy production and efficiency, allowing for longer and more intense exercise sessions without early onset of exhaustion.",
              "layer3": {}
            },
            "Recovery": {
              "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has shown to significantly improve recovery by reducing exercise-induced muscular damage and inflammation, and enhancing antioxidant defense. This underscores CoQ10's effectiveness in supporting quicker recovery and lowering the risk of injury following physical activity.",
              "layer3": {}
            }
          }
        },
        "Longevity": {
          "Summary Papers": "Research suggests that Coenzyme Q10 (CoQ10) supplementation may help reduce oxidative stress, strengthen antioxidant defenses, and support cardiovascular and metabolic health — potential benefits that could contribute to a longer, healthier lifespan.",
          "layer2": {
            "Energy": {
              "Summary Papers": "Research suggests that Coenzyme Q10 (CoQ10) supplementation may help boost energy levels and reduce fatigue, enabling longer physical performance. These potential benefits reflect CoQ10’s role in supporting cellular energy production, enhancing endurance, and promoting overall vitality.",
              "layer3": {}
            },
            "Disease Prevention": {
              "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has been shown to enhance antioxidant defense and reduce oxidative stress, leading to improved cardiovascular health and a reduction in inflammation. These effects underscore CoQ10's significant role in disease prevention, contributing to a longer, healthier lifespan by protecting cells from damage and supporting overall organ function.",
              "layer3": {}
            },
            "Disease Management": {
              "Summary Papers": "Coenzyme Q10 (CoQ10) is essential for preventing diseases by boosting antioxidant defenses and reducing oxidative stress. This supports heart health, reduces inflammation, and promotes longevity by protecting cells from damage and ensuring vital organs work well.",
              "layer3": {
                "Diabetes": {
                  "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has shown to significantly benefit individuals with diabetes by reducing inflammation, improving cholesterol levels, enhancing insulin metabolism, and improving vascular health. These effects highlight CoQ10's role in managing diabetes-related complications and supporting overall metabolic health, contributing to better disease management and longevity."
                },
                "Neurodegenerative": {
                  "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has been effective in reducing inflammation, fatigue, and depression in patients with neurodegenerative conditions like multiple sclerosis. This underscores CoQ10's potential in managing symptoms and improving quality of life for individuals facing neurodegenerative diseases."
                }
              }
            }
          }
        },
        "Hormones & Reproduction": {
          "Summary Papers": "Research suggests that Coenzyme Q10 (CoQ10) supplementation may help improve sperm health and motility in men and reduce the risk of pre-eclampsia in pregnant women. These potential benefits are linked to CoQ10’s antioxidant properties, which protect cells from oxidative damage — an important factor in hormone balance and reproductive health.",
          "layer2": {
            "Men": {
              "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation have a significant impact on men's hormones and reproduction. It helps improve sperm health by reducing oxidative damage and enhancing antioxidant protection, leading to better fertility outcomes and improved erectile function.",
              "layer3": {
                "Sperm Health": {
                  "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has been linked to improved sperm health, including enhanced motility and increased sperm count, by reducing oxidative stress and improving antioxidant defense in seminal fluid. These effects underscore CoQ10's importance in supporting male fertility and sperm quality."
                },
                "Peyronie's Disease": {
                  "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has shown significant benefits in improving erection quality, reducing pain, and slowing the progression of Peyronie's Disease. This underscores CoQ10's potential as a therapeutic option for enhancing reproductive health and managing symptoms of this condition."
                },
                "Reproduction": {
                  "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has been linked to improved fertility rates in men, underscoring its importance in enhancing reproductive health and contributing to better fertility outcomes."
                }
              }
            },
            "Women": {
              "Summary Papers": "Coenzyme Q10 (CoQ10) demonstrates significant benefits for women's hormonal health and reproduction. It reduces the risk of pre-eclampsia during pregnancy and improves hormonal balance, potentially aiding conditions like PCOS and insulin resistance.",
              "layer3": {
                "Pregnancy Health": {
                  "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation in pregnant women has been shown to significantly reduce the risk of pre-eclampsia, indicating its beneficial impact on pregnancy health. This underscores CoQ10's potential in supporting maternal well-being and fetal development."
                },
                "Reproductive Health": {
                  "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has demonstrated significant benefits in enhancing hormonal balance and reducing insulin resistance in women with PCOS, highlighting its importance in improving reproductive health and fertility."
                }
              }
            }
          }
        },
        "Musculoskeletal Health": {
          "Summary Papers": "Research suggests that Coenzyme Q10 (CoQ10) supplementation may help ease symptoms of fibromyalgia — a chronic condition marked by widespread pain, fatigue, and localized tenderness. By supporting mitochondrial function and reducing inflammation, CoQ10 has the potential to improve quality of life and support overall musculoskeletal health.",
          "layer2": {
            "Fibromyalgia": {
              "Summary Papers": "Coenzyme Q10 (CoQ10) shows promise in managing fibromyalgia, a chronic condition causing widespread pain and fatigue. Its ability to reduce pain, fatigue, and associated symptoms offers hope for improved quality of life in fibromyalgia patients.",
              "layer3": {}
            }
          }
        },
        "Mental Health": {
          "Summary Papers": "Research suggests that Coenzyme Q10 (CoQ10) supplementation may help improve mood and overall quality of life, with studies noting reduced depression scores in people with bipolar disorder. These potential benefits are linked to CoQ10’s ability to support the body’s natural defenses against stress and inflammation, highlighting its role in promoting mental well-being.",
          "layer2": {
            "Mood Improvement": {
              "Summary Papers": "Coenzyme Q10 (CoQ10) shows promise in improving mood. While the exact mechanisms are not fully understood, its ability to enhance mood suggests potential benefits for mental well-being.",
              "layer3": {}
            },
            "Depression": {
              "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has been shown to significantly reduce depression scores in individuals with bipolar disorder, highlighting its potential as a beneficial addition to mental health treatments.",
              "layer3": {}
            },
            "Disease Specific": {
              "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has demonstrated significant benefits in reducing depression scores and improving biomarkers of inflammation and oxidative stress in bipolar disorder patients. This suggests CoQ10's effectiveness in addressing specific mental health diseases by enhancing mood regulation and reducing biological factors that can exacerbate symptoms.",
              "layer3": {
                "Bipolar Disorder": {
                  "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has shown promising results in improving mental health conditions, notably in managing bipolar disorder, by reducing symptoms and enhancing mood stability. This effect likely stems from CoQ10's ability to improve cellular energy production and reduce oxidative stress, offering a novel approach to supporting mental wellness in bipolar disorder."
                }
              }
            }
          }
        },
        "Skin & Beauty": {
          "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has shown significant benefits in reducing wrinkles, enhancing skin smoothness, and protecting against UV damage. This highlights CoQ10's effectiveness in promoting skin health and contributing to a more youthful appearance by preserving skin integrity and mitochondrial function.",
          "layer2": {
            "Skin Health": {
              "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has shown to significantly reduce wrinkles, improve skin smoothness, and protect against UV damage, highlighting its vital role in enhancing skin health. This underscores CoQ10's effectiveness in promoting a more youthful skin appearance and preserving skin integrity.",
              "layer3": {
                "Wrinkles": {
                  "Summary Papers": "Coenzyme Q10 (CoQ10) supplementation has been effective in significantly reducing wrinkles and enhancing skin smoothness, indicating its powerful anti-aging properties and its role in promoting healthier, more youthful skin."
                }
              }
            }
          }
        }
      }
    },
    "Folic Acid": {
      "focusAreas": {
        "Longevity": {
          "Summary Papers": "Folic acid supplementation has been linked to significant improvements in reducing oxidative stress and enhancing metabolic health by lowering blood glucose and insulin resistance. These effects suggest folic acid's role in promoting longevity through the mitigation of age-related diseases and improving overall health.",
          "layer2": {
            "Disease Prevention": {
              "Summary Papers": "Folic acid supplementation has been linked to significant improvements in reducing oxidative stress and enhancing metabolic health by lowering blood glucose and insulin resistance. These effects underscore folic acid's crucial role in disease prevention, contributing to longer, healthier lives by mitigating risk factors associated with chronic conditions.",
              "layer3": {
                "Diabetes": {
                  "Summary Papers": "Folic acid supplementation has been linked to notable improvements in metabolic health, including significant reductions in fasting blood glucose, insulin levels, and insulin resistance, underscoring its role in diabetes prevention and management. This highlights folic acid's potential in contributing to longer, healthier lives by mitigating diabetes risk factors."
                }
              }
            }
          }
        },
        "Organ Health": {
          "Summary Papers": "Folic acid supplementation contributes to organ health by reducing cardiovascular risks, such as atherosclerosis and stroke, and improving blood vessel function through the lowering of homocysteine levels and blood pressure. These benefits highlight its essential role in promoting heart and vascular wellness.",
          "layer2": {
            "Heart & Circulation": {
              "Summary Papers": "Research suggests that folic acid supplementation may help support heart and circulatory health by slowing the buildup of artery plaque, reducing blood pressure, and lowering the risk of cardiovascular events. These potential benefits are linked to folic acid’s ability to reduce homocysteine levels and support healthier metabolism, underscoring its role in cardiovascular wellness.",
              "layer3": {}
            }
          }
        },
        "Mental Health": {
          "Summary Papers": "Folic acid supplementation has shown a promising effect in reducing depression scores. This highlights its potential role as an adjunctive treatment in improving mental health outcomes.",
          "layer2": {
            "Depression": {
              "Summary Papers": "Folic acid supplementation has been associated with significant improvements in mental health, particularly in reducing symptoms of depression. This connection may be attributed to folic acid's role in regulating homocysteine levels, which impacts brain health and mood regulation, suggesting its potential as an adjunctive treatment in managing depression.",
              "layer3": {}
            },
            "Disease Specific": {
              "Summary Papers": "Methylfolate, a form of folic acid, has shown significant benefits in enhancing social recovery for patients with depression or schizophrenia, particularly those with initially low folate levels. This underscores the critical role of folic acid in supporting mental health recovery and management of specific psychiatric conditions.",
              "layer3": {
                "Schizophrenia": {
                  "Summary Papers": "Methylfolate supplementation has demonstrated substantial improvements in patients with schizophrenia, particularly enhancing social recovery in those with initially low folate levels. This highlights the importance of folic acid in the therapeutic approach to schizophrenia, offering potential for improved outcomes in managing this complex condition."
                }
              }
            }
          }
        }
      }
    },
    "Iron": {
      "focusAreas": {
        "Longevity": {
          "Summary Papers": "Research suggests that iron supplementation may help combat fatigue and boost energy levels, supporting overall well-being and healthy energy metabolism — potential benefits that can contribute to a longer, more active life.",
          "layer2": {
            "Energy": {
              "Summary Papers": "Research suggests that iron supplementation may help reduce fatigue and improve energy levels, enhancing quality of life for individuals with iron deficiency — potential benefits that can also support long-term health and vitality.",
              "layer3": {}
            }
          }
        },
        "Organ Health": {
          "Summary Papers": "Research suggests that iron supports organ health by helping maintain energy levels, improving muscle endurance, and aiding the body’s ability to use oxygen efficiently. These potential benefits highlight its role in keeping organs functioning optimally across different life stages.",
          "layer2": {
            "Blood Health": {
              "Summary Papers": "Research suggests that iron supplementation supports blood health by helping increase hemoglobin and ferritin levels and improving overall iron status. These potential benefits highlight its role in maintaining healthy blood and reducing the risk of iron deficiency.",
              "layer3": {}
            },
            "Heart & Circulation": {
              "Summary Papers": "Research suggests that iron supplementation may support heart and circulation by improving exercise capacity and overall physical performance in individuals with low iron levels. These potential benefits highlight its role in promoting cardiovascular health.",
              "layer3": {}
            },
            "Brain Health": {
              "Summary Papers": "Research suggests that iron supplementation may support brain health by helping reduce certain symptoms associated with Restless Legs Syndrome. These potential benefits highlight its role in supporting healthy neurological function and overall mental well-being.",
              "layer3": {}
            }
          }
        },
        "Cognitive Performance": {
          "Summary Papers": "Research suggests that iron supplementation may help improve cognitive performance, particularly in children and adolescents, by supporting concentration, memory, and overall mental function. These potential benefits highlight its role in promoting brain health and learning.",
          "layer2": {
            "Fatigue": {
              "Summary Papers": "Iron supplementation notably reduces fatigue in non-anemic subjects, underscoring its pivotal role in enhancing cognitive performance and alleviating fatigue-related cognitive impairments.",
              "layer3": {}
            },
            "Focus": {
              "Summary Papers": "Research suggests that iron is important for cognitive focus in children and adolescents, with supplementation potentially supporting improvements in intelligence scores, concentration, and memory. These benefits highlight its role in healthy cognitive development and learning.",
              "layer3": {}
            },
            "Memory": {
              "Summary Papers": "Research suggests that iron supplementation may help improve memory in children, highlighting the importance of adequate iron levels for supporting healthy cognitive development.",
              "layer3": {}
            }
          }
        },
        "Mental Health": {
          "Summary Papers": "Research suggests that iron supplementation may help reduce perceived stress and improve mood in distance runners, highlighting its potential role in supporting psychological well-being.",
          "layer2": {
            "Stress": {
              "Summary Papers": "Research suggests that iron supplementation may help reduce perceived stress in distance runners with low ferritin levels, supporting mental well-being and promoting psychological resilience.",
              "layer3": {}
            }
          }
        },
        "Fitness": {
          "Summary Papers": "Research suggests that iron may help improve VO₂ max and boost energy levels in people engaged in aerobic training, highlighting its role in supporting physical performance and endurance.",
          "layer2": {
            "Endurance": {
              "Summary Papers": "Research suggests that iron supplementation may help enhance endurance in athletes undergoing aerobic training, including female soldiers, by supporting aerobic adaptation and energy levels — key factors for physical performance.",
              "layer3": {}
            }
          }
        },
        "Hormones & Reproduction": {
          "Summary Papers": "Iron supplementation during pregnancy significantly reduces the risk of maternal anemia and improves newborn health outcomes, while also benefiting menstruating women by increasing hemoglobin levels and reducing anemia risk, emphasizing its crucial role in women's reproductive health.",
          "layer2": {
            "Women": {
              "Summary Papers": "Iron supplementation during pregnancy significantly reduces the risk of maternal iron deficiency anemia and improves newborn health, while also benefiting menstruating women by increasing hemoglobin levels and reducing anemia risk, emphasizing its essential role in women's reproductive health.",
              "layer3": {
                "Pregnancy Health": {
                  "Summary Papers": "Iron supplementation during pregnancy significantly reduces the risk of maternal iron deficiency anemia and low birthweight, underscoring its crucial role in ensuring maternal and neonatal health and well-being during pregnancy."
                },
                "Menstrual Health": {
                  "Summary Papers": "Intermittent iron supplementation in menstruating women effectively increases hemoglobin and ferritin levels and reduces the risk of anemia, highlighting its importance in managing menstrual health and preventing anemia in women."
                }
              }
            }
          }
        },
        "Musculoskeletal Health": {
          "Summary Papers": "Research suggests that iron supplementation may support musculoskeletal health by helping improve symptoms and quality of life in individuals with conditions such as fibromyalgia, highlighting its potential role in managing long-term muscle and joint health.",
          "layer2": {
            "Fibromyalgia": {
              "Summary Papers": "Iron supplementation in patients with fibromyalgia and iron deficiency leads to significant improvements in symptoms, illustrating its potential therapeutic value in managing chronic musculoskeletal conditions and enhancing musculoskeletal health.",
              "layer3": {}
            }
          }
        }
      }
    },
    "Magnesium": {
      "focusAreas": {
        "Organ Health": {
          "Summary Papers": "Research suggests that magnesium may support organ health by helping alleviate acute migraine attacks and improving factors such as sleep quality, cardiovascular health, and glucose metabolism, highlighting its potential benefits across multiple body systems.",
          "layer2": {
            "Brain Health": {
              "Summary Papers": "Research suggests that magnesium may help reduce the severity and frequency of migraines, highlighting its potential role in supporting brain health and managing migraine symptoms.",
              "layer3": {
                "Migraines": {
                  "Summary Papers": "In the context of brain health and migraines, magnesium has proven effective in providing relief from acute migraine attacks and reducing migraine frequency and severity, underscoring its therapeutic potential for migraine sufferers."
                }
              }
            },
            "Heart & Circulation": {
              "Summary Papers": "Research suggests that magnesium supplementation may support heart and circulation health by helping improve cardiovascular risk factors, lowering blood pressure, and aiding in the management of conditions such as hypertension and diabetes, underscoring its role in overall cardiovascular wellness.",
              "layer3": {}
            },
            "Blood Health": {
              "Summary Papers": "Research suggests that magnesium may support blood health by helping increase vitamin D levels, which play a key role in calcium absorption and bone metabolism, highlighting its importance in maintaining healthy blood and bone function.",
              "layer3": {}
            },
            "Kidney Health": {
              "Summary Papers": "Magnesium's role in kidney health is underscored by its ability to improve markers associated with Chronic Kidney Disease-Mineral and Bone Disorder (CKD-MBD), offering potential benefits in managing complications associated with chronic kidney disease.",
              "layer3": {}
            },
            "Respiratory Health": {
              "Summary Papers": "Magnesium has shown a significant positive impact on respiratory health by reducing asthma symptoms and improving airway resilience in both adults and children, underscoring its potential as a supportive treatment for asthma management.",
              "layer3": {}
            },
            "Ear Health": {
              "Summary Papers": "Magnesium supplementation has demonstrated potential benefits in ear health, particularly in lessening the severity of tinnitus symptoms, suggesting a therapeutic role in managing this challenging condition.",
              "layer3": {}
            }
          }
        },
        "Fitness": {
          "Summary Papers": "Magnesium supplementation has been shown to significantly enhance fitness, with improvements in muscle strength, reduced muscle soreness, and better recovery in athletes, highlighting its importance in physical performance and endurance.",
          "layer2": {
            "Strength & Power": {
              "Summary Papers": "Research suggests that magnesium supplementation may help improve muscle strength and reduce soreness in athletes, highlighting its role in supporting strength, power, and overall physical performance.",
              "layer3": {}
            },
            "Recovery": {
              "Summary Papers": "Research suggests that magnesium may aid fitness recovery by helping reduce muscle damage, lessen soreness, and improve post-exercise blood glucose recovery, making it a valuable nutrient for athletes and active individuals.",
              "layer3": {}
            },
            "Endurance": {
              "Summary Papers": "Magnesium supplementation has significantly improved endurance performance, as seen in competitive triathletes, indicating its essential role in energy metabolism and aerobic capacity.",
              "layer3": {}
            }
          }
        },
        "Longevity": {
          "Summary Papers": "Research suggests that magnesium may support longevity by helping improve vitamin D status, cardiovascular health, blood sugar control, and mental well-being, highlighting its potential role in promoting overall health and reducing the risk of chronic disease.",
          "layer2": {
            "Disease Prevention": {
              "Summary Papers": "Research suggests that magnesium may help reduce muscle damage, improve vitamin D status, and lower inflammation markers, highlighting its potential role in supporting longevity and reducing the risk of chronic disease.",
              "layer3": {
                "Diabetes": {
                  "Summary Papers": "Magnesium's role in diabetes prevention is supported by its capacity to decrease inflammation and improve glucose metabolism and insulin sensitivity, illustrating its importance in managing and preventing diabetes."
                }
              }
            },
            "Energy": {
              "Summary Papers": "Research suggests that magnesium may help support energy levels and overall quality of life, particularly in individuals with PCOS, highlighting its role in promoting metabolic health and supporting conditions linked to energy metabolism.",
              "layer3": {}
            },
            "Disease Management": {
              "Summary Papers": "Magnesium has shown a wide-ranging impact on disease management, from improving glycemic control and insulin sensitivity in diabetic patients to reducing blood pressure and inflammation, emphasizing its importance in chronic disease management strategies.",
              "layer3": {
                "Diabetes": {
                  "Summary Papers": "The management of diabetes benefits from magnesium supplementation, as evidenced by improved glycemic control, insulin sensitivity, and reduced blood pressure, highlighting magnesium's integral role in diabetes care strategies."
                }
              }
            },
            "Weight Management": {
              "Summary Papers": "Research suggests that magnesium supplementation may help support weight management by improving mood and reducing inflammation markers, which can play an indirect role in maintaining a healthy weight.",
              "layer3": {}
            }
          }
        },
        "Hormones & Reproduction": {
          "Summary Papers": "Magnesium has a significant impact on hormonal and reproductive health, offering benefits such as reduced premenstrual syndrome symptoms, improved hormonal and metabolic profiles in PCOS, and enhanced mood and sleep quality, underscoring its importance in women's health.",
          "layer2": {
            "Women": {
              "Summary Papers": "For women's hormonal and reproductive health, magnesium has shown to improve symptoms of PMS, enhance hormonal and metabolic profiles in PCOS, and reduce water retention, underscoring its importance in women's health.",
              "layer3": {
                "Reproductive Health": {
                  "Summary Papers": "Magnesium plays a crucial role in women's reproductive health by improving hormonal balance, reducing symptoms of PCOS and PMS, and positively affecting ovulation and menstrual cycles, demonstrating its importance in managing reproductive health issues."
                },
                "Menstrual Health": {
                  "Summary Papers": "For menstrual health, magnesium supplementation has shown to significantly alleviate premenstrual syndrome symptoms, including water retention and mood changes, offering a non-invasive option for managing menstrual health concerns."
                }
              }
            }
          }
        },
        "Sleep": {
          "Summary Papers": "Research suggests that magnesium supplementation may help improve sleep quality by reducing the time it takes to fall asleep and enhancing sleep efficiency, making it a valuable option for those looking to support better rest.",
          "layer2": {
            "Sleep Quality": {
              "Summary Papers": "Magnesium's benefits on sleep quality, including reducing sleep onset latency and enhancing sleep efficiency, make it a critical nutrient for improving sleep and, by extension, overall health and well-being.",
              "layer3": {}
            },
            "Falling Asleep": {
              "Summary Papers": "Magnesium supplementation has been effective in reducing sleep onset latency and improving the quality of sleep in older adults, indicating its significant impact on facilitating the process of falling asleep and enhancing overall sleep quality.",
              "layer3": {}
            }
          }
        },
        "Musculoskeletal Health": {
          "Summary Papers": "Research suggests that magnesium may support musculoskeletal health by helping reduce bone turnover in osteoporotic women, easing pain in fibromyalgia, and increasing bone mineral content, highlighting its role in bone strength and pain management.",
          "layer2": {
            "Bones": {
              "Summary Papers": "Magnesium's role in musculoskeletal health, particularly in bone health, is underscored by its ability to suppress bone turnover and increase bone mineral content, offering a potential strategy for osteoporosis management and bone health improvement.",
              "layer3": {}
            },
            "Fibromyalgia": {
              "Summary Papers": "For individuals with fibromyalgia, magnesium has shown promise in reducing stress symptoms and pain intensity, with combination therapies involving magnesium demonstrating enhanced effectiveness in alleviating fibromyalgia symptoms.",
              "layer3": {}
            }
          }
        },
        "Mental Health": {
          "Summary Papers": "Research suggests that magnesium may help reduce anxiety and depression symptoms while also improving sleep quality, highlighting its potential to support overall well-being.",
          "layer2": {
            "Anxiety": {
              "Summary Papers": "Research suggests that magnesium supplementation may help reduce anxiety levels, particularly in post-operative care, highlighting its potential role in supporting relaxation and recovery.",
              "layer3": {}
            },
            "Depression": {
              "Summary Papers": "The role of magnesium in combating depression is evident from its ability to improve mood and reduce depressive symptoms, aligning with the effectiveness of traditional antidepressant drugs and highlighting its significance in mental health care.",
              "layer3": {}
            },
            "Stress": {
              "Summary Papers": "Magnesium's impact on stress reduction is highlighted by its ability to improve sleep quality and reduce cortisol levels, supporting its use as a natural remedy for stress management and overall mental well-being.",
              "layer3": {}
            }
          }
        }
      }
    },
    "Omega 3": {
      "focusAreas": {
        "Mental Health": {
          "Summary Papers": "Research suggests that omega-3 fatty acids, particularly EPA, may help reduce inflammation and support healthy neurotransmitter function, which are important for mood regulation and cognitive performance. These potential effects have been linked to improvements in symptoms such as depression, anxiety, and attention difficulties.",
          "layer2": {
            "Disease Specific": {
              "Summary Papers": "Omega-3 fatty acids, especially EPA and DHA, have a profound impact on improving symptoms of specific mental health disorders such as ADHD and bipolar depression by enhancing focus, reducing hyperactivity, and improving mood regulation. These nutrients support brain function and neurotransmitter balance, leading to notable improvements in behavioral and cognitive outcomes in affected individuals.",
              "layer3": {
                "ADHD": {
                  "Summary Papers": "Omega-3 fatty acids, especially EPA and DHA, significantly improve symptoms of ADHD in children and adolescents by enhancing focus, working memory, and reducing hyperactivity and oppositional behaviors. This nutritional intervention supports better academic performance and behavioral outcomes, contributing to overall improvements in daily functioning and quality of life for individuals with ADHD."
                },
                "Bipolar Disorder": {
                  "Summary Papers": "Omega-3 fatty acids, particularly EPA, have been shown to significantly alleviate depressive symptoms in individuals with bipolar disorder, contributing to improved mood and potentially enhancing brain physiology. However, these benefits appear more pronounced in managing depression within bipolar disorder, with limited impact on manic phases, suggesting a targeted yet partial therapeutic effect."
                },
                "Schizophrenia": {
                  "Summary Papers": "Omega-3 fatty acids, through supplementation of EPA and DHA, show potential in improving symptoms of schizophrenia by reducing oxidative stress markers in patients. This suggests a beneficial effect on mental health by possibly enhancing brain function and mitigating some underlying factors contributing to schizophrenia."
                }
              }
            },
            "Anxiety": {
              "Summary Papers": "Research suggests that omega-3 fatty acids, particularly EPA and DHA, may help reduce anxiety by supporting healthy brain function, lowering inflammation, and promoting a calmer, more balanced state.",
              "layer3": {}
            },
            "Mood Improvement": {
              "Summary Papers": "Omega-3 fatty acids, through supplementation or diet enhancement, play a significant role in elevating mood and reducing negative emotions such as anger, anxiety, and depression. This mood-enhancing effect is linked to the improvement in brain function and the balancing of blood fat levels, contributing to overall emotional and psychological well-being.",
              "layer3": {}
            },
            "Depression": {
              "Summary Papers": "Omega-3 fatty acids, particularly EPA, have shown a significant impact in reducing depressive symptoms, improving mood, and enhancing emotional well-being in individuals with depression. This effect is attributed to omega-3's ability to modulate brain chemistry and inflammation, offering a promising adjunct treatment for depression alongside traditional therapies.",
              "layer3": {}
            },
            "Stress": {
              "Summary Papers": "Research suggests that omega-3 fatty acids, especially EPA and DHA, may help reduce stress levels and improve mood by supporting the body’s stress response and easing symptoms linked to depression. These potential benefits highlight their role in promoting resilience and overall emotional well-being.",
              "layer3": {}
            }
          }
        },
        "Cognitive Performance": {
          "Summary Papers": "Research suggests that omega-3 fatty acids, especially DHA and EPA, may support brain health by helping improve memory, reaction time, and cerebral blood flow — key factors for sharp thinking, quick responses, and effective information processing.",
          "layer2": {
            "Memory": {
              "Summary Papers": "Research suggests that omega-3 fatty acids, particularly DHA, may help improve memory by supporting neuronal communication and reducing inflammation, with potential benefits for both short- and long-term recall across different age groups.",
              "layer3": {}
            },
            "Reaction Time": {
              "Summary Papers": "Research suggests that omega-3 fatty acids, particularly EPA and DHA, may help improve reaction time in cognitive tasks by supporting brain function and neural efficiency, contributing to quicker responses and enhanced cognitive performance.",
              "layer3": {}
            },
            "Focus": {
              "Summary Papers": "Research suggests that omega-3 fatty acids, particularly DHA, may help boost cognitive performance and focus by increasing cerebral blood flow and oxygen delivery during tasks, supporting better concentration and information processing.",
              "layer3": {}
            }
          }
        },
        "Longevity": {
          "Summary Papers": "Omega-3 fatty acids contribute to longevity by reducing inflammation and improving heart health, weight management, and metabolic functions. These benefits, in turn, support the body's overall resilience against aging-related diseases and conditions, enhancing lifespan and quality of life.",
          "layer2": {
            "Energy": {
              "Summary Papers": "Research suggests that omega-3 fatty acids may help boost energy levels and reduce daytime sleepiness by improving mood and supporting healthy inflammation and blood lipid profiles, contributing to greater vitality and overall well-being.",
              "layer3": {}
            },
            "Weight Management": {
              "Summary Papers": "Research suggests that omega-3 fatty acids may support weight management by aiding fat loss, improving insulin sensitivity, and increasing fat-burning efficiency — effects that may be enhanced when paired with a balanced diet and regular exercise. These potential benefits are linked to omega-3’s role in modulating metabolism and reducing inflammation.",
              "layer3": {}
            },
            "Disease Prevention": {
              "Summary Papers": "Omega-3 fatty acids play a crucial role in disease prevention by reducing inflammation, improving lipid profiles, and enhancing insulin sensitivity. These effects contribute to a lower risk of developing chronic conditions such as cardiovascular diseases, diabetes, and inflammatory disorders, supporting overall health and longevity.",
              "layer3": {
                "Diabetes": {
                  "Summary Papers": "Omega-3 fatty acids, particularly from fish oil supplementation, have shown potential in reducing risk factors associated with diabetes, such as improving lipid profiles and modestly enhancing insulin sensitivity. These effects suggest a beneficial role in diabetes prevention and management, highlighting the importance of omega-3s in supporting metabolic health."
                }
              }
            },
            "Disease Management": {
              "Summary Papers": "Omega-3 fatty acids are effective in managing chronic diseases by significantly improving metabolic markers, reducing inflammation, and enhancing blood flow. These benefits aid in the management of conditions such as type 2 diabetes, systemic lupus erythematosus, and cardiovascular diseases, contributing to better disease outcomes and quality of life.",
              "layer3": {
                "Diabetes": {
                  "Summary Papers": "Omega-3 fatty acids are effective in managing diabetes by significantly lowering triglycerides, improving endothelial function, and reducing markers of inflammation and oxidative stress in individuals with type 2 diabetes. These effects contribute to better glycemic control and cardiovascular health, supporting a comprehensive approach to diabetes management."
                },
                "Autoimmune Diseases": {
                  "Summary Papers": "Omega-3 fatty acids have shown significant benefits in managing autoimmune diseases such as systemic lupus erythematosus, with patients experiencing symptom reduction and improved blood flow, highlighting omega-3's potential as an effective adjunct treatment for reducing autoimmune disease symptoms."
                },
                "Cancer": {
                  "Summary Papers": "In the context of cancer management, omega-3 fatty acids, particularly EPA and DHA, have been effective in reducing inflammation markers in advanced lung cancer patients, suggesting a supportive role in enhancing the effectiveness of chemotherapy and potentially improving patient outcomes."
                }
              }
            }
          }
        },
        "Organ Health": {
          "Summary Papers": "Research suggests that omega-3 fatty acids, particularly EPA and DHA, may help maintain organ health by improving blood flow, reducing inflammation, and supporting healthy lipid profiles. These potential benefits contribute to the optimal function of the heart, brain, and other vital organs, supporting overall well-being.",
          "layer2": {
            "Brain Health": {
              "Summary Papers": "Research suggests that omega-3 fatty acids, particularly DHA, may support brain health by increasing cerebral blood flow and oxygen delivery during cognitive tasks, as well as reducing inflammation, which may help lessen the frequency and severity of migraines. These potential benefits highlight omega-3’s role in promoting cognitive function and overall neurological well-being",
              "layer3": {
                "Migraines": {
                  "Summary Papers": "The combination of omega-3 fats and nano-curcumin has demonstrated a significant reduction in migraine attacks and inflammation markers, indicating the potential of omega-3 fatty acids in reducing migraine frequency and severity through anti-inflammatory effects."
                }
              }
            },
            "Blood Health": {
              "Summary Papers": "Research suggests that omega-3 fatty acids may support brain health by improving mood and cognitive function, while also helping reduce risk factors such as high triglycerides and insulin resistance that can affect brain function. These potential benefits contribute to overall mental well-being and may help lower the risk of cognitive decline.",
              "layer3": {}
            },
            "Heart & Circulation": {
              "Summary Papers": "Research suggests that omega-3 fatty acids may support heart and circulatory health by helping reduce triglycerides, improve lipid profiles, and enhance endothelial function. These potential benefits contribute to better blood flow, reduced inflammation, and overall cardiovascular wellness.",
              "layer3": {}
            },
            "Respiratory Health": {
              "Summary Papers": "Omega-3 fatty acids contribute to respiratory health by reducing airway inflammation and improving symptoms of asthma and exercise-induced bronchoconstriction. These effects support better lung function and may reduce the risk of respiratory conditions in both adults and potentially in infants through maternal supplementation.",
              "layer3": {}
            },
            "Kidney Health": {
              "Summary Papers": "Omega-3 fatty acids benefit kidney health by slightly reducing inflammation and significantly improving lipid profiles in chronic kidney disease patients. These effects can contribute to the overall management of kidney health by addressing risk factors associated with kidney disease progression.",
              "layer3": {}
            },
            "Eye Health": {
              "Summary Papers": "Omega-3 fatty acids, alongside nutrients like lutein and zeaxanthin, significantly improve visual acuity, suggesting a beneficial impact on eye health, particularly in managing conditions like age-related macular degeneration. This effect likely stems from omega-3's anti-inflammatory and neuroprotective properties, supporting overall retinal health and function.",
              "layer3": {}
            }
          }
        },
        "Fitness": {
          "Summary Papers": "Research suggests that omega-3 fatty acids, particularly EPA and DHA, may support fitness by aiding fat loss, improving endurance, and helping recovery after exercise through reduced inflammation and better metabolic health. These potential benefits can contribute to more effective workouts and quicker recovery times.",
          "layer2": {
            "Fat Loss": {
              "Summary Papers": "Research suggests that omega-3 fatty acids may help enhance fat loss and improve body composition by supporting metabolic health, increasing fat oxidation, and making fat-burning processes more efficient — effects that may be amplified when combined with exercise and a balanced diet. These potential benefits can contribute to improved fitness and overall health.",
              "layer3": {}
            },
            "Endurance": {
              "Summary Papers": "Research suggests that omega-3 fatty acids may help improve endurance by supporting cardiovascular health and reducing the oxygen cost of exercise, potentially enhancing both aerobic and anaerobic capacity. These benefits can contribute to better performance and efficiency for athletes and active individuals.",
              "layer3": {}
            },
            "Recovery": {
              "Summary Papers": "Research suggests that omega-3 fatty acids may help support fitness recovery by reducing inflammation and easing post-exercise pain and soreness, enabling more effective recovery and supporting overall physical performance.",
              "layer3": {}
            },
            "Body Fat": {
              "Summary Papers": "Omega-3 fatty acids, when combined with regular aerobic exercise, significantly enhance body fat reduction and improve cardiovascular health markers, facilitating better body composition and overall fitness. This synergistic effect highlights the role of omega-3s in supporting fat loss efforts and cardiovascular wellness.",
              "layer3": {}
            }
          }
        },
        "Immunity": {
          "Summary Papers": "Research suggests that omega-3 fatty acids may help support immunity by modulating inflammatory responses and enhancing the activity of infection-fighting cells, such as natural killer cells. These potential benefits can contribute to a more efficient immune system and greater overall resilience.",
          "layer2": {
            "Immune Strengthening": {
              "Summary Papers": "Omega-3 fatty acids boost the immune system by reducing inflammation and enhancing the activity of cells critical for immune response, such as natural killer cells and the production of cytokines like IL-2 and IL-4. These effects contribute to a more effective defense against infections and improved overall immune function.",
              "layer3": {}
            }
          }
        },
        "Hormones & Reproduction": {
          "Summary Papers": "Omega-3 fatty acids may help keep hormones in balance and support reproductive health by influencing hormone levels and improving factors linked to healthy pregnancy outcomes. They can also play a role in supporting menstrual cycle health and overall wellness.",
          "layer2": {
            "Women": {
              "Summary Papers": "Omega-3 fatty acids support women's reproductive health by modulating hormonal levels, reducing the risk of infant mortality, and potentially shortening the time to birth. These benefits extend to improving symptoms associated with premenstrual syndrome and managing conditions like polycystic ovarian syndrome, highlighting the role of omega-3s in enhancing female reproductive well-being and pregnancy outcomes.",
              "layer3": {
                "Pregnancy Health": {
                  "Summary Papers": "Omega-3 supplementation during pregnancy has been associated with beneficial outcomes such as reduced infant mortality and a slight reduction in time to birth, although it did not significantly reduce the risk of pre-eclampsia, suggesting a nuanced role of omega-3s in pregnancy health."
                },
                "Reproductive Health": {
                  "Summary Papers": "Omega-3 fatty acids have been shown to positively affect reproductive health in women, including reducing triglycerides and insulin resistance in PCOS and modulating reproductive hormones, indicating their potential role in managing reproductive health conditions."
                },
                "Menstrual Health": {
                  "Summary Papers": "For menstrual health, omega-3 fatty acid supplementation has been effective in improving symptoms associated with premenstrual syndrome, particularly in reducing insomnia and hypersomnia, highlighting the potential of omega-3s in alleviating menstrual-related discomfort."
                }
              }
            }
          }
        },
        "Sleep": {
          "Summary Papers": "Omega-3 fatty acids may help improve sleep quality by easing symptoms of both insomnia and hypersomnia. Their potential anti-inflammatory effects and influence on brain function can support deeper, more restful sleep, which in turn may enhance overall well-being and daily energy levels.",
          "layer2": {
            "Falling Asleep": {
              "Summary Papers": "Omega-3 fatty acids significantly improve the ability to fall asleep by reducing symptoms of insomnia and enhancing overall sleep quality. These benefits are likely due to omega-3's positive effects on reducing anxiety and depression, factors that can interfere with sleep initiation, contributing to a more restful and uninterrupted night's sleep.",
              "layer3": {}
            },
            "Sleep Quality": {
              "Summary Papers": "Omega-3 fatty acids enhance sleep quality by alleviating symptoms of insomnia and hypersomnia, contributing to more restful and uninterrupted sleep. This improvement in sleep patterns supports overall well-being and can particularly benefit individuals experiencing sleep disturbances related to premenstrual syndrome.",
              "layer3": {}
            }
          }
        },
        "Skin & Beauty": {
          "Summary Papers": "Omega-3 fatty acids, particularly EPA from fish oil, enhance skin health by increasing skin barrier function, reducing sensitivity to sunburn, and decreasing DNA damage from UV exposure. This contributes to healthier, more resilient skin and a reduced risk of skin aging and damage.",
          "layer2": {
            "Skin Health": {
              "Summary Papers": "Omega-3 fatty acids, particularly EPA from fish oil, improve skin health by enhancing the skin's EPA levels, which contributes to reduced sensitivity to sunburn and decreased DNA damage. This protective effect supports the maintenance of healthy skin and may reduce the risk of skin-related issues caused by UV exposure.",
              "layer3": {}
            }
          }
        }
      }
    },
    "Probiotics": {
      "focusAreas": {
        "Organ Health": {
          "Summary Papers": "Probiotics may help support organ health by reducing inflammation in the gut, particularly in people with cystic fibrosis, suggesting a role in promoting digestive health with minimal side effects.",
          "layer2": {
            "Gut Health": {
              "Summary Papers": "Probiotics have demonstrated effectiveness in improving gut health by significantly lowering inflammation indicators. This suggests their beneficial role in managing intestinal conditions while maintaining a low risk of mild side effects.",
              "layer3": {}
            }
          }
        }
      }
    },
    "Vitamin B12": {
      "focusAreas": {
        "Organ Health": {
          "Summary Papers": "Vitamin B12 may help support overall organ health by promoting optimal brain function, with research showing benefits for cognitive abilities such as verbal learning in certain neurological conditions.",
          "layer2": {
            "Heart & Circulation": {
              "Summary Papers": "Vitamin B12 may support heart and circulation health by aiding recovery in stroke-related conditions and improving cognitive outcomes, highlighting its potential role in cardiovascular system support and brain function.",
              "layer3": {}
            }
          }
        }
      }
    },
    "Vitamin B2": {
      "focusAreas": {
        "Organ Health": {
          "Summary Papers": "Vitamin B2 (riboflavin) may support overall organ health by helping lower homocysteine levels and blood pressure, particularly in people with certain genetic variations, while also reducing the frequency and duration of migraines.",
          "layer2": {
            "Heart & Circulation": {
              "Summary Papers": "Vitamin B2 may help support heart and circulation health by lowering homocysteine levels and blood pressure, especially in individuals with specific genetic predispositions, offering a targeted approach to cardiovascular wellness.",
              "layer3": {}
            },
            "Brain Health": {
              "Summary Papers": "Vitamin B2 may benefit brain health by reducing how often and how long migraines last, including in children and adolescents, making it a promising non-drug option for migraine management.",
              "layer3": {
                "Migraines": {
                  "Summary Papers": "For brain health specifically related to migraines, vitamin B2 (riboflavin) supplementation has shown to be effective in significantly reducing migraine frequency and duration, providing a beneficial intervention for individuals suffering from this condition."
                }
              }
            }
          }
        }
      }
    },
    "Vitamin B6": {
      "focusAreas": {
        "Sleep": {
          "Summary Papers": "Supplementing with Vitamin B6 before sleep has been shown to significantly increase dream vividness and recall, suggesting an influence on sleep quality by possibly affecting REM sleep patterns.",
          "layer2": {
            "Sleep Quality": {
              "Summary Papers": "Vitamin B6 (pyridoxine) may help improve sleep quality by increasing dream vividness and recall, which could contribute to deeper, more engaging sleep experiences and support better rest overall.",
              "layer3": {}
            }
          }
        },
        "Fitness": {
          "Summary Papers": "Vitamin B6 may support fitness by helping boost growth hormone levels and reduce prolactin during physical activity, which could aid muscle development and help the body manage stress during exercise.",
          "layer2": {
            "Recovery": {
              "Summary Papers": "Vitamin B6 plays a crucial role in fitness recovery by promoting an increase in growth hormone levels and reducing prolactin levels, indicating enhanced muscle repair and reduced stress from physical exertion.",
              "layer3": {}
            },
            "Endurance": {
              "Summary Papers": "Vitamin B6 could play a role in boosting endurance by promoting hormonal balance during exercise, which may help the body sustain activity longer and perform more efficiently.",
              "layer3": {}
            }
          }
        },
        "Hormones & Reproduction": {
          "Summary Papers": "Vitamin B6 supplementation has proven effective in managing hormonal and reproductive health, notably improving symptoms of premenstrual syndrome (PMS) and affecting prolactin levels, indicating its significant role in hormonal balance and reproductive health management.",
          "layer2": {
            "Women": {
              "Summary Papers": "Vitamin B6 supplementation is beneficial for women's hormonal health, showing significant improvements in managing premenstrual syndrome symptoms and minor effects on prolactin levels, highlighting its role in women's reproductive health.",
              "layer3": {
                "Reproduction": {
                  "Summary Papers": "Vitamin B6 has a minor impact on women's reproductive health by slightly decreasing prolactin levels without significant changes in cortisol and ACTH, suggesting a nuanced role in reproductive hormone regulation."
                },
                "Menstrual Health": {
                  "Summary Papers": "Vitamin B6 has been effective in significantly improving symptoms associated with premenstrual syndrome in women, demonstrating its potential as a supportive treatment for managing menstrual health issues."
                }
              }
            }
          }
        }
      }
    },
    "Vitamin C": {
      "focusAreas": {
        "Fitness": {
          "Summary Papers": "Vitamin C may support fitness by helping reduce muscle soreness, lowering markers of muscle damage, and easing oxidative stress during and after workouts. It may also help moderate the cortisol rise from exercise in hot conditions, supporting recovery and stress management.",
          "layer2": {
            "Recovery": {
              "Summary Papers": "Vitamin C may aid fitness recovery by helping reduce muscle soreness, easing oxidative stress, and moderating the cortisol spike that can occur during exercise in hot conditions, supporting post-workout recovery and overall physical well-being.",
              "layer3": {}
            },
            "Endurance": {
              "Summary Papers": "Vitamin C supplementation supports endurance by reducing the cortisol spike associated with exercise-heat stress, suggesting its role in enhancing physical performance and resilience during prolonged physical activities.",
              "layer3": {}
            }
          }
        },
        "Longevity": {
          "Summary Papers": "Vitamin C may support longevity through its antioxidant properties, helping reduce inflammation, fasting blood glucose, and oxidative stress while promoting vascular health — potential benefits that can contribute to healthier aging and long-term well-being.",
          "layer2": {
            "Disease Prevention": {
              "Summary Papers": "Vitamin C plays a crucial role in disease prevention by reducing oxidative stress, inflammation, and the risk of gout, alongside protecting fats from exercise-induced damage, which collectively contribute to reducing the likelihood of age-related diseases and enhancing longevity.",
              "layer3": {}
            },
            "Disease Management": {
              "Summary Papers": "In disease management, Vitamin C has shown significant benefits by reducing inflammation, blood glucose, and cholesterol levels in individuals with diabetes and obesity, highlighting its potential in managing chronic conditions and improving overall health outcomes.",
              "layer3": {
                "Diabetes": {
                  "Summary Papers": "In diabetes management, vitamin C significantly improves blood glucose levels, reduces inflammation, and enhances lipid profiles, showcasing its beneficial impact on glycemic control and cardiovascular risk factors in individuals with diabetes."
                }
              }
            },
            "Weight Management": {
              "Summary Papers": "Vitamin C contributes to weight management by significantly reducing inflammation and fasting blood glucose in obese individuals, and moderating blood pressure during mental stress, suggesting its role in combating obesity-related complications and improving metabolic health.",
              "layer3": {}
            },
            "DNA Health": {
              "Summary Papers": "Vitamin C's impact on DNA health is evidenced by its effectiveness in reducing DNA damage in blood cells, indicating its protective role against genetic damage and its potential in preventing long-term health complications.",
              "layer3": {}
            }
          }
        },
        "Cognitive Performance": {
          "Summary Papers": "Vitamin C may help improve cognitive performance during physical activity by reducing fatigue, which could enhance mental alertness and lower perceived exertion, supporting sharper focus while exercising.",
          "layer2": {
            "Fatigue": {
              "Summary Papers": "Vitamin C may help combat fatigue by lowering perceived exertion and tiredness during exercise, potentially supporting both physical stamina and mental focus.",
              "layer3": {}
            }
          }
        },
        "Hormones & Reproduction": {
          "Summary Papers": "Vitamin C may play a valuable role in hormone regulation and reproductive health for both men and women. In men, it has been linked to protecting sperm quality from harmful exposures and supporting mood and sexual health. In women, it may help manage bacterial vaginosis and promote hormonal balance. More broadly, Vitamin C’s ability to influence cortisol and glucose levels highlights its potential in supporting stress response and overall metabolic health.",
          "layer2": {
            "Men": {
              "Summary Papers": "In the realm of hormones and reproduction for men, Vitamin C has demonstrated protective effects on sperm parameters against toxic exposures and has been associated with improved mood and sexual health, underscoring its importance in male reproductive well-being.",
              "layer3": {
                "Sperm Health": {
                  "Summary Papers": "Vitamin C's protective effect on sperm health in men exposed to lead highlights its antioxidative properties and its importance in maintaining reproductive health, even under adverse environmental conditions."
                }
              }
            },
            "Women": {
              "Summary Papers": "For women's reproductive health, Vitamin C has shown to effectively treat bacterial vaginosis and enhance mood, suggesting its broad impact on women's hormonal balance and reproductive system health.",
              "layer3": {
                "Sexual Health": {
                  "Summary Papers": "By significantly enhancing mood and intercourse frequency, vitamin C contributes to improved sexual health, demonstrating its positive impact on emotional well-being and sexual relationships."
                },
                "Reproductive Health": {
                  "Summary Papers": "Vitamin C effectively treats bacterial vaginosis, emphasizing its role in women's reproductive health and highlighting its therapeutic potential in managing vaginal infections."
                }
              }
            },
            "General Hormone Health": {
              "Summary Papers": "Vitamin C's role in general hormone health is highlighted by its ability to modulate cortisol and glucose levels post-surgery, indicating its potential influence on stress response and metabolic regulation.",
              "layer3": {
                "Cortisol": {
                  "Summary Papers": "Vitamin C's influence on general hormone health is evidenced by its ability to modulate cortisol and glucose levels post-surgery, suggesting its potential in stress response and metabolic regulation."
                }
              }
            }
          }
        },
        "Mental Health": {
          "Summary Papers": "Vitamin C significantly benefits mental health by reducing depression symptoms and improving mood, demonstrating its effectiveness as an adjunct treatment for depression and its potential to enhance overall well-being.",
          "layer2": {
            "Depression": {
              "Summary Papers": "In addressing depression within mental health, Vitamin C supplementation has been associated with significant mood improvement and increased well-being, presenting a promising adjunct treatment option for depression.",
              "layer3": {}
            }
          }
        },
        "Organ Health": {
          "Summary Papers": "Vitamin C may help protect and support organ health by reducing inflammation, easing oxidative stress, and improving vascular function — key factors in keeping organs working optimally and lowering the risk of chronic disease.",
          "layer2": {
            "Heart & Circulation": {
              "Summary Papers": "Vitamin C may support heart and circulation health by improving blood flow, reducing endothelial dysfunction, and lowering oxidative damage — all important for maintaining cardiovascular wellness and reducing the risk of related diseases.",
              "layer3": {}
            },
            "Respiratory Health": {
              "Summary Papers": "Vitamin C may help counter some of the negative effects of smoking on blood circulation, supporting respiratory health and helping maintain lung function even in challenging conditions",
              "layer3": {}
            },
            "Blood Health": {
              "Summary Papers": "Vitamin C may support blood health by helping reduce DNA damage and oxidative stress markers, showcasing its antioxidant power and potential to protect cellular integrity.",
              "layer3": {}
            }
          }
        },
        "Immunity": {
          "Summary Papers": "Vitamin C enhances immunity, as evidenced by its effectiveness in reducing the incidence and duration of colds, especially in physically stressed individuals, showcasing its vital role in supporting the immune system.",
          "layer2": {
            "Infection Management": {
              "Summary Papers": "Vitamin C's effectiveness in reducing the frequency and severity of cold symptoms among soldiers in challenging climates demonstrates its potent role in infection management, enhancing immune response and reducing the impact of respiratory infections.",
              "layer3": {
                "Common Cold": {
                  "Summary Papers": "Vitamin C's ability to significantly reduce the frequency and duration of common cold symptoms illustrates its effectiveness in managing infections, reinforcing its role as a vital nutrient in immune function and infection management."
                }
              }
            },
            "Immune Strengthening": {
              "Summary Papers": "The significant reduction in the incidence of colds among soldiers supplemented with vitamin C underscores its role in immune strengthening, offering a simple yet effective strategy to bolster the body's defense mechanisms against common infections.",
              "layer3": {}
            }
          }
        },
        "Musculoskeletal Health": {
          "Summary Papers": "Vitamin C contributes to musculoskeletal health by increasing bone mineral density and reducing oxidative stress, indicating its potential in preventing osteoporosis and supporting overall skeletal health.",
          "layer2": {
            "Bones": {
              "Summary Papers": "Vitamin C supplementation is associated with increased bone mineral density and reduced oxidative stress in elderly adults, indicating its potential in preventing bone loss and promoting musculoskeletal health, particularly in age-related osteoporosis.",
              "layer3": {}
            }
          }
        }
      }
    },
    "Vitamin D": {
      "focusAreas": {
        "Longevity": {
          "Summary Papers": "Vitamin D may support longevity by helping improve cognitive function, reduce body fat, ease endometriosis symptoms, lower mortality risk in illnesses like COVID-19, and decrease the likelihood of certain cancers and chronic diseases, highlighting its broad role in health and disease prevention.",
          "layer2": {
            "Disease Management": {
              "Summary Papers": "Vitamin D plays a crucial role in disease management by enhancing memory in Alzheimer's, reducing relapse rates in multiple sclerosis, and alleviating symptoms in chronic conditions like breast cancer and diabetes, underlining its protective and therapeutic effects against various diseases.",
              "layer3": {
                "Neurodegenerative": {
                  "Summary Papers": "Vitamin D supplementation offers protective benefits against neurodegenerative diseases by improving memory performance in Alzheimer's, lowering multiple sclerosis relapse rates, and potentially regulating immune system functions, indicating its importance in neurodegenerative disease management."
                },
                "Cancer": {
                  "Summary Papers": "Vitamin D supplementation in subjects undergoing cancer treatment notably increases serum vitamin D levels and reduces joint pain, indicating its supportive role in managing side effects of cancer therapy."
                },
                "Diabetes": {
                  "Summary Papers": "In diabetes management, vitamin D supplementation leads to significant improvements in insulin sensitivity and pancreatic insulin secretion, highlighting its beneficial effects on glucose metabolism and potential in diabetes care."
                }
              }
            },
            "Weight Management": {
              "Summary Papers": "Vitamin D may help with weight management by boosting body fat reduction in overweight women and improving insulin sensitivity in obese children, highlighting its potential role in addressing obesity and related metabolic issues.",
              "layer3": {}
            },
            "Disease Prevention": {
              "Summary Papers": "Vitamin D plays a crucial role in disease prevention by significantly reducing symptoms and improving metabolic profiles in conditions like endometriosis and premenstrual syndrome, lowering ICU admissions and mortality rates in COVID-19, and decreasing the risk of various cancers and diabetes, underscoring its broad protective effects against chronic diseases.",
              "layer3": {
                "Diabetes": {
                  "Summary Papers": "Vitamin D plays a pivotal role in diabetes prevention, with studies showing its association with lower incidence rates of type 1 diabetes, improved insulin sensitivity, and better glucose regulation, underscoring its potential in reducing diabetes risk and managing blood sugar levels."
                },
                "Cancer": {
                  "Summary Papers": "In cancer prevention, vitamin D has been significantly associated with reduced risks of breast, colorectal, and pancreatic cancers, suggesting its vital role in lowering the risk of developing certain cancers through its influence on cell growth and immune function."
                }
              }
            }
          }
        },
        "Fitness": {
          "Summary Papers": "Vitamin D may support fitness by helping reduce body fat, promoting muscle repair, and boosting power output, highlighting its role in physical conditioning and muscular health.",
          "layer2": {
            "Fat Loss": {
              "Summary Papers": "Vitamin D may aid fat loss by helping reduce body fat mass in overweight and obese individuals, supporting both weight management and improved metabolic health.",
              "layer3": {}
            },
            "Strength & Power": {
              "Summary Papers": "Vitamin D may help boost strength and power in adults engaged in resistance training, suggesting a role in supporting physical performance and muscle function.",
              "layer3": {}
            },
            "Recovery": {
              "Summary Papers": "Vitamin D aids in recovery from fitness activities by improving skeletal muscle repair, regeneration, and hypertrophy, indicating its vital role in post-exercise recovery and muscle health.",
              "layer3": {}
            },
            "Muscle Mass": {
              "Summary Papers": "Vitamin D may help promote muscle growth and maintenance by supporting skeletal muscle repair, regeneration, and hypertrophy, underscoring its importance for muscular health.",
              "layer3": {}
            }
          }
        },
        "Hormones & Reproduction": {
          "Summary Papers": "Vitamin D may support hormonal and reproductive health by helping raise testosterone levels in men, easing menstrual cramps and PMS symptoms in women, and reducing discomfort from endometriosis, highlighting its role in promoting reproductive well-being and hormonal balance.",
          "layer2": {
            "Men": {
              "Summary Papers": "Vitamin D significantly impacts men's hormonal health by increasing testosterone levels, which plays a critical role in muscle strength, bone density, and overall well-being.",
              "layer3": {
                "Testosterone": {
                  "Summary Papers": "For men's testosterone levels, vitamin D supplementation has been shown to significantly increase testosterone levels over a year, highlighting its importance in supporting hormonal health and overall well-being in men."
                }
              }
            },
            "Women": {
              "Summary Papers": "In women, vitamin D supplementation has shown to alleviate symptoms of premenstrual syndrome and dysmenorrhea, and improve mood in conditions like endometriosis, indicating its beneficial effects on women's hormonal and reproductive health.",
              "layer3": {
                "Menstrual Health": {
                  "Summary Papers": "Vitamin D supplementation has shown promising results in improving menstrual health, including reducing menstrual cramps and dysmenorrhea, and enhancing mood in women with PMS or endometriosis, indicating its beneficial effects on menstrual health and related symptoms."
                },
                "Pregnancy Health": {
                  "Summary Papers": "During pregnancy, high-dose vitamin D supplementation has led to reduced doctor visits for acute respiratory infections in early childhood, emphasizing the importance of adequate vitamin D levels for maternal and infant health, potentially leading to long-term health benefits for the child."
                }
              }
            }
          }
        },
        "Immunity": {
          "Summary Papers": "Vitamin D may help strengthen the immune system by lowering infection rates, reducing ICU admissions and mortality in COVID-19, and decreasing respiratory infections in children, highlighting its role in supporting the body’s defenses and managing infections",
          "layer2": {
            "Immune Strengthening": {
              "Summary Papers": "Vitamin D strengthens immunity by reducing infection rates in mother-infant pairs, lowering non-influenza viral infections in children, and significantly cutting down the incidence of acute respiratory infections, showcasing its crucial role in immune system enhancement.",
              "layer3": {}
            },
            "Infection Management": {
              "Summary Papers": "Vitamin D plays a significant role in infection management by reducing ICU admissions and mortality rates in COVID-19, and significantly decreasing repeated infection rates in children with pneumonia, underscoring its importance in fighting infections and enhancing patient outcomes.",
              "layer3": {
                "COVID-19": {
                  "Summary Papers": "In the management of COVID-19, vitamin D supplementation has been associated with reduced ICU admissions and mortality rates, as well as quicker symptom resolution, suggesting its potential role in supporting the immune response and improving outcomes in COVID-19 patients."
                },
                "Respiratory Infections": {
                  "Summary Papers": "Vitamin D has also shown a significant impact on the management of respiratory infections, with supplementation leading to reduced infection rates, severity, and antibiotic use in various populations, supporting its role in enhancing immune function and infection management."
                }
              }
            }
          }
        },
        "Organ Health": {
          "Summary Papers": "Vitamin D supports organ health by reducing acute otitis media risk, lowering cardiovascular and all-cause mortality, and showing potential benefits for cystic fibrosis-related bone disease and blood pressure regulation, demonstrating its wide-ranging benefits for maintaining organ functionality and health.",
          "layer2": {
            "Ear Health": {
              "Summary Papers": "Vitamin D supplementation significantly lowers the risk of acute otitis media in otitis-prone children, indicating its protective effect on ear health and its potential to reduce the incidence of common ear infections.",
              "layer3": {}
            },
            "Heart & Circulation": {
              "Summary Papers": "Vitamin D may support heart and circulation health by helping reduce cardiovascular mortality, lower blood pressure, and decrease the risk of cardiometabolic disorders, underscoring its role in promoting cardiovascular wellness and preventing disease.",
              "layer3": {}
            },
            "Respiratory Health": {
              "Summary Papers": "Vitamin D may benefit respiratory health by helping prevent cystic fibrosis-related bone disease, suggesting a wider role in supporting respiratory conditions and reducing related complications.",
              "layer3": {}
            }
          }
        },
        "Musculoskeletal Health": {
          "Summary Papers": "Vitamin D may support musculoskeletal health by helping improve fibromyalgia symptoms, promoting muscle repair, and increasing bone mineral density, highlighting its role in maintaining strong muscles and bones and reducing disease risk.",
          "layer2": {
            "Fibromyalgia": {
              "Summary Papers": "For fibromyalgia, vitamin D supplementation leads to significant improvements in pain scores, functional capacities, and quality of life, offering a promising adjunctive treatment for managing symptoms in patients with vitamin D deficiency.",
              "layer3": {}
            },
            "Muscle Tissue": {
              "Summary Papers": "Vitamin D may help support muscle tissue health by promoting repair, regeneration, and hypertrophy, highlighting its importance for muscle recovery and long-term maintenance.",
              "layer3": {}
            },
            "Bones": {
              "Summary Papers": "Vitamin D may support bone health by helping lower parathyroid hormone levels, which can improve calcium metabolism and contribute to stronger, healthier bones.",
              "layer3": {}
            }
          }
        },
        "Mental Health": {
          "Summary Papers": "Vitamin D may support mental well-being by helping reduce symptoms of depression and improving oxidative stress markers in Major Depressive Disorder, suggesting a potential role in mood regulation.",
          "layer2": {
            "Depression": {
              "Summary Papers": "High-dose vitamin D supplementation shows a promising trend towards reducing depression symptoms in patients with Major Depressive Disorder, suggesting its potential as an adjunctive treatment for improving mental health outcomes.",
              "layer3": {}
            }
          }
        },
        "Sleep": {
          "Summary Papers": "Vitamin D improves sleep quality and duration, especially in individuals with poor sleep patterns, highlighting its significance in promoting restorative sleep and overall health.",
          "layer2": {
            "Sleep Quality": {
              "Summary Papers": "Vitamin D significantly improves sleep quality and duration, offering a non-pharmacological approach to enhancing sleep quality and addressing sleep-related issues.",
              "layer3": {}
            },
            "Staying Asleep": {
              "Summary Papers": "Similar to its impact on sleep quality, vitamin D supplementation also aids in maintaining sleep, further emphasizing its role in promoting overall sleep health and well-being.",
              "layer3": {}
            }
          }
        }
      }
    },
    "Vitamin E": {
      "focusAreas": {
        "Longevity": {
          "Summary Papers": "Vitamin E may help support longevity by slowing the progression of Alzheimer’s disease, boosting immune function, and reducing oxidative stress, contributing to healthier aging and improved overall health markers.",
          "layer2": {
            "Disease Management": {
              "Summary Papers": "Vitamin E's impact on disease management is particularly notable in slowing Alzheimer's disease progression, improving endothelial function in diabetes, and reducing oxidative stress, highlighting its therapeutic potential in chronic disease management and contributing to increased lifespan.",
              "layer3": {
                "Neurodegenerative": {
                  "Summary Papers": "Vitamin E has a profound impact on managing neurodegenerative diseases like Alzheimer's, with supplementation leading to delayed disease progression and potentially extending patients' lifespan, highlighting its importance in disease management strategies for longevity."
                },
                "Diabetes": {
                  "Summary Papers": "In the context of diabetes management, vitamin E supplementation has been found to significantly reduce oxidative stress and improve endothelial function in patients, demonstrating its therapeutic potential in mitigating diabetes-related complications."
                }
              }
            },
            "Disease Prevention": {
              "Summary Papers": "Vitamin E contributes to disease prevention by enhancing immune function, lowering inflammation, and reducing oxidative stress, key factors in preventing chronic diseases and supporting long-term health and longevity.",
              "layer3": {}
            }
          }
        },
        "Hormones & Reproduction": {
          "Summary Papers": "Vitamin E supplementation has shown considerable benefits for women dealing with menstrual discomfort and premenstrual syndrome, offering significant relief from pain and improving quality of life, highlighting its role in supporting reproductive health.",
          "layer2": {
            "Women": {
              "Summary Papers": "For women, vitamin E provides substantial relief from menstrual discomfort and cyclic mastalgia, supporting hormonal balance and reproductive health, and offering a non-invasive approach to managing menstrual and premenstrual symptoms.",
              "layer3": {
                "Menstrual Health": {
                  "Summary Papers": "Vitamin E offers significant relief from menstrual discomfort, including dysmenorrhea and cyclic mastalgia, providing women with an effective non-pharmacological option for managing menstrual health and improving overall quality of life in reproductive health."
                }
              }
            }
          }
        },
        "Organ Health": {
          "Summary Papers": "Vitamin E plays a crucial role in organ health by reducing oxidative stress and improving conditions in patients with compromised kidney function, liver disease, and those at risk for cardiovascular events, underscoring its importance in maintaining organ system integrity and function.",
          "layer2": {
            "Kidney Health": {
              "Summary Papers": "In the context of kidney health, vitamin E supplementation has been beneficial for uremic patients on hemodialysis, indicating its potential to alleviate complications associated with compromised kidney function and improve overall organ health.",
              "layer3": {}
            },
            "Heart & Circulation": {
              "Summary Papers": "Vitamin E may support heart and circulation health by helping lower oxidative stress and potentially reducing the risk of venous thromboembolism, highlighting its role in protecting cardiovascular function and promoting healthy circulation.",
              "layer3": {}
            },
            "Liver Health": {
              "Summary Papers": "Vitamin E may help improve liver health in people with nonalcoholic fatty liver disease (NAFLD) by reducing liver fat levels, improving enzyme markers, and lowering signs of fibrosis, highlighting its potential role in managing liver conditions.",
              "layer3": {}
            },
            "Gut Health": {
              "Summary Papers": "Vitamin E may help manage gut health by reducing disease severity in individuals with ulcerative colitis, suggesting a potential role in supporting digestive health through its anti-inflammatory benefits.",
              "layer3": {}
            }
          }
        },
        "Immunity": {
          "Summary Papers": "Vitamin E may help strengthen the immune system by reducing inflammation, enhancing immune response, and potentially protecting against upper respiratory infections in older adults, highlighting its role in supporting the body’s defenses.",
          "layer2": {
            "Immune Strengthening": {
              "Summary Papers": "Vitamin E supplementation enhances immune strengthening in the elderly and healthy individuals by improving immune response, cytokine production, and vaccination response, indicating its vital role in supporting the body's defense system against infections and inflammations.",
              "layer3": {}
            }
          }
        },
        "Skin & Beauty": {
          "Summary Papers": "Tocotrienol, a form of vitamin E, may help increase hair count in thinning areas, highlighting its potential benefits for hair growth and overall skin and hair health.",
          "layer2": {
            "Hair": {
              "Summary Papers": "Tocotrienol forms of vitamin E have been shown to significantly increase visible hair count in balding areas, underlining the nutrient's potential benefits for hair health and its contribution to beauty and dermatological wellness.",
              "layer3": {}
            }
          }
        }
      }
    },
    "Zinc": {
      "focusAreas": {
        "Organ Health": {
          "Summary Papers": "Zinc may support organ health by aiding neurological recovery after stroke, improving metabolic profiles in people with diabetes, boosting hormone levels in those with deficiencies, supporting liver health, and easing symptoms in conditions such as tinnitus and oral mucositis. These wide-ranging effects highlight its role in maintaining healthy organ function and managing chronic conditions.",
          "layer2": {
            "Heart & Circulation": {
              "Summary Papers": "Zinc may support heart and circulation health through its atheroprotective effects and potential to improve brain function after stroke, suggesting a role in both cardiovascular disease prevention and recovery from neurological damage.",
              "layer3": {}
            },
            "Blood Health": {
              "Summary Papers": "Zinc may support blood health by helping improve blood sugar and cholesterol levels in people with type 2 diabetes, highlighting its role in managing metabolic disorders and promoting vascular health.",
              "layer3": {}
            },
            "Kidney Health": {
              "Summary Papers": "Zinc may help support kidney health in hemodialysis patients by improving hormone levels, reducing itching, and potentially lowering inflammation, highlighting its role in maintaining kidney function and enhancing well-being during dialysis.",
              "layer3": {}
            },
            "Liver Health": {
              "Summary Papers": "Zinc's positive impact on liver health is evident through its ability to improve conditions in individuals with liver cirrhosis, suggesting zinc's potential in supporting liver function and overall organ health.",
              "layer3": {}
            },
            "Oral Health": {
              "Summary Papers": "Zinc supplementation contributes to oral health by significantly reducing plaque formation in children and alleviating the severity of oral mucositis in cancer patients undergoing radiotherapy, indicating its beneficial effects in dental care and as an adjunctive treatment in oncology.",
              "layer3": {}
            },
            "Ear Health": {
              "Summary Papers": "Zinc plays a significant role in ear health by significantly reducing self-reported symptoms in individuals with tinnitus, suggesting its potential therapeutic benefits in managing auditory conditions.",
              "layer3": {}
            }
          }
        },
        "Cognitive Performance": {
          "Summary Papers": "Zinc may help support brain health by improving focus, memory, and recognition abilities, particularly in adolescents, highlighting its role in promoting cognitive performance.",
          "layer2": {
            "Focus": {
              "Summary Papers": "Zinc may help improve focus in adolescents, underscoring its role in supporting cognitive performance and attention span.",
              "layer3": {}
            },
            "Reaction Time": {
              "Summary Papers": "Zinc may help enhance cognitive performance by improving reaction times, particularly in tasks that require quick responses, highlighting its role in supporting cognitive health and function.",
              "layer3": {}
            },
            "Memory": {
              "Summary Papers": "Zinc may support cognitive development and performance by enhancing memory in adolescent girls, highlighting the importance of adequate dietary intake for optimal cognitive abilities.",
              "layer3": {}
            }
          }
        },
        "Fitness": {
          "Summary Papers": "Zinc may help maintain hormone levels during intense exercise, supporting endurance, muscle recovery, and overall physical performance. Its role in boosting antioxidant activity and managing exercise-induced stress further highlights its benefits for athletic performance and recovery.",
          "layer2": {
            "Endurance": {
              "Summary Papers": "Zinc may help support endurance in athletes by keeping hormone levels stable during intense activity, underscoring its role in sports nutrition for optimizing performance and energy metabolism.",
              "layer3": {}
            },
            "Strength & Power": {
              "Summary Papers": "Zinc may help athletes maintain essential hormone levels during intense training, supporting peak performance and muscle function in strength and power activities.",
              "layer3": {}
            },
            "Recovery": {
              "Summary Papers": "Zinc may support fitness recovery by boosting antioxidant activity in athletes, helping reduce oxidative stress and promote muscle repair after intense physical activity.",
              "layer3": {}
            }
          }
        },
        "Hormones & Reproduction": {
          "Summary Papers": "Zinc may support hormone regulation and reproductive health by helping maintain testosterone levels, improving sperm count, easing PMS symptoms, and normalizing serum leptin levels, highlighting its role in promoting hormonal balance for both men and women.",
          "layer2": {
            "Men": {
              "Summary Papers": "Zinc plays a pivotal role in enhancing men's hormonal health, notably maintaining testosterone and thyroid hormone levels during physical stress, and improving sperm quality and hormone levels in infertile men, demonstrating its essential role in male reproductive health and athletic performance.",
              "layer3": {
                "Testosterone": {
                  "Summary Papers": "Zinc has a pronounced effect on men's testosterone levels, particularly benefiting athletes and infertile men by maintaining hormonal balance during physical stress and improving sperm quality, underscoring its importance in male reproductive health."
                },
                "Sperm Health": {
                  "Summary Papers": "Zinc supplementation in infertile men leads to significant improvements in sperm count and dihydrotestosterone levels, highlighting zinc's critical role in enhancing male fertility and hormone function."
                }
              }
            },
            "Women": {
              "Summary Papers": "For women, zinc supplementation has shown significant benefits in alleviating premenstrual syndrome symptoms, improving life quality, and reducing inflammation and oxidative stress, highlighting zinc's importance in female hormonal balance and well-being.",
              "layer3": {
                "Menstrual Health": {
                  "Summary Papers": "For women dealing with premenstrual syndrome, zinc supplementation has been proven to significantly alleviate PMS symptoms and improve quality of life, indicating its beneficial impact on menstrual health."
                }
              }
            },
            "General Hormone Health": {
              "Summary Papers": "Zinc's ability to normalize serum leptin concentrations without affecting body fat suggests its critical role in regulating appetite and metabolism, underpinning its impact on general hormone health and body weight management.",
              "layer3": {
                "Leptin": {
                  "Summary Papers": "Zinc plays a vital role in regulating leptin, a key hormone in appetite and metabolism control, with supplementation normalizing serum leptin concentrations in deficient individuals, showcasing its importance in hormone health."
                }
              }
            }
          }
        },
        "Longevity": {
          "Summary Papers": "Zinc may support longevity by improving metabolic profiles, boosting antioxidant activity, aiding glucose metabolism, and enhancing mood and neurological function, highlighting its potential to promote healthier aging through disease prevention and better metabolic health.",
          "layer2": {
            "Disease Prevention": {
              "Summary Papers": "Zinc contributes to longevity and disease prevention by improving antioxidant activity, reducing inflammation, and enhancing metabolic health, which are key factors in preventing chronic diseases and promoting a healthier, longer life.",
              "layer3": {}
            },
            "Weight Management": {
              "Summary Papers": "Zinc may aid in weight management by improving glucose metabolism and reducing inflammation in obese adolescents, highlighting its potential to address obesity-related health issues and support long-term health",
              "layer3": {}
            },
            "Disease Management": {
              "Summary Papers": "Zinc's impact on disease management is evident in its ability to partially restore zinc levels and increase IGF-1 in diabetic subjects, indicating its role in improving metabolic health and managing chronic conditions.",
              "layer3": {
                "Diabetes": {
                  "Summary Papers": "In diabetes management within the context of longevity, zinc supplementation in deficient type II diabetic subjects led to partial restoration of zinc levels and increased IGF-1, suggesting its potential in managing diabetes-related complications."
                }
              }
            }
          }
        },
        "Immunity": {
          "Summary Papers": "Zinc may help strengthen the immune system by reducing the duration and severity of common cold symptoms and boosting defenses against respiratory infections, highlighting its potential as both a preventive and supportive nutrient for infection management.",
          "layer2": {
            "Infection Management": {
              "Summary Papers": "For infection management, zinc significantly reduces the duration and severity of common cold symptoms, showcasing its potent antiviral effects and immune-boosting properties.",
              "layer3": {
                "Common Cold": {
                  "Summary Papers": "Zinc lozenges significantly reduce the duration and severity of common cold symptoms, highlighting zinc's effectiveness in infection management and its role in bolstering the immune response to cold viruses."
                }
              }
            },
            "Immune Strengthening": {
              "Summary Papers": "Zinc supplementation significantly decreases infection rates in elderly subjects with low baseline levels, demonstrating its effectiveness in strengthening the immune system and preventing infections.",
              "layer3": {}
            }
          }
        },
        "Skin & Beauty": {
          "Summary Papers": "Zinc may help improve skin health by reducing symptoms of acne, warts, and psoriasis, highlighting its potential in managing various skin conditions and its role in supporting overall skin appearance and dermatological care.",
          "layer2": {
            "Skin Health": {
              "Summary Papers": "Zinc's beneficial effects on skin health include treating viral warts, reducing acne symptoms, and improving psoriasis conditions, highlighting its versatile role in dermatological health and beauty.",
              "layer3": {
                "Acne": {
                  "Summary Papers": "For acne management, zinc has shown significant effectiveness in reducing symptoms of inflammatory acne, making it a viable option for improving skin health and addressing acne-related issues."
                }
              }
            }
          }
        },
        "Mental Health": {
          "Summary Papers": "Zinc may help improve mental health by reducing depressive symptoms and supporting mood and cognitive function, suggesting its potential as a complementary approach in managing depression and related conditions.",
          "layer2": {
            "Depression": {
              "Summary Papers": "In addressing depression, zinc supplementation, whether as monotherapy or in conjunction with antidepressant treatment, has shown to improve depressive symptoms and increase serum BDNF levels, underscoring its potential as a valuable adjunct in mental health management.",
              "layer3": {}
            },
            "Disease Specific": {
              "Summary Papers": "Zinc supplementation has shown to marginally improve symptoms in patients with obsessive-compulsive disorder (OCD) when added to standard fluoxetine treatment, indicating its potential role in enhancing the therapeutic effects of psychiatric medication.",
              "layer3": {
                "OCD": {
                  "Summary Papers": "In treating Obsessive-Compulsive Disorder (OCD), zinc supplementation alongside conventional treatment has resulted in modest symptom relief, suggesting its adjunctive potential in specific mental health conditions."
                }
              }
            }
          }
        }
      }
    }
  }
  


/* finalDataExaminDict lives in final-data-examin-dict.js (loaded only where needed). */


const fetchDataSupplement = {
    "Ashwagandha": {"dose": "450", "featuredImageUrl": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/ashwagandha_300x300.png?v=1705477891" , "price": "26.0 SGD", "tags": "Cognitive Performance, Cognitive Performance - Reaction Time, Fitness, Fitness - Endurance, Fitness - Recovery, Fitness - Strength & Power, Hormones & Reproduction, Hormones & Reproduction - General Hormone Health, Hormones & Reproduction - General Hormone Health - Cortisol, Hormones & Reproduction - Men, Hormones & Reproduction - Men - Sperm Health, Hormones & Reproduction - Men - Testosterone, Hormones & Reproduction - Women, Hormones & Reproduction - Women - Sexual Health, Immunity, Immunity - Immune Strengthening, Longevity, Longevity - Disease Management, Longevity - Disease Management - Cancer, Longevity - Disease Management - Diabetes, Longevity - Disease Prevention, Longevity - Energy, Mental Health, Mental Health - Anxiety, Mental Health - Depression, Mental Health - Disease Specific, Mental Health - Disease Specific - Bipolar Disorder, Mental Health - Disease Specific - OCD, Mental Health - Mood Improvement, Mental Health - Stress, Musculoskeletal Health, Musculoskeletal Health - Joints, Sleep, Sleep - Falling Asleep, Sleep - Sleep Quality", "unit": "mg", "variantId": "46344351842595"},
    "Biotin": {"dose":"10000", "featuredImageUrl": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/biotin_300x300.png?v=1705478035", "price": "18.0 SGD" , "tags": "Longevity, Longevity - Disease Management, Longevity - Disease Management - Diabetes, Organ Health, Organ Health - Heart & Circulation, Skin & Beauty, Skin & Beauty - Nails" , "unit": "mcg", "variantId": "45228380553507"},
    "Calcium": {"dose": "500", "featuredImageUrl": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/calcium_300x300.png?v=1705478112", "price": "18.0 SGD", "tags": "Hormones & Reproduction, Hormones & Reproduction - Women, Hormones & Reproduction - Women - Menstrual Health, Hormones & Reproduction - Women - Menstrual Health - PMS, Hormones & Reproduction - Women - Pregnancy Health, Hormones & Reproduction - Women - Pregnancy Health - Infant Health, Hormones & Reproduction - Women - Pregnancy Health - Pre-Eclampsia, Hormones & Reproduction - Women - Pregnancy Health - Pre-Term Birth, Musculoskeletal Health, Musculoskeletal Health - Bones, Organ Health, Organ Health - Gut Health, Organ Health - Heart & Circulation", "unit": "mg", "variantId": "45228449628451"},
    "CoQ10": {"dose": "200", "featuredImageUrl": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/coq10_300x300.png?v=1705478199", "price": "42.0 SGD", "tags":  "Fitness, Fitness - Endurance, Fitness - Recovery, Hormones & Reproduction, Hormones & Reproduction - Men, Hormones & Reproduction - Men - Peyronie's Disease, Hormones & Reproduction - Men - Reproduction, Hormones & Reproduction - Men - Sperm Health, Hormones & Reproduction - Women, Hormones & Reproduction - Women - Pregnancy Health, Hormones & Reproduction - Women - Pregnancy Health - Pre-Eclampsia, Hormones & Reproduction - Women - Reproductive Health, Hormones & Reproduction - Women - Reproductive Health - Disease Management, Longevity, Longevity - Disease Management, Longevity - Disease Management - Diabetes, Longevity - Disease Management - Neurodegenerative, Longevity - Disease Management - Neurodegenerative - Multiple Sclerosis, Longevity - Disease Prevention, Longevity - Energy, Mental Health, Mental Health - Depression, Mental Health - Disease Specific, Mental Health - Disease Specific - Bipolar Disorder, Mental Health - Mood Improvement, Musculoskeletal Health, Musculoskeletal Health - Fibromyalgia, Organ Health, Organ Health - Brain Health, Organ Health - Brain Health - Migraines, Organ Health - Eye Health, Organ Health - Heart & Circulation, Skin & Beauty, Skin & Beauty - Skin Health, Skin & Beauty - Skin Health - Wrinkles", "unit": "mg", "variantId": "45273943048483"},
    "Folic Acid": {"dose": "400", "featuredImageUrl": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/folic_acid_300x300.png?v=1705478231", "price": "17.0 SGD" , "tags": "Longevity, Longevity - Disease Prevention, Longevity - Disease Prevention - Diabetes, Mental Health, Mental Health - Depression, Mental Health - Disease Specific, Mental Health - Disease Specific - Schizophrenia, Organ Health, Organ Health - Heart & Circulation", "unit": "mcg", "variantId": "45273937936675"},
    "Iron": {"dose": "65", "featuredImageUrl": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/iron_300x300.png?v=1705478333", "price": "12.0 SGD", "tags": "Cognitive Performance, Cognitive Performance - Fatigue, Cognitive Performance - Focus, Cognitive Performance - Memory, Fitness, Fitness - Endurance, Hormones & Reproduction, Hormones & Reproduction - Women, Hormones & Reproduction - Women - Menstrual Health, Hormones & Reproduction - Women - Pregnancy Health, Hormones & Reproduction - Women - Pregnancy Health - Infant Health, Longevity, Longevity - Energy, Mental Health, Mental Health - Stress, Musculoskeletal Health, Musculoskeletal Health - Fibromyalgia, Organ Health, Organ Health - Blood Health, Organ Health - Brain Health, Organ Health - Heart & Circulation", "unit": "mg", "variantId": "46344472690979" },
    "Magnesium": {"dose": "400", "featuredImageUrl": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/magnesium_300x300.png?v=1705478364", "price": "21.0 SGD" , "tags": "Fitness, Fitness - Endurance, Fitness - Recovery, Fitness - Strength & Power, Hormones & Reproduction, Hormones & Reproduction - Women, Hormones & Reproduction - Women - Menstrual Health, Hormones & Reproduction - Women - Menstrual Health - PMS, Hormones & Reproduction - Women - Reproductive Health, Hormones & Reproduction - Women - Reproductive Health - Disease Management, Longevity, Longevity - Disease Management, Longevity - Disease Management - Diabetes, Longevity - Disease Prevention, Longevity - Disease Prevention - Diabetes, Longevity - Energy, Longevity - Weight Management, Mental Health, Mental Health - Anxiety, Mental Health - Depression, Mental Health - Stress, Musculoskeletal Health, Musculoskeletal Health - Bones, Musculoskeletal Health - Fibromyalgia, Organ Health, Organ Health - Blood Health, Organ Health - Brain Health, Organ Health - Brain Health - Migraines, Organ Health - Ear Health, Organ Health - Heart & Circulation, Organ Health - Kidney Health, Organ Health - Respiratory Health, Sleep, Sleep - Falling Asleep, Sleep - Sleep Quality", "unit": "mg" , "variantId": "45228481675555"},
    "Omega 3": {"dose": "1920", "featuredImageUrl": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/omega3_300x300.png?v=1705478398" , "price": "27.0 SGD" , "tags": "Cognitive Performance, Cognitive Performance - Focus, Cognitive Performance - Memory, Cognitive Performance - Reaction Time, Fitness, Fitness - Body Fat, Fitness - Endurance, Fitness - Fat Loss, Fitness - Recovery, Hormones & Reproduction, Hormones & Reproduction - Women, Hormones & Reproduction - Women - Menstrual Health, Hormones & Reproduction - Women - Menstrual Health - PMS, Hormones & Reproduction - Women - Pregnancy Health, Hormones & Reproduction - Women - Pregnancy Health - Infant Health, Hormones & Reproduction - Women - Reproductive Health, Hormones & Reproduction - Women - Reproductive Health - Disease Management, Immunity, Immunity - Immune Strengthening, Longevity, Longevity - Disease Management, Longevity - Disease Management - Autoimmune Diseases, Longevity - Disease Management - Autoimmune Diseases - Lupus, Longevity - Disease Management - Cancer, Longevity - Disease Management - Diabetes, Longevity - Disease Prevention, Longevity - Disease Prevention - Diabetes, Longevity - Energy, Longevity - Weight Management, Mental Health, Mental Health - Anxiety, Mental Health - Depression, Mental Health - Disease Specific, Mental Health - Disease Specific - ADHD, Mental Health - Disease Specific - Bipolar Disorder, Mental Health - Disease Specific - Schizophrenia, Mental Health - Mood Improvement, Mental Health - Stress, Organ Health, Organ Health - Blood Health, Organ Health - Brain Health, Organ Health - Brain Health - Migraines, Organ Health - Eye Health, Organ Health - Heart & Circulation, Organ Health - Kidney Health, Organ Health - Respiratory Health, Skin & Beauty, Skin & Beauty - Skin Health, Sleep, Sleep - Falling Asleep, Sleep - Sleep Quality", "unit": "mg" , "variantId": "45279370019107" },
    "Probiotics": {"dose": "136", "featuredImageUrl": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/probiotic_300x300.png?v=1705478456", "price": "48.0 SGD", "tags": "Organ Health, Organ Health - Gut Health", "unit": "mg" , "variantId": "46344468168995"},
    "Vitamin B12": {"dose": "1000", "featuredImageUrl": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/b12_300x300.png?v=1705478491", "price": "11.0 SGD", "tags": "Organ Health, Organ Health - Heart & Circulation", "unit": "mcg" , "variantId": "45228442288419" },
    "Vitamin B2": {"dose": "100", "featuredImageUrl": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/b2_300x300.png?v=1705478524", "price": "18.0 SGD", "tags": "Organ Health, Organ Health - Brain Health, Organ Health - Brain Health - Migraines, Organ Health - Heart & Circulation", "unit": "mg", "variantId": "45273972375843"},
    "Vitamin B6": {"dose": "200", "featuredImageUrl": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/b6_300x300.png?v=1705478573", "price": "18.0 SGD", "tags": "Fitness, Fitness - Endurance, Fitness - Recovery, Hormones & Reproduction, Hormones & Reproduction - Women, Hormones & Reproduction - Women - Menstrual Health, Hormones & Reproduction - Women - Menstrual Health - PMS, Hormones & Reproduction - Women - Reproduction, Sleep, Sleep - Sleep Quality", "unit": "mg", "variantId": "45273994625315"},
    "Vitamin C": {"dose": "1000", "featuredImageUrl": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/c_300x300.png?v=1705478623", "price": "13.0 SGD", "tags": "Cognitive Performance, Cognitive Performance - Fatigue, Fitness, Fitness - Endurance, Fitness - Recovery, Hormones & Reproduction, Hormones & Reproduction - General Hormone Health, Hormones & Reproduction - General Hormone Health - Cortisol, Hormones & Reproduction - Men, Hormones & Reproduction - Men - Sperm Health, Hormones & Reproduction - Women, Hormones & Reproduction - Women - Reproductive Health, Hormones & Reproduction - Women - Reproductive Health - Disease Management, Hormones & Reproduction - Women - Sexual Health, Immunity, Immunity - Immune Strengthening, Immunity - Infection Management, Immunity - Infection Management - Common Cold, Longevity, Longevity - Disease Management, Longevity - Disease Management - Diabetes, Longevity - Disease Prevention, Longevity - DNA Health, Longevity - Weight Management, Mental Health, Mental Health - Depression, Musculoskeletal Health, Musculoskeletal Health - Bones, Organ Health, Organ Health - Blood Health, Organ Health - Heart & Circulation, Organ Health - Respiratory Health", "unit": "mg", "variantId": "45228434882851"},
    "Vitamin D": {"dose": "125", "featuredImageUrl": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/d_300x300.png?v=1705478658", "price": "13.0 SGD", "tags": "Fitness, Fitness - Fat Loss, Fitness - Muscle Mass, Fitness - Recovery, Fitness - Strength & Power, Hormones & Reproduction, Hormones & Reproduction - Men, Hormones & Reproduction - Men - Testosterone, Hormones & Reproduction - Women, Hormones & Reproduction - Women - Menstrual Health, Hormones & Reproduction - Women - Menstrual Health - dysmenorrhea, Hormones & Reproduction - Women - Menstrual Health - PMS, Hormones & Reproduction - Women - Pregnancy Health, Hormones & Reproduction - Women - Pregnancy Health - Infant Health, Immunity, Immunity - Immune Strengthening, Immunity - Infection Management, Immunity - Infection Management - COVID-19, Immunity - Infection Management - Respiratory Infections, Longevity, Longevity - Disease Management, Longevity - Disease Management - Cancer, Longevity - Disease Management - Diabetes, Longevity - Disease Management - Neurodegenerative, Longevity - Disease Management - Neurodegenerative - Alzheimer’s, Longevity - Disease Management - Neurodegenerative - Multiple Sclerosis, Longevity - Disease Prevention, Longevity - Disease Prevention - Cancer, Longevity - Disease Prevention - Diabetes, Longevity - Weight Management, Mental Health, Mental Health - Depression, Musculoskeletal Health, Musculoskeletal Health - Bones, Musculoskeletal Health - Fibromyalgia, Musculoskeletal Health - Muscle Tissue, Organ Health, Organ Health - Ear Health, Organ Health - Heart & Circulation, Organ Health - Respiratory Health, Sleep, Sleep - Sleep Quality, Sleep - Staying Asleep", "unit": "mcg", "variantId": "45228426920227"},
    "Vitamin E": {"dose": "360", "featuredImageUrl": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/e_300x300.png?v=1705478699", "price": "18.0 SGD", "tags": "Hormones & Reproduction, Hormones & Reproduction - Women, Hormones & Reproduction - Women - Menstrual Health, Hormones & Reproduction - Women - Menstrual Health - Cyclic Mastalgia, Hormones & Reproduction - Women - Menstrual Health - Dysmenorrhea, Hormones & Reproduction - Women - Menstrual Health - PMS, Immunity, Immunity - Immune Strengthening, Longevity, Longevity - Disease Management, Longevity - Disease Management - Diabetes, Longevity - Disease Management - Neurodegenerative, Longevity - Disease Management - Neurodegenerative - Alzheimer’s, Longevity - Disease Prevention, Organ Health, Organ Health - Gut Health, Organ Health - Heart & Circulation, Organ Health - Kidney Health, Organ Health - Liver Health, Skin & Beauty, Skin & Beauty - Hair", "unit": "mg", "variantId": "46344354890019"},
    "Zinc": {"dose":"50", "featuredImageUrl": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/zinc_300x300.png?v=1705478725", "price": "12.0 SGD", "tags": "Cognitive Performance, Cognitive Performance - Focus, Cognitive Performance - Memory, Cognitive Performance - Reaction Time, Fitness, Fitness - Endurance, Fitness - Recovery, Fitness - Strength & Power, Hormones & Reproduction, Hormones & Reproduction - General Hormone Health, Hormones & Reproduction - General Hormone Health - Leptin, Hormones & Reproduction - Men, Hormones & Reproduction - Men - Sperm Health, Hormones & Reproduction - Men - Testosterone, Hormones & Reproduction - Women, Hormones & Reproduction - Women - Menstrual Health, Hormones & Reproduction - Women - Menstrual Health - PMS, Immunity, Immunity - Immune Strengthening, Immunity - Infection Management, Immunity - Infection Management - Common Cold, Longevity, Longevity - Disease Management, Longevity - Disease Management - Diabetes, Longevity - Disease Prevention, Longevity - Weight Management, Mental Health, Mental Health - Depression, Mental Health - Disease Specific, Mental Health - Disease Specific - OCD, Organ Health, Organ Health - Blood Health, Organ Health - Ear Health, Organ Health - Heart & Circulation, Organ Health - Kidney Health, Organ Health - Liver Health, Organ Health - Oral Health, Skin & Beauty, Skin & Beauty - Skin Health, Skin & Beauty - Skin Health - Acne", "unit": "mg", "variantId": "45279520850211" }
};





const priceSupplementsConverted = {
  "Ashwagandha": {
    SGD: 33,
    AUD: 36,
    MYR: 102,
    IDR: 429000,
    HKD: 199,
    DEFAULT: 33
  },
  "Biotin": {
    SGD: 23,
    AUD: 26,
    MYR: 70,
    IDR: 299000,
    HKD: 138,
    DEFAULT: 23
  },
  "Calcium": {
     SGD: 23,
    AUD: 26,
    MYR: 70,
    IDR: 299000,
    HKD: 138,
    DEFAULT: 23
  },
  "CoQ10": {
    SGD: 53,
    AUD: 60,
    MYR: 164,
    IDR: 699000,
    HKD: 322,
    DEFAULT: 53
  },
  "Folic Acid": {
    SGD: 21,
    AUD: 24,
    MYR: 67,
    IDR: 280000,
    HKD: 130,
    DEFAULT: 21
  },
  "Iron": {
    SGD: 15,
    AUD: 17,
    MYR: 47,
    IDR: 199000,
    HKD: 92,
    DEFAULT: 15
  },
  "Magnesium": {
    SGD: 26,
    AUD: 29,
    MYR: 82,
    IDR: 349000,
    HKD: 161,
    DEFAULT: 26
  },
  "Omega 3": {
    SGD: 34,
    AUD: 38,
    MYR: 106,
    IDR: 445000,
    HKD: 207,
    DEFAULT: 34
  },
  "Probiotics": {
    SGD: 60,
    AUD: 69,
    MYR: 188,
    IDR: 790000,
    HKD: 368,
    DEFAULT: 60
  },
  "Vitamin B12": {
    SGD: 14,
    AUD: 16,
    MYR: 43,
    IDR: 180000,
    HKD: 84,
    DEFAULT: 14
  },
  "Vitamin B2": {
    SGD: 23,
    AUD: 26,
    MYR: 70,
    IDR: 299000,
    HKD: 138,
    DEFAULT: 23
  },
  "Vitamin B6": {
    SGD: 23,
    AUD: 26,
    MYR: 70,
    IDR: 299000,
    HKD: 138,
    DEFAULT: 23
  },
  "Vitamin C": {
    SGD: 16,
    AUD: 19,
    MYR: 51,
    IDR: 215000,
    HKD: 100,
    DEFAULT: 16
  },
  "Vitamin D": {
    SGD: 16,
    AUD: 19,
    MYR: 51,
    IDR: 215000,
    HKD: 100,
    DEFAULT: 16
  },
  "Vitamin E": {
    SGD: 23,
    AUD: 26,
    MYR: 70,
    IDR: 299000,
    HKD: 138,
    DEFAULT: 23
  },
  "Zinc": {
    SGD: 15,
    AUD: 15,
    MYR: 47,
    IDR: 199000,
    HKD: 92,
    DEFAULT: 15
  }
};

  const categoryLabel = {
    "Ashwagandha": "ADAPTOGENS",
    "Biotin": "FUNCTIONAL COMPOUNDS",
    "Calcium": "MINERALS",
    "CoQ10": "FUNCTIONAL COMPOUNDS",
    "Folic Acid": "VITAMINS",
    "Iron": "MINERALS",
    "Magnesium": "MINERALS",
    "Omega 3": "FUNCTIONAL COMPOUNDS",
    "Probiotics": "PROBIOTICS",
    "Vitamin B12": "VITAMINS",
    "Vitamin B2": "VITAMINS",
    "Vitamin B6": "VITAMINS",
    "Vitamin C": "VITAMINS",
    "Vitamin D": "VITAMINS",
    "Vitamin E": "VITAMINS",
    "Zinc": "MINERALS",
    "The Sleep Protocol": "SLEEP SOLUTION",
    "The Energy Protocol": "ENERGY STACK",
    "The Fitness Protocol": "ATHLETE STACK",
  };


const priceBoxes = {
  "Energy": {
    SGD: priceSupplementsConverted["CoQ10"].SGD + priceSupplementsConverted["Omega 3"].SGD + priceSupplementsConverted["Vitamin B12"].SGD + priceSupplementsConverted["Vitamin B2"].SGD,
    AUD: priceSupplementsConverted["CoQ10"].AUD + priceSupplementsConverted["Omega 3"].AUD + priceSupplementsConverted["Vitamin B12"].AUD + priceSupplementsConverted["Vitamin B2"].AUD,
    MYR: priceSupplementsConverted["CoQ10"].MYR + priceSupplementsConverted["Omega 3"].MYR + priceSupplementsConverted["Vitamin B12"].MYR + priceSupplementsConverted["Vitamin B2"].MYR,
    IDR: priceSupplementsConverted["CoQ10"].IDR + priceSupplementsConverted["Omega 3"].IDR + priceSupplementsConverted["Vitamin B12"].IDR + priceSupplementsConverted["Vitamin B2"].IDR,
    HKD: priceSupplementsConverted["CoQ10"].HKD + priceSupplementsConverted["Omega 3"].HKD + priceSupplementsConverted["Vitamin B12"].HKD + priceSupplementsConverted["Vitamin B2"].HKD,
    DEFAULT: priceSupplementsConverted["CoQ10"].DEFAULT + priceSupplementsConverted["Omega 3"].DEFAULT + priceSupplementsConverted["Vitamin B12"].DEFAULT + priceSupplementsConverted["Vitamin B2"].DEFAULT
  },
  "Sleep": {
    SGD: priceSupplementsConverted["Ashwagandha"].SGD + priceSupplementsConverted["Magnesium"].SGD + priceSupplementsConverted["Omega 3"].SGD + priceSupplementsConverted["Vitamin B6"].SGD,
    AUD: priceSupplementsConverted["Ashwagandha"].AUD + priceSupplementsConverted["Magnesium"].AUD + priceSupplementsConverted["Omega 3"].AUD + priceSupplementsConverted["Vitamin B6"].AUD,
    MYR: priceSupplementsConverted["Ashwagandha"].MYR + priceSupplementsConverted["Magnesium"].MYR + priceSupplementsConverted["Omega 3"].MYR + priceSupplementsConverted["Vitamin B6"].MYR,
    IDR: priceSupplementsConverted["Ashwagandha"].IDR + priceSupplementsConverted["Magnesium"].IDR + priceSupplementsConverted["Omega 3"].IDR + priceSupplementsConverted["Vitamin B6"].IDR,
    HKD: priceSupplementsConverted["Ashwagandha"].HKD + priceSupplementsConverted["Magnesium"].HKD + priceSupplementsConverted["Omega 3"].HKD + priceSupplementsConverted["Vitamin B6"].HKD,
    DEFAULT: priceSupplementsConverted["Ashwagandha"].DEFAULT + priceSupplementsConverted["Magnesium"].DEFAULT + priceSupplementsConverted["Omega 3"].DEFAULT + priceSupplementsConverted["Vitamin B6"].DEFAULT
  },
  "Fitness": {
    SGD: priceSupplementsConverted["Ashwagandha"].SGD + priceSupplementsConverted["Magnesium"].SGD + priceSupplementsConverted["Vitamin C"].SGD + priceSupplementsConverted["Zinc"].SGD,
    AUD: priceSupplementsConverted["Ashwagandha"].AUD + priceSupplementsConverted["Magnesium"].AUD + priceSupplementsConverted["Vitamin C"].AUD + priceSupplementsConverted["Zinc"].AUD,
    MYR: priceSupplementsConverted["Ashwagandha"].MYR + priceSupplementsConverted["Magnesium"].MYR + priceSupplementsConverted["Vitamin C"].MYR + priceSupplementsConverted["Zinc"].MYR,
    IDR: priceSupplementsConverted["Ashwagandha"].IDR + priceSupplementsConverted["Magnesium"].IDR + priceSupplementsConverted["Vitamin C"].IDR + priceSupplementsConverted["Zinc"].IDR,
    HKD: priceSupplementsConverted["Ashwagandha"].HKD + priceSupplementsConverted["Magnesium"].HKD + priceSupplementsConverted["Vitamin C"].HKD + priceSupplementsConverted["Zinc"].HKD,
    DEFAULT: priceSupplementsConverted["Ashwagandha"].DEFAULT + priceSupplementsConverted["Magnesium"].DEFAULT + priceSupplementsConverted["Vitamin C"].DEFAULT + priceSupplementsConverted["Zinc"].DEFAULT
  }
};



const supplementDescriptions = {
  "Acetyl L-Carnitine": {
    "title": "Brain Fuel",
    "description": "An amino acid derivative that shuttles fatty acids into cells for energy, supporting cognitive function and mental clarity."
  },
  "Alpha GPC": {
    "title": "Focus Former",
    "description": "A choline compound that supports acetylcholine production in the brain, linked to sharper focus and memory."
  },
  "Apigenin": {
    "title": "Sleep Soother",
    "description": "A plant-derived flavonoid with calming properties, commonly used to support relaxation and sleep quality."
  },
  "Ashwagandha": {
    "title": "Calm in a Capsule",
    "description": "An ancient herb known for balancing body systems, often used in traditional medicine for its calming effects."
  },
  "Berberine": {
    "title": "Sugar Stabiliser",
    "description": "A bioactive compound found in several plants, known for supporting healthy blood sugar levels and metabolic function."
  },
  "Biotin": {
    "title": "Beauty Booster",
    "description": "A B-vitamin that aids in processing fats and carbs, key to maintaining cellular health."
  },
  "Calcium": {
    "title": "Bone Builder",
    "description": "Essential mineral for bone structure and teeth strength, also supports muscle and nerve function."
  },
  "CoQ10": {
    "title": "Energy Enabler",
    "description": "A natural compound that aids energy production in cells, especially in heart and muscles."
  },
  "Curcumin": {
    "title": "Golden Guard",
    "description": "The active compound in turmeric, widely studied for its potent anti-inflammatory and antioxidant properties."
  },
  "Folic Acid": {
    "title": "Cell Builder",
    "description": "A B-vitamin essential for forming DNA and cell growth, especially important in cell division."
  },
  "Inositol": {
    "title": "Balance Booster",
    "description": "A naturally occurring sugar alcohol that supports hormonal balance, mood regulation, and insulin signalling."
  },
  "Iron": {
    "title": "Oxygen Mover",
    "description": "A key mineral that helps transport oxygen through the blood and plays a role in cellular energy."
  },
  "L-Theanine": {
    "title": "Zen Compound",
    "description": "An amino acid found naturally in tea leaves that promotes calm alertness without drowsiness."
  },
  "L-Tyrosine": {
    "title": "Mental Mover",
    "description": "A precursor to dopamine and noradrenaline, supporting cognitive performance and focus under stress."
  },
  "Magnesium": {
    "title": "Muscle Magic",
    "description": "An essential mineral involved in over 300 body processes, including muscle and nerve function."
  },
  "Omega 3": {
    "title": "Fatty Friend",
    "description": "Essential fats found in fish and seeds, crucial for cell structure and brain function."
  },
  "Probiotics": {
    "title": "Gut Guardians",
    "description": "Live bacteria that support the natural balance of your digestive system's microflora."
  },
  "Resveratrol": {
    "title": "Age Ally",
    "description": "A polyphenol found in red grapes and berries, associated with antioxidant protection and cellular longevity."
  },
  "Rhodiola Rosea": {
    "title": "Stress Shield",
    "description": "An adaptogenic herb traditionally used to reduce fatigue and help the body adapt to physical and mental stress."
  },
  "Tongkat Ali": {
    "title": "Vitality Vanguard",
    "description": "A Southeast Asian root extract linked to supporting testosterone levels, physical energy, and male vitality."
  },
  "Vitamin B12": {
    "title": "Energy Essential",
    "description": "Vital for making DNA and red blood cells, it helps keep the nervous system running smoothly."
  },
  "Vitamin B2": {
    "title": "Cell Charger",
    "description": "A B-vitamin that aids in energy production and cellular repair through metabolism of carbs, fats, and proteins."
  },
  "Vitamin B6": {
    "title": "Metabolism Mover",
    "description": "Supports brain and nervous system function, helping the body metabolize amino acids and other nutrients."
  },
  "Vitamin C": {
    "title": "Immunity Icon",
    "description": "A water-soluble vitamin important for collagen formation, helping protect cells from oxidative stress."
  },
  "Vitamin D": {
    "title": "Sunshine Vitamin",
    "description": "Produced in skin exposed to sunlight, it helps the body absorb calcium for healthy bones."
  },
  "Vitamin E": {
    "title": "Cell Protector",
    "description": "An antioxidant that protects cell membranes from damage caused by free radicals."
  },
  "Zinc": {
    "title": "Immunity Insider",
    "description": "A trace mineral crucial for immune function, wound healing, and protein synthesis."
  }
};


  const supplementDescriptionsPopup = {
    "Ashwagandha": {
      "title": "Calm in a Capsule",
      "description": "An ancient herb known for balancing body systems, often used in traditional medicine for its calming effects."
    },
    "Biotin": {
      "title": "Beauty Booster",
      "description": "A B-vitamin that aids in processing fats and carbs, key to maintaining cellular health."
    },
    "Calcium": {
      "title": "Bone Builder",
      "description": "Essential mineral for bone structure and teeth strength, also supports muscle and nerve function."
    },
    "CoQ10": {
      "title": "Energy Enabler",
      "description": "A natural compound that aids energy production in cells, especially in heart and muscles."
    },
    "Folic Acid": {
      "title": "Cell Builder",
      "description": "A B-vitamin essential for forming DNA and cell growth, especially important in cell division."
    },
    "Iron": {
      "title": "Oxygen Mover",
      "description": "A key mineral that helps transport oxygen through the blood and plays a role in cellular energy."
    },
    "Magnesium": {
      "title": "Muscle Magic",
      "description": "An essential mineral involved in over 300 body processes, including muscle and nerve function."
    },
    "Omega 3": {
      "title": "Fatty Friend",
      "description": "Essential fats found in fish and seeds, crucial for cell structure and brain function."
    },
    "Probiotics": {
      "title": "Gut Guardians",
      "description": "Live bacteria that support the natural balance of your digestive system’s microflora."
    },
    "Vitamin B12": {
      "title": "Energy Essential",
      "description": "Vital for making DNA and red blood cells, it helps keep the nervous system running smoothly."
    },
    "Vitamin B2": {
      "title": "Cell Charger",
      "description": "A B-vitamin that aids in energy production and cellular repair through metabolism of carbs, fats, and proteins."
    },
    "Vitamin B6": {
      "title": "Metabolism Mover",
      "description": "Supports brain and nervous system function, helping the body metabolize amino acids and other nutrients."
    },
    "Vitamin C": {
      "title": "Immunity Icon",
      "description": "A water-soluble vitamin important for collagen formation, helping protect cells from oxidative stress."
    },
    "Vitamin D": {
      "title": "Sunshine Vitamin",
      "description": "Produced in skin exposed to sunlight, it helps the body absorb calcium for healthy bones."
    },
    "Vitamin E": {
      "title": "Cell Protector",
      "description": "An antioxidant that protects cell membranes from damage caused by free radicals."
    },
    "Zinc": {
      "title": "Immunity Insider",
      "description": "A trace mineral crucial for immune function, wound healing, and protein synthesis."
    }
  };

window.supplementDescriptions = supplementDescriptions;
window.supplementDescriptionsPopup = supplementDescriptionsPopup;

const gaugeBarDoses = {
    "Ashwagandha": { avg_competitor_dose: 100, ped: 775, your_dose: 900, minValue: 0, maxValue: 1200, lowerLimit: 600, upperLimit: 1100, unit: "mg"},
    "Biotin": { avg_competitor_dose: 422, ped: 8000, your_dose: 10000, minValue: 0, maxValue: 13000, lowerLimit: 6000, upperLimit: 12000, unit: "mcg"},
    "Calcium": { avg_competitor_dose: 150, ped: 950, your_dose: 1000, minValue: 50, maxValue: 1300, lowerLimit: 850, upperLimit: 1250, unit: "mg"},
    "CoQ10": { avg_competitor_dose: 60, ped: 175, your_dose: 200, minValue: 20, maxValue: 250, lowerLimit: 155, upperLimit: 240, unit: "mg"},
    "Folic Acid": { avg_competitor_dose: 280, ped: 780, your_dose: 800, minValue: 100, maxValue: 1000, lowerLimit: 750, upperLimit: 900, unit: "mcg"},
    "Iron": { avg_competitor_dose: 15, ped: 60, your_dose: 65, minValue: 0, maxValue: 100, lowerLimit: 40, upperLimit: 70, unit: "mg"},
    "Magnesium": { avg_competitor_dose: 80, ped: 385, your_dose: 400, minValue: 20, maxValue: 500, lowerLimit: 250, upperLimit: 475, unit: "mg"},
    "Omega 3": { avg_competitor_dose: 1000, ped: 3000, your_dose: 3000, minValue: 500, maxValue: 4000, lowerLimit: 2500, upperLimit: 3300, unit: "mg"},
    "Probiotics": { avg_competitor_dose: 20, ped: 130, your_dose: 136, minValue: 0, maxValue: 160, lowerLimit: 110, upperLimit: 150, unit: "mg"},
    "Vitamin B12": { avg_competitor_dose: 100, ped: 980, your_dose: 1000, minValue: 0, maxValue: 1300, lowerLimit: 700, upperLimit: 1100, unit: "mcg"},
    "Vitamin B2": { avg_competitor_dose: 30, ped: 390, your_dose: 400, minValue: 0, maxValue: 500, lowerLimit: 370, upperLimit: 480, unit: "mg"},
    "Vitamin B6": { avg_competitor_dose: 15, ped: 180, your_dose: 200, minValue: 0, maxValue: 230, lowerLimit: 150, upperLimit: 220, unit: "mg"},
    "Vitamin C": { avg_competitor_dose: 500, ped: 1000, your_dose: 1000, minValue: 50, maxValue: 1300, lowerLimit: 900, upperLimit: 1200, unit: "mg"},
    "Vitamin D": { avg_competitor_dose: 20, ped: 120, your_dose: 125, minValue: 0, maxValue: 150, lowerLimit: 100, upperLimit: 140, unit: "mcg"},
    "Vitamin E": { avg_competitor_dose: 50, ped: 350, your_dose: 360, minValue: 10, maxValue: 440, lowerLimit: 250, upperLimit: 400, unit: "mg"},
    "Zinc": { avg_competitor_dose: 12, ped: 50, your_dose: 50, minValue: 5, maxValue: 70, lowerLimit: 40, upperLimit: 65, unit: "mg"}
};



const scienceSubtitle = {
    "Endurance": {
        "Iron": "Strength to the finish",
        "Ashwagandha": "Power through the day",
        "Magnesium": "Keep going strong",
        "CoQ10": "Last longer, feel stronger",
        "Omega 3": "Push further",
        "Vitamin B6": "Fuel to last",
        "Zinc": "Go the distance",
        "Vitamin C": "Lasting power"
    },
    "Strength & Power": {
        "Ashwagandha": "Unleash inner strength",
        "Magnesium": "Unlock strength",
        "Vitamin D": "Support strength",
        "Zinc": "Power up"
    },
    "Recovery": {
        "Omega 3": "Repair and renew",
        "Magnesium": "Bounce back",
        "Vitamin C": "Repair and renew",
        "CoQ10": "Refuel and repair",
        "Ashwagandha": "Bounce back faster",
        "Vitamin D": "Bounce back",
        "Zinc": "Restore fast",
        "Vitamin B6": "Quick rebound"
    },
    "Sleep Quality": {
        "Ashwagandha": "Sleep like a baby",
        "Vitamin D": "Nighttime support",
        "Magnesium": "Sleep soundly",
        "Omega 3": "Rest better",
        "Vitamin B6": "Restful nights"
    },
    "Falling Asleep": {
        "Omega 3": "Sleep with ease",
        "Magnesium": "Easy drift-off",
        "Ashwagandha": "Drift off with ease"
    },
    "Staying Asleep": {
        "Vitamin D": "Sleep soundly"
    },
    "Energy": {
        "Iron": "Power through",
        "Omega 3": "Fuel your fire",
        "Ashwagandha": "Energize your routine",
        "CoQ10": "Recharge your cells",
        "Magnesium": "Natural recharge"
    },
    "Fat Loss": {
        "Omega 3": "Fat-fighter",
        "Vitamin D": "Lean and strong"
    }
}

const supplementFact = {
  "Acetyl L-Carnitine": {
      "ingredients": [
          {
              "ingredient_title": "Acetyl L-Carnitine",
              "ingredient_subtitle": "(from 625mg Acetyl L-Carnitine HCl)",
              "amount_per_serving": "500mg"
          }
      ],
      "other_ingredients": "Gelatin Capsule, Magnesium Stearate (Vegetable Source), Microcrystalline Cellulose, Silica",
      "dietary_restrictions": "Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Alpha GPC": {
      "ingredients": [
          {
              "ingredient_title": "Alpha GPC",
              "ingredient_subtitle": "(L-alpha-glycerylphosphorylcholine)",
              "amount_per_serving": "300mg"
          }
      ],
      "other_ingredients": "Stearic Acid, Hypromellose (Cellulose) Capsule, Magnesium Stearate (Vegetable Source), Silica",
      "dietary_restrictions": "Vegan, Vegetarian, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Apigenin": {
      "ingredients": [
          {
              "ingredient_title": "Apigenin",
              "amount_per_serving": "50mg"
          }
      ],
      "other_ingredients": "Rice Flour, Hypromellose (Cellulose) Capsule",
      "dietary_restrictions": "Vegan, Vegetarian, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Ashwagandha": {
      "ingredients": [
          {
              "ingredient_title": "Ashwagandha Extract",
              "ingredient_subtitle": "(Withania Somnifera)(Root and Leaf)",
              "amount_per_serving": "900mg"
          }
      ],
      "other_ingredients": "Rice Flour, Cellulose Capsule (Hypromellose), and Stearic Acid (Vegetable Source)",
      "dietary_restrictions": "Vegan, Vegetarian, Halal, Kosher, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Berberine": {
      "ingredients": [
          {
              "ingredient_title": "Berberine HCl",
              "amount_per_serving": "400mg"
          }
      ],
      "other_ingredients": "Rice Flour, Vegan Capsule (Hypromellose), Magnesium Stearate, Silica",
      "dietary_restrictions": "Vegan, Vegetarian, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Biotin": {
      "ingredients": [
          {
              "ingredient_title": "Biotin",
              "amount_per_serving": "10,000mcg"
          },
          {
              "ingredient_title": "Calcium",
              "amount_per_serving": "226mg"
          }
      ],
      "other_ingredients": "Cellulose, Capsule (Fish Gelatin), and Stearic Acid",
      "dietary_restrictions": "Dairy Free, No Egg, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Calcium": {
      "ingredients": [
          {
              "ingredient_title": "Calcium",
              "ingredient_subtitle": "(from Carbonate, Asparate and Citrate)",
              "amount_per_serving": "1,000mg"
          }
      ],
      "other_ingredients": "Acacia, Maltodextrin, Stearic Acid, Pharmaceutical Glaze, Croscarmellose Sodium, and Magnesium Stearate",
      "dietary_restrictions": "Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "CoQ10": {
      "ingredients": [
          {
              "ingredient_title": "Coenzyme Q10",
              "amount_per_serving": "200mg"
          }
      ],
      "other_ingredients": "Rice Flour, Hypromellose (cellulose capsule), Ascorbyl Palmitate, Magnesium Stearate (vegetable source) and Silicon Dioxide",
      "dietary_restrictions": "Vegan, Vegetarian, Halal, Kosher, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Curcumin": {
      "ingredients": [
          {
              "ingredient_title": "Turmeric Extract",
              "ingredient_subtitle": "(Curcuma longa)(Root), Standardized to 95% Curcuminoids (475mg)",
              "amount_per_serving": "500mg"
          }
      ],
      "other_ingredients": "Modified Cellulose (Hypromellose Veggie Capsule), Magnesium Stearate, and Silicon Dioxide (Silica)",
      "dietary_restrictions": "Vegan, Vegetarian, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Folic Acid": {
      "ingredients": [
          {
              "ingredient_title": "Folate",
              "ingredient_subtitle": "(Folic Acid)",
              "amount_per_serving": "1,334mcg",
              "amount_per_serving_subtitle": "800mcg"
          },
          {
              "ingredient_title": "Calcium",
              "ingredient_subtitle": "(as Calcium Carbonate)",
              "amount_per_serving": "200mg"
          }
      ],
      "other_ingredients": "Cellulose, Gum Acacia, Croscarmellose, Sodium, Stearic Acid",
      "dietary_restrictions": "Vegan, Vegetarian, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy",
      "contains": "Magnesium Stearate, Silicon Dioxide"
  },
  "Inositol": {
      "ingredients": [
          {
              "ingredient_title": "Inositol",
              "ingredient_subtitle": "(as Myo-Inositol)",
              "amount_per_serving": "1,000mg"
          }
      ],
      "other_ingredients": "Vegetable Cellulose (Capsule), Vegetable Stearate, Silica",
      "dietary_restrictions": "Vegan, Vegetarian, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Iron": {
      "ingredients": [
          {
              "ingredient_title": "Iron",
              "ingredient_subtitle": "(as Dried Ferrous Sulfate)",
              "amount_per_serving": "65mg"
          }
      ],
      "other_ingredients": "Cellulose, Dextrose, Sorbitol, Stearic Acid, and Croscarmellose Sodium",
      "dietary_restrictions": "Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free",
      "contains": "Artificial Colors, Magnesium Silicate, Magnesium Stearate, Polyethylene Glycol, Polyvinyl Alcohol, Silicon Dioxide, and Titanium Dioxide"
  },
  "L-Theanine": {
      "ingredients": [
          {
              "ingredient_title": "L-Theanine",
              "amount_per_serving": "200mg"
          }
      ],
      "other_ingredients": "Microcrystalline Cellulose, Modified Cellulose (Hypromellose Veggie Capsule), Stearic Acid, and Silicon Dioxide (Silica)",
      "dietary_restrictions": "Vegan, Vegetarian, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "L-Tyrosine": {
      "ingredients": [
          {
              "ingredient_title": "L-Tyrosine",
              "ingredient_subtitle": "(Free-Form)",
              "amount_per_serving": "500mg"
          }
      ],
      "other_ingredients": "Hypromellose (Cellulose Capsule), Stearic Acid (Vegetable Source), and Silicon Dioxide",
      "dietary_restrictions": "Vegan, Vegetarian, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Magnesium": {
      "ingredients": [
          {
              "ingredient_title": "Magnesium",
              "ingredient_subtitle": "(from Magnesium Glycinate and Magnesium Oxide)",
              "amount_per_serving": "400mg"
          }
      ],
      "other_ingredients": "Rice Flour, Cellulose, Stearic Acid, Croscarmellose Sodium, Silicon Dioxide, Magnesium Stearate, Hydroxypropyl Methylcellulose, Ethylcellulose, Carnauba Wax",
      "dietary_restrictions": "Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Omega 3": {
      "ingredients": [
          {
              "ingredient_title": "Omega 3 Fatty Acids",
              "ingredient_subtitle": "EPA",
              "amount_per_serving": "1,920mg",
              "amount_per_serving_subtitle": "1,080mg",
              "ingredient_subtitle_2": "DHA",
              "amount_per_serving_subtitle_2": "720mg",
              "ingredient_subtitle_3": "Other",
              "amount_per_serving_subtitle_3": "120mg"
          }
      ],
      "other_ingredients": "Fish Gelatin Softgel and Vitamin E (<0.1%)",
      "dietary_restrictions": "Dairy Free, No Egg, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Probiotics": {
      "ingredients": [
          {
              "ingredient_title": "Probiotic Bacteria Blend",
              "amount_per_serving": "136mg (30bn CFU)"
          }
      ],
      "other_ingredients": "Microcrystalline Cellulose, Modified Cellulose (Veggie Capsule), Silicon Dioxide (Silica), and Magnesium Stearate (Non-GMO Vegetable Source)",
      "dietary_restrictions": "Vegan, Vegetarian, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Resveratrol": {
      "ingredients": [
          {
              "ingredient_title": "Resveratrol Complex",
              "ingredient_subtitle": "Grape Seed Extract (Vitis vinifera), Red Wine Extract (Vitis vinifera)(Fruit), trans-Resveratrol (from Polygonum cuspidatum Extract)(Root)",
              "amount_per_serving": "500mg"
          }
      ],
      "other_ingredients": "Rice Bran Extract, Modified Cellulose (Hypromellose Veggie Capsule), Maltodextrin, Magnesium Stearate, and Silicon Dioxide (Silica)",
      "dietary_restrictions": "Vegan, Vegetarian, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Rhodiola Rosea": {
      "ingredients": [
          {
              "ingredient_title": "Rhodiola Rosea Extract",
              "ingredient_subtitle": "(Rhodiola rosea)(Root), Standardized to 3% Total Rosavins and 1% Salidrosides",
              "amount_per_serving": "500mg"
          }
      ],
      "other_ingredients": "Hypromellose (Cellulose) Capsule, Magnesium Stearate (Vegetable Source), Stearic Acid",
      "dietary_restrictions": "Vegan, Vegetarian, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Tongkat Ali": {
      "ingredients": [
          {
              "ingredient_title": "Tongkat Ali",
              "ingredient_subtitle": "(Eurycoma longifolia Jack)(Root)",
              "amount_per_serving": "800mg"
          }
      ],
      "other_ingredients": "Vegan Capsule (Hypromellose), Rice Flour, Magnesium Stearate",
      "dietary_restrictions": "Vegan, Vegetarian, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Vitamin B12": {
      "ingredients": [
          {
              "ingredient_title": "Vitamin B12",
              "ingredient_subtitle": "(as Cyanocobalamin)",
              "amount_per_serving": "1,000mcg"
          },
          {
              "ingredient_title": "Folate",
              "amount_per_serving": "167mcg"
          }
      ],
      "other_ingredients": "Fructose, Microcrystalline Cellulose, Sorbitol, Stearic Acid (Vegetable Source), Magnesium Stearate (Vegetable Source) and Silicon Dioxide",
      "dietary_restrictions": "Vegan, Vegetarian, Halal, Kosher, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Vitamin B2": {
      "ingredients": [
          {
              "ingredient_title": "Riboflavin (Vitamin B2)",
              "amount_per_serving": "400mg"
          }
      ],
      "other_ingredients": "Gelatin Capsule, Magnesium Stearate (Vegetable Source), Silica, Stearic Acid (Vegetable Source)",
      "dietary_restrictions": "Vegan, Vegetarian, Halal, Kosher, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Free"
  },
  "Vitamin B6": {
      "ingredients": [
          {
              "ingredient_title": "Vitamin B6",
              "ingredient_subtitle": "(as Pyridoxine Hydrochloride)",
              "amount_per_serving": "200mg"
          }
      ],
      "other_ingredients": "Rice Flour and Hypromellose (Cellulose Capsule)",
      "dietary_restrictions": "Vegan, Vegetarian, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy"
  },
  "Vitamin C": {
      "ingredients": [
          {
              "ingredient_title": "Vitamin C",
              "ingredient_subtitle": "(as Ascorbic Acid)",
              "amount_per_serving": "1,000mg"
          }
      ],
      "other_ingredients": "Hydroxypropyl Methylcellulose (Veggie Capsule) and Magnesium Stearate",
      "dietary_restrictions": "Vegan, Vegetarian, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy"
  },
  "Vitamin D": {
      "ingredients": [
          {
              "ingredient_title": "Vitamin D",
              "ingredient_subtitle": "(as D3, Cholecalciferol)",
              "amount_per_serving": "125mcg (5,000lU)"
          }
      ],
      "other_ingredients": "Safflower Oil and Fish Gelatin Softgel (Gelatin [from Tilapia], Vegetable Glycerin, Purified Water)",
      "dietary_restrictions": "Dairy Free, No Egg, Gluten Free, No Nuts, No Shellfish, Soy Free",
      "contains_short": "Fish (Tilapia)"
  },
  "Vitamin E": {
      "ingredients": [
          {
              "ingredient_title": "Vitamin E",
              "ingredient_subtitle": "(as dl-Alpha Tocopheryl Acetate)",
              "amount_per_serving": "360mg"
          }
      ],
      "other_ingredients": "Capsule (Fish Gelatin), Glycerin, Soybean Oil, and Purified Water",
      "dietary_restrictions": "Dairy Free, No Egg, Gluten Free, No Nuts, No Shellfish"
  },
  "Zinc": {
      "ingredients": [
          {
              "ingredient_title": "Zinc",
              "ingredient_subtitle": "(as Zinc Citrate)",
              "amount_per_serving": "50mg"
          },
          {
              "ingredient_title": "Calcium",
              "ingredient_subtitle": "(as Dicalcium Phosphate)",
              "amount_per_serving": "46mg"
          }
      ],
      "other_ingredients": "Microcrystalline Cellulose, Stearic Acid, and Croscarmellose Sodium",
      "dietary_restrictions": "Vegan, Vegetarian, Dairy Free, No Egg, No Fish, Gluten Free, No Nuts, No Shellfish, Soy Bean",
      "contains": "Magnesium Stearate, Silicon Dioxide"
  }
};


window.supplementFact = supplementFact;


const pillCounts = {
  "Acetyl L-Carnitine": "1 Tablet",
  "Alpha GPC": "1 Tablet",
  "Apigenin": "1 Capsule",
  "Ashwagandha": "2 Capsules",
  "Berberine": "1 Capsule",
  "Biotin": "1 Tablet",
  "Calcium": "1 Tablet",
  "CoQ10": "1 Capsule",
  "Curcumin": "1 Capsule",
  "Folic Acid": "2 Tablets",
  "Inositol": "1 Softgel",
  "Iron": "1 Tablet",
  "L-Theanine": "1 Capsule",
  "L-Tyrosine": "1 Capsule",
  "Magnesium": "2 Tablets",
  "Omega 3": "3 Softgels",
  "Probiotics": "1 Capsule",
  "Resveratrol": "1 Capsule",
  "Rhodiola Rosea": "1 Capsule",
  "Tongkat Ali": "2 Capsules",
  "Vitamin B12": "1 Tablet",
  "Vitamin B2": "1 Capsule",
  "Vitamin B6": "2 Tablets",
  "Vitamin C": "1 Capsule",
  "Vitamin D": "1 Softgel",
  "Vitamin E": "2 Softgels",
  "Zinc": "1 Tablet"
};

window.pillsCounts = pillCounts;


/**
 * Authoritative list of every supplement name Nutricode offers.
 * Single source of truth for supplement-name validation (e.g. go-to-checkout).
 * Names are the canonical spelling/casing; keep in sync with pillCounts keys.
 */
const supplementList = [
  "Acetyl L-Carnitine",
  "Alpha GPC",
  "Apigenin",
  "Ashwagandha",
  "Berberine",
  "Biotin",
  "Calcium",
  "CoQ10",
  "Curcumin",
  "Folic Acid",
  "Inositol",
  "Iron",
  "L-Theanine",
  "L-Tyrosine",
  "Magnesium",
  "Omega 3",
  "Probiotics",
  "Resveratrol",
  "Rhodiola Rosea",
  "Tongkat Ali",
  "Vitamin B12",
  "Vitamin B2",
  "Vitamin B6",
  "Vitamin C",
  "Vitamin D",
  "Vitamin E",
  "Zinc"
];

window.supplementList = supplementList;


const supplementGrades = {
  "Iron": {
    "Endurance": 9,
    "Energy": 7,
    "Focus": 6,
    "Heart & Circulation": 7,
    "Female": { "Female Hormones": 7 }
  },
  "Probiotics": {
    "Gut Health": 8
  },
  "Vitamin E": {
    "Longevity": 6,
    "Hair Health": 7,
    "Immunity": 8,
    "Organ Health": 5,
    "Female": { "Menstrual Health": 7 }
  },
  "Ashwagandha": {
    "Endurance": 8,
    "Strength & Power": 9,
    "Sleep": 6,
    "Mood Improvement": 7,
    "Stress": 7,
    "Both": { "Hormone Health": 7 }
  },
  "Zinc": {
    "Heart & Circulation": 10,
    "Focus": 8,
    "Memory": 8,
    "Immunity": 7,
    "Weight Management": 6,
    "Both": { "Hormone Health": 7 }
  },
  "Omega 3": {
    "Brain Health": 10,
    "Recovery": 7,
    "Stress": 7,
    "Weight Management": 5,
    "Mood Improvement": 7,
    "Female": {
      "Menstrual Health": 3,
      "Pregnancy Health": 7,
      "Female Hormones": 6
    }
  },
  "Vitamin B6": {
    "Sleep Quality": 6,
    "Endurance": 5,
    "Recovery": 3,
    "Female": {
      "Menstrual Health": 7,
      "Female Hormones": 3
    }
  },
  "Vitamin B2": {
    "Heart & Circulation": 8,
    "Brain Health": 6
  },
  "CoQ10": {
    "Energy": 9,
    "Longevity": 7,
    "Brain Health": 6,
    "Endurance": 7,
    "Both": { "Hormone Health": 7 }
  },
  "Folic Acid": {
    "Mood Improvement": 8,
    "Longevity": 7,
    "Heart & Circulation": 8
  },
  "Magnesium": {
    "Sleep Quality": 7,
    "Weight Management": 10,
    "Recovery": 7,
    "Strength & Power": 8,
    "Brain Health": 8,
    "Female": {
      "Menstrual Health": 6,
      "Female Hormones": 6
    }
  },
  "Calcium": {
    "Bone Health": 8,
    "Heart & Circulation": 7,
    "Gut Health": 6,
    "Female": {
      "Menstrual Health": 8,
      "Pregnancy Health": 7
    }
  },
  "Vitamin B12": {
    "Heart & Circulation": 7
  },
  "Vitamin C": {
    "Immunity": 7,
    "Weight Management": 7,
    "Organ Health": 8,
    "Mood Improvement": 6,
    "Energy": 5,
    "Both": { "Hormone Health": 8 }
  },
  "Vitamin D": {
    "Fat Loss": 7,
    "Immunity": 9,
    "Organ Health": 8,
    "Strength & Power": 7,
    "Mood Improvement": 6,
    "Both": { "Hormone Health": 8 }
  },
  "Biotin": {
    "Hair & Nails": 6,
    "Heart & Circulation": 7,
    "Longevity": 5
  }
};



   const numberOfCapsules = {
            "Ashwagandha":"2 Capsules",
            "Biotin":"1 Tablet",
            "Calcium":"1 Tablet",
            "CoQ10":"1 Capsule",
            "Folic Acid":"2 Tablets",
            "Iron":"1 Tablet",
            "Magnesium":"2 Tablets",
            "Omega 3":"3 Softgels",
            "Probiotics":"1 Capsule",
            "Vitamin B12":"1 Tablet",
            "Vitamin B2":"1 Capsule",
            "Vitamin B6":"2 Tablets",
            "Vitamin C":"1 Capsule",
            "Vitamin D":"1 Softgel",
            "Vitamin E":"2 Softgels",
            "Zinc":"1 Tablet"
            };


const pills_shooting = {
            "Ashwagandha": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/ashwagandha_shooting-min.png?v=1745115002",
            "Biotin": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/biotin_shooting-min.png?v=1745115003",
            "Calcium": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/calcium_shooting-min.png?v=1745115003",
            "CoQ10": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/coq10_shooting-min.png?v=1745115003",
            "Folic Acid": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/folic_acid_shooting-min.png?v=1745115002",
            "Iron": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/iron_shooting-min.png?v=1745115003",
            "Magnesium": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/magnesium_shooting-min.png?v=1745115003",
            "Omega 3": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/omega3_shooting-min.png?v=1745115003",
            "Probiotics": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/probiotics_shooting-min.png?v=1745115003",
            "Vitamin B12": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminB12_shooting-min.png?v=1745115002",
            "Vitamin B2": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminB2_shooting-min.png?v=1745115002",
            "Vitamin B6": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminB6_shooting-min.png?v=1745115003",
            "Vitamin C": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminC_shooting-min.png?v=1745115002",
            "Vitamin D": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminD3_shooting-min.png?v=1745115003",
            "Vitamin E": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminE_shooting-min.png?v=1745115002",
            "Zinc": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/zinc_shooting-min.png?v=1745115002",
        };


const pills_mouth = {
    "Ashwagandha":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/ashwagandha_mouth-min.png?v=1755157752",
    "Biotin":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/biotin_mouth-min.png?v=1755157751",
    "Calcium":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/calcium_mouth-min.png?v=1755157752",
    "CoQ10":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/coq10_mouth-min.png?v=1755157752",
    "Folic Acid":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/folic_acid_mouth-min.png?v=1755157751",
    "Iron":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/iron_mouth-min.png?v=1755157751",
    "Magnesium":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/magnesium_mouth-min.png?v=1755157752",
    "Omega 3":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/omega3_mouth-min.png?v=1755157752",
    "Probiotics":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/probiotics_mouth-min.png?v=1755157752",
    "Vitamin B12":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminb12_mouth-min.png?v=1755157751",
    "Vitamin B2":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminb2_mouth-min.png?v=1755157752",
    "Vitamin B6":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminb6_mouth-min.png?v=1755157751",
    "Vitamin C":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminc_mouth-min.png?v=1755157752",
    "Vitamin D":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitamind_mouth-min.png?v=1755157752",
    "Vitamin E":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitamine_mouth-min.png?v=1755157752",
    "Zinc":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/zinc_mouth-min.png?v=1755157751"
    };



    const supplementIntakeGuidelines = {
    "Ashwagandha": {
        time: "Evening",
        food: "With or without food"
    },
    "Biotin": {
        time: "Anytime",
        food: "With food"
    },
    "Calcium": {
        time: "Anytime",
        food: "With food"
    },
    "CoQ10": {
        time: "Morning",
        food: "With food containing fat"
    },
    "Folic Acid": {
        time: "Anytime",
        food: "With food"
    },
    "Iron": {
        time: "Anytime",
        food: "Without food",
        avoid: ["Calcium"]
    },
    "Magnesium": {
        time: "Evening",
        food: "With or without food"
    },
    "Omega 3": {
        time: "Anytime",
        food: "With food containing fat"
    },
    "Probiotics": {
        time: "Morning",
        food: "Without food"
    },
    "Vitamin B12": {
        time: "Anytime",
        food: "With food"
    },
    "Vitamin B2": {
        time: "Anytime",
        food: "With food"
    },
    "Vitamin B6": {
        time: "Morning",
        food: "With food"
    },
    "Vitamin C": {
        time: "Anytime",
        food: "With or without food"
    },
    "Vitamin D": {
        time: "Morning",
        food: "With food containing fat"
    },
    "Vitamin E": {
        time: "Anytime",
        food: "With food containing fat"
    },
    "Zinc": {
        time: "Anytime",
        food: "Without food or with a light meal"
    }
};


const supplementToGoalsL1L2_very_short = {
    "Ashwagandha": ["Stress", "Endurance", "Strength & Power", "Sleep", "Hormones"], 
    "Biotin": ["Longevity", "Organ Health", "Skin & Beauty", "Nails"], 
    "Calcium": ["Heart", "Gut Health", "Bones"], 
    "CoQ10": ["Mood", "Endurance", "Longevity", "Energy", "Heart", "Organ Health"], 
    "Folic Acid": ["Mental Health", "Longevity", "Organ Health", "Heart"], 
    "Iron": ["Stress", "Endurance", "Hormones & Reproduction", "Brain", "Focus", "Memory"], 
    "Magnesium": ["Stress", "Endurance", "Strength & Power", "Hormones", "Sleep", "Heart", "Bones"], 
    "Omega 3": ["Mood", "Stress", "Endurance", "Energy", "Hormones", "Immunity", "Sleep", "Focus", "Memory", "Fat Loss"], 
    "Probiotics": ["Organ Health", "Gut Health"], 
    "Vitamin B12": ["Organ Health", "Heart"], 
    "Vitamin B2": ["Organ Health", "Brain", "Heart"], 
    "Vitamin B6": ["Endurance", "Recovery", "Hormones", "Sleep"], 
    "Vitamin C": [ "Endurance", "Recovery", "Longevity", "Hormones", "Immunity", "Heart", "Bones", "Weight"], 
    "Vitamin D": ["Strength & Power", "Fat Loss", "Muscle Mass", "Hormones", "Immunity", "Sleep", "Bones"], 
    "Vitamin E": ["Longevity", "Hormones", "Immunity", "Heart", "Skin & Beauty", "Gut", "Hair"], 
    "Zinc": ["Endurance", "Strength & Power", "Longevity", "Hormones", "Immunity","Focus", "Memory", "Weight"]
}

const supplementToGoalsL1L2_short = {
    "Ashwagandha": ["Stress","Sleep", "Endurance", "Strength & Power", "Energy", "Hormones & Reproduction", "Immunity", "Joints"], 
    "Biotin": ["Longevity", "Organ Health", "Heart & Circulation", "Skin & Beauty", "Nails"], 
    "Calcium": ["Hormones & Reproduction", "Musculoskeletal Health", "Organ Health", "Heart & Circulation", "Gut Health", "Bones"], 
    "CoQ10": ["Mood Improvement", "Endurance", "Longevity", "Energy", "Hormones & Reproduction", "Heart & Circulation", "Eye Health", "Brain Health", "Skin Health"], 
    "Folic Acid": ["Mental Health", "Longevity", "Disease Prevention", "Organ Health", "Heart & Circulation"], 
    "Iron": ["Stress", "Endurance", "Energy", "Hormones & Reproduction", "Heart & Circulation", "Brain Health", "Blood Health", "Focus", "Memory"], 
    "Magnesium": ["Stress", "Endurance", "Strength & Power", "Recovery", "Hormones & Reproduction", "Sleep Quality", "Falling Asleep", "Heart & Circulation", "Bones"], 
    "Omega 3": ["Mood Improvement", "Stress", "Endurance", "Energy", "Hormones & Reproduction", "Immunity", "Sleep Quality", "Falling Asleep", "Focus", "Memory", "Fat Loss", "Recovery", "Organ Health"], 
    "Probiotics": ["Organ Health", "Gut Health"], 
    "Vitamin B12": ["Organ Health", "Heart & Circulation"], 
    "Vitamin B2": ["Organ Health", "Heart & Circulation", "Brain Health"], 
    "Vitamin B6": ["Endurance", "Recovery", "Hormones & Reproduction", "Sleep Quality"], 
    "Vitamin C": [ "Endurance", "Recovery", "Longevity", "Hormones & Reproduction", "Immunity", "Heart & Circulation", "Bones", "Weight Management"], 
    "Vitamin D": ["Strength & Power", "Fat Loss", "Muscle Mass", "Recovery", "Longevity", "Hormones & Reproduction", "Immunity", "Sleep Quality", "Staying Asleep", "Bones"], 
    "Vitamin E": ["Longevity", "Hormones & Reproduction", "Immunity", "Heart & Circulation", "Skin & Beauty", "Gut Health", "Kidney Health", "Liver Health", "Hair", "Organ Health"], 
    "Zinc": ["Endurance", "Strength & Power", "Recovery", "Longevity", "Hormones & Reproduction", "Immunity","Focus", "Memory", "Weight Management"]
}


const supplementToGoalsL1L2_REFINED = {
    "Ashwagandha": ["Stress","Sleep", "Endurance", "Strength & Power", "Energy", "Hormones & Reproduction"], 
    "Biotin": ["Skin & Beauty", "Nails","Longevity"], 
    "Calcium": ["Musculoskeletal Health", "Heart & Circulation", "Gut Health", "Hormones & Reproduction"], 
    "CoQ10": ["Energy", "Endurance","Longevity","Hormones & Reproduction", "Brain Health", "Heart & Circulation", "Eye Health", "Skin Health"], 
    "Folic Acid": ["Heart & Circulation", "Longevity", "Mental Health"], 
    "Iron": ["Endurance", "Energy", "Blood Health", "Focus", "Hormones & Reproduction", "Heart & Circulation"], 
    "Magnesium": ["Strength & Power", "Recovery", "Sleep", "Endurance","Hormones & Reproduction", "Heart & Circulation", "Bones"], 
    "Omega 3": ["Organ Health", "Cognitive Performance", "Endurance", "Fat Loss","Recovery", "Energy", "Hormones & Reproduction", "Sleep", "Mood Improvement","Immunity"], 
    "Probiotics": [ "Gut Health", "Organ Health"], 
    "Vitamin B12": ["Heart & Circulation", "Organ Health"], 
    "Vitamin B2": ["Heart & Circulation", "Brain Health", "Organ Health"], 
    "Vitamin B6": ["Endurance", "Recovery", "Sleep", "Hormones & Reproduction"], 
    "Vitamin C": ["Immunity", "Recovery", "Longevity", "Endurance", "Hormones & Reproduction", "Heart & Circulation", "Bones", "Weight Management"], 
    "Vitamin D": ["Hormones & Reproduction", "Immunity", "Strength & Power", "Fat Loss", "Muscle Mass", "Recovery", "Longevity", "Sleep", "Bones"], 
    "Vitamin E": ["Immunity","Longevity","Organ Health", "Hormones & Reproduction","Skin & Beauty", "Hair"], 
    "Zinc": ["Endurance", "Hormones & Reproduction", "Longevity", "Weight Management", "Strength & Power", "Recovery", "Immunity", "Cognitive Performance",]
}


const supplementToGoalsL1L2_REFINED_short = {
    "Ashwagandha": ["Stress","Sleep", "Endurance", "Strength", "Energy", "Hormones"], 
    "Biotin": ["Skin", "Nails", "Longevity"], 
    "Calcium": ["Joints", "Heart", "Gut", "Hormones"], 
    "CoQ10": ["Energy", "Endurance", "Longevity", "Hormones", "Brain", "Heart", "Eye Health", "Skin"], 
    "Folic Acid": ["Heart", "Longevity", "Mental Health"], 
    "Iron": ["Fitness", "Energy", "Blood", "Focus", "Hormones", "Heart"], 
    "Magnesium": ["Strength", "Recovery", "Sleep", "Endurance", "Hormones", "Heart", "Bones"], 
    "Omega 3": [ "Organ", "Cognitive","Endurance","Fat Loss", "Recovery", "Energy", "Hormones", "Sleep", "Mood","Immunity"], 
    "Probiotics": [ "Gut", "Organ Health"], 
    "Vitamin B12": [ "Heart", "Organ Health"], 
    "Vitamin B2": ["Heart", "Brain", "Organ Health"], 
    "Vitamin B6": ["Fitness", "Recovery", "Sleep", "Hormones"], 
    "Vitamin C": ["Immunity", "Recovery", "Longevity", "Endurance", "Hormones", "Heart", "Bones", "Weight"], 
    "Vitamin D": ["Hormones", "Immunity", "Strength", "Fat Loss", "Muscle Mass", "Recovery", "Longevity", "Sleep", "Bones"], 
    "Vitamin E": ["Longevity", "Immunity", "Organ Health", "Hormones","Skin", "Hair"], 
    "Zinc": [ "Fitness","Hormones", "Longevity", "Weight Management", "Strength & Power", "Recovery", "Immunity", "Cognitive Performance",]
}

const supplementToBenefitScore = {
  "Ashwagandha": {
    "Stress": 3,
    "Sleep Quality": 2,
    "Strength & Power": 1
  },
  "Biotin": {
    "Longevity": 3,
    "Organ Health": 2,
    "Skin & Beauty": 1
  },
  "Calcium": {
    "Joints": 3,
    "Gut Health": 1,
  },
  "CoQ10": {
    "Energy": 3,
    "Endurance": 2,
    "Longevity": 1
  },
  "Folic Acid": {
    "Heart Health": 2,
    "Longevity": 1,
    "Organ Health": 1
  },
  "Iron": {
    "Energy": 3,
    "Endurance": 2,
    "Focus": 1
  },
  "Magnesium": {
    "Sleep Quality": 3,
    "Strength & Power": 2,
    "Recovery": 1
  },
  "Omega 3": {
    "Focus": 3,
    "Recovery": 2,
    "Fat Loss": 1
  },
  "Probiotics": {
    "Gut Health": 3,
  },
  "Vitamin B12": {
    "Energy": 2,
    "Heart Health": 1
  },
  "Vitamin B2": {
    "Organ Health": 3,
    "Focus": 2,
    "Heart Health": 1
  },
  "Vitamin B6": {
    "Sleep Quality": 2,
    "Recovery": 2,
    "Endurance": 1
  },
  "Vitamin C": {
    "Recovery": 3,
    "Endurance": 2,
    "Immunity": 1
  },
  "Vitamin D": {
    "Strength & Power": 3,
    "Fat Loss": 2,
    "Hormones Health": 1
  },
  "Vitamin E": {
    "Longevity": 3,
    "Recovery": 1,
    "Hormones Health": 1
  },
  "Zinc": {
    "Endurance": 3,
    "Strength & Power": 2,
    "Longevity": 1
  }
};

const boxBenefits = {
      "The Energy Protocol": ["Energy", "Metabolism", "Focus", "Mental Clarity", "Performance"],
      "The Sleep Protocol": ["Sleep", "Deep & REM", "HRV", "Falling Asleep", "Staying Asleep", "Sleep Quality"],
      "The Fitness Protocol": ["Strength", "Endurance", "Recovery", "Muscle Mass", "Performance"],
      "Sleep": ["Sleep", "Deep & REM", "HRV", "Falling Asleep", "Staying Asleep", "Sleep Quality"],
      "Fitness": ["Strength", "Endurance", "Recovery", "Muscle Mass", "Performance"]
    };

function findPath(supplement, healthNeed) {
    const path = [];
    const tree = treeHealthNeed

    function search(node, currentPath) {
        if (typeof node !== 'object' || node === null) {
            return false;
        }

        for (const key in node) {
            const newPath = [...currentPath, key];

            if (key === healthNeed) {
                path.push(...newPath);
                return true;
            }

            if (search(node[key], newPath)) {
                return true;
            }
        }

        return false;
    }

    if (tree[supplement]) {
        search(tree[supplement], [supplement]);
    }

    return path.length > 0 ? path : null;
}


function fetchSummaryPapers(path) {
    // Start with the root of the explanationParagraph
    let current = explanationParagraph;


    // Traverse the explanationParagraph using the path array
    for (const key of path) {
        if (current[key]) {
            current = current[key];
        } else {
            // If the path is invalid, return null or handle the error as needed
            return null;
        }
    }

    // Return the value of "Summary Papers" if it exists
    return current["Summary Papers"] || null;
}


function fetchListOfPapers(path) {
    // Only loaded on pages that use it (see final-data-examin-dict.js).
    if (typeof finalDataExaminDict === 'undefined') return null;
    let current = finalDataExaminDict;

    // Traverse the fullTree using the path array
    for (const key of path) {
        if (current[key]) {
            current = current[key];
        } else {
            // If the path is invalid, return null or handle the error as needed
            return null;
        }
    }

    // Determine the level and extract papers
    let papers = [];
    if (current.papersFocusAreas) {
        papers = current.papersFocusAreas.papers;
    } else if (current.papersLayer2) {
        papers = current.papersLayer2.papers;
    } else if (current.papersLayer3) {
        papers = current.papersLayer3.papers;
    } else {
        // If no papers are found, return null or handle the error as needed
        return null;
    }

    // Create a list of articles with title and url
    const articles = Object.values(papers).map(article => ({
        title: article.title,
        url: article.url
    }));

    return articles;
}



    const boxSupplements = {
      "Energy": [
        { name: "CoQ10", dose: "200mg", count: "1x" },
        { name: "Omega 3", dose: "3000mg", count: "3x" },
        { name: "Vitamin B12", dose: "1,000mcg", count: "1x" },
        { name: "Vitamin B2", dose: "400mg", count: "1x" }
      ],
      "Sleep": [
        { name: "Ashwagandha", dose: "900mg", count: "2x" },
        { name: "Magnesium", dose: "400mg", count: "2x" },
        { name: "Omega 3", dose: "3000mg", count: "3x" },
        { name: "Vitamin B6", dose: "100mg", count: "2x" }
        
      ],
      "Fitness": [
        { name: "Ashwagandha", dose: "900mg", count: "2x" },
        { name: "Magnesium", dose: "400mg", count: "2x" },
        { name: "Vitamin C", dose: "1,000mg", count: "1x" },
        { name: "Zinc", dose: "50mg", count: "1x" }
      ],
      "The Energy Protocol": [
        { name: "CoQ10", dose: "200mg", count: "1x" },
        { name: "Omega 3", dose: "3000mg", count: "3x" },
        { name: "Vitamin B12", dose: "1,000mcg", count: "1x" },
        { name: "Vitamin B2", dose: "400mg", count: "1x" }
      ],
      "The Sleep Protocol": [
        { name: "Ashwagandha", dose: "900mg", count: "2x" },
        { name: "Magnesium", dose: "400mg", count: "2x" },
        { name: "Omega 3", dose: "3000mg", count: "3x" },
        { name: "Vitamin B6", dose: "100mg", count: "2x" }
        
      ],
      "The Fitness Protocol": [
        { name: "Ashwagandha", dose: "900mg", count: "2x" },
        { name: "Magnesium", dose: "400mg", count: "2x" },
        { name: "Vitamin C", dose: "1,000mg", count: "1x" },
        { name: "Zinc", dose: "50mg", count: "1x" }
      ]
    };




const supplementDescriptionLong = {
  "Ashwagandha": {
    title: "Calm",
    title_highlight: "in a Capsule",
    description:
      "Ashwagandha (Withania somnifera) is a clinically studied adaptogen known for its ability to <span class=\"body-semibold-black font-20px darkmode\">lower cortisol and support the body’s stress response</span>. Used for centuries in Ayurvedic medicine, it promotes calm, enhances mood stability, and improves sleep quality without sedation."
  },
  "Biotin": {
    title: "Beauty",
    title_highlight: "Booster",
    description:
      "Biotin (vitamin B7) supports metabolism while <span class=\"body-semibold-black font-20px darkmode\">strengthening hair, skin, and nails at the root</span>. Consistent use enhances resilience, boosts vitality, and promotes a natural, healthy glow."
  },
  "Calcium": {
    title: "Bone",
    title_highlight: "Builder",
    description:
      "Calcium is essential for strong bones and teeth, helping <span class=\"body-semibold-black font-20px darkmode\">maintain density and long-term bone strength</span>. It also supports circulation, muscle contraction, and hormonal balance for everyday health."
  },
  "CoQ10": {
    title: "Energy",
    title_highlight: "Enabler",
    description:
      "CoQ10 is a mitochondrial cofactor that powers ATP energy, <span class=\"body-semibold-black font-20px darkmode\">boosting endurance and cardiovascular performance</span>. It sustains cellular health, reduces fatigue, and slows signs of aging."
  },
  "Folic Acid": {
    title: "Cell",
    title_highlight: "Builder",
    description:
      "Folic acid (B9) is vital for DNA synthesis and cell renewal, <span class=\"body-semibold-black font-20px darkmode\">supporting brain, heart, and red blood cell health</span>. It regulates homocysteine, promotes longevity, and aids disease prevention."
  },
  "Iron": {
    title: "Oxygen",
    title_highlight: "Mover",
    description:
      "Iron enables hemoglobin to carry oxygen, <span class=\"body-semibold-black font-20px darkmode\">fueling energy, focus, and endurance</span>. It builds red blood cells, supports blood health, and combats fatigue for optimal performance."
  },
  "Magnesium": {
    title: "Muscle",
    title_highlight: "Magic",
    description:
      "Magnesium regulates hundreds of body processes, <span class=\"body-semibold-black font-20px darkmode\">improving sleep quality, muscle recovery, and calm</span>. It relieves fatigue, balances hormones, and sustains strength."
  },
  "Omega 3": {
    title: "Fatty",
    title_highlight: "Friend",
    description:
      "Omega-3 fatty acids (EPA & DHA) reduce inflammation and <span class=\"body-semibold-black font-20px darkmode\">support heart, brain, and recovery performance</span>. They improve endurance, sharpen cognition, and protect long-term health."
  },
  "Probiotics": {
    title: "Gut",
    title_highlight: "Guardians",
    description:
      "Probiotics restore gut balance and digestion, <span class=\"body-semibold-black font-20px darkmode\">enhancing nutrient absorption and immunity</span>. They strengthen recovery and optimize energy through the gut–brain axis."
  },
  "Vitamin B12": {
    title: "Energy",
    title_highlight: "Essential",
    description:
      "Vitamin B12 sustains organ and nervous system health by <span class=\"body-semibold-black font-20px darkmode\">boosting energy, mood, and mental clarity</span>. It supports red blood cell formation, cardiovascular balance, and DNA repair."
  },
  "Vitamin B2": {
    title: "Cell",
    title_highlight: "Charger",
    description:
      "Vitamin B2 (riboflavin) powers mitochondrial energy and <span class=\"body-semibold-black font-20px darkmode\">protects cells with antioxidant defense</span>. It sustains brain function, supports circulation, and maintains vitality."
  },
  "Vitamin B6": {
    title: "Metabolism",
    title_highlight: "Mover",
    description:
      "Vitamin B6 regulates amino acids and neurotransmitters, <span class=\"body-semibold-black font-20px darkmode\">balancing hormones and improving sleep quality</span>. It enhances recovery, endurance, and overall wellbeing."
  },
  "Vitamin C": {
    title: "Immunity",
    title_highlight: "Icon",
    description:
      "Vitamin C (ascorbic acid) is a powerful antioxidant that <span class=\"body-semibold-black font-20px darkmode\">strengthens immunity and speeds up recovery</span>. It supports collagen, endurance, and resilience against stress."
  },
  "Vitamin D": {
    title: "Sunshine",
    title_highlight: "Vitamin",
    description:
      "Vitamin D regulates calcium absorption and hormones, <span class=\"body-semibold-black font-20px darkmode\">boosting immunity, strength, and mood</span>. It enhances muscle performance, metabolism, and long-term resilience."
  },
  "Vitamin E": {
    title: "Cell",
    title_highlight: "Protector",
    description:
      "Vitamin E shields cells from oxidative stress, <span class=\"body-semibold-black font-20px darkmode\">protecting immunity, fertility, and skin health</span>. It slows aging, enhances vitality, and supports overall longevity."
  },
  "Zinc": {
    title: "Performance",
    title_highlight: "Powerhouse",
    description:
      "Zinc is essential for hormone balance and repair, <span class=\"body-semibold-black font-20px darkmode\">enhancing strength, recovery, and immunity</span>. It supports protein synthesis, endurance, and long-term resilience."
  },
  "The Sleep Protocol": {
    title: "Rest",
    title_highlight: "Redefined",
    description:
      "Nutricode’s Sleep Protocol blends adaptogens and nutrients that <span class=\"body-semibold-black font-20px darkmode\">lower stress hormones and improve sleep quality</span>. With Ashwagandha, Omega-3, B6, and Magnesium, it enhances nightly recovery and balance."
  },
  "The Fitness Protocol": {
    title: "Peak",
    title_highlight: "Performer",
    description:
      "Nutricode’s Fitness Protocol combines key nutrients to <span class=\"body-semibold-black font-20px darkmode\">unlock endurance, immunity, and lean muscle gains</span>. With Ashwagandha, Magnesium, Vitamin C, and Zinc, it accelerates recovery and performance."
  }
};





const supplementInFood = {
  "Ashwagandha": {
    "description":
      "Ashwagandha is a traditional adaptogen, but <span class=\"subtitle-highlight-darkmode\">its effective dose comes only from standardized extracts</span>. Since it’s not present in food, supplementation is the only way to benefit.",
    "foods": {
      "No Food": { "weight": "... g", "kcal": "... ", "dose": "... mg" }
    }
  },
  "Biotin": {
    "description":
      "Biotin exists in small amounts across foods, yet <span class=\"subtitle-highlight-darkmode\">even the richest sources fall short of the optimal dose</span>. High-dose supplementation is the only practical route for beauty and metabolic support.",
    "foods": {
      "Beef Liver": { "weight": "75 g", "kcal": "150", "dose": "31 mcg" },
      "Eggs": { "weight": "50 g", "kcal": "70", "dose": "10 mcg" },
      "Salmon": { "weight": "75 g", "kcal": "120", "dose": "5 mcg" },
      "Sunflower Seeds": { "weight": "35 g", "kcal": "200", "dose": "2.6 mcg" },
      "Sweet Potato": { "weight": "100 g", "kcal": "90", "dose": "2.4 mcg" }
    }
  },
  "Calcium": {
    "description":
      "Calcium is abundant in dairy and fish, but <span class=\"subtitle-highlight-darkmode\">many people fall short without consistent intake</span>. Supplements help maintain bone strength and cover higher daily needs.",
    "foods": {
      "Yogurt (low-fat)": { "weight": "245 g", "kcal": "150", "dose": "415 mg" },
      "Milk (whole)": { "weight": "240 g", "kcal": "150", "dose": "276 mg" },
      "Mozzarella Cheese": { "weight": "42 g", "kcal": "125", "dose": "333 mg" },
      "Sardines (with bones)": { "weight": "75 g", "kcal": "150", "dose": "325 mg" },
      "Tofu": { "weight": "126 g", "kcal": "95", "dose": "253 mg" }
    }
  },
  "CoQ10": {
    "description":
      "CoQ10 is present in organ meats and oily fish, but <span class=\"subtitle-highlight-darkmode\">dietary amounts are far below effective levels</span>. Supplementation is the only realistic way to support energy and heart health.",
    "foods": {
      "Beef Heart": { "weight": "75 g", "kcal": "130", "dose": "8 mg" },
      "Beef Liver": { "weight": "75 g", "kcal": "150", "dose": "3 mg" },
      "Sardines": { "weight": "75 g", "kcal": "150", "dose": "5 mg" },
      "Mackerel": { "weight": "75 g", "kcal": "200", "dose": "5 mg" },
      "Peanuts": { "weight": "28 g", "kcal": "160", "dose": "1 mg" }
    }
  },
  "Folic Acid": {
    "description":
      "Folate is found in greens, legumes, and liver, yet <span class=\"subtitle-highlight-darkmode\">reaching optimal levels daily can be difficult</span>. Supplementation ensures consistency, especially in pregnancy.",
    "foods": {
      "Chicken Liver": { "weight": "75 g", "kcal": "130", "dose": "250 mcg" },
      "Lentils (cooked)": { "weight": "90 g", "kcal": "115", "dose": "180 mcg" },
      "Spinach (cooked)": { "weight": "90 g", "kcal": "20", "dose": "130 mcg" },
      "Asparagus": { "weight": "90 g", "kcal": "20", "dose": "134 mcg" },
      "Sunflower Seeds": { "weight": "35 g", "kcal": "200", "dose": "82 mcg" }
    }
  },
  "Iron": {
    "description":
      "Iron is in many foods, but <span class=\"subtitle-highlight-darkmode\">absorption is low and inconsistent</span>. Supplements provide a reliable way to maintain healthy oxygen transport and energy.",
    "foods": {
      "Clams": { "weight": "75 g", "kcal": "125", "dose": "24 mg" },
      "Chicken Liver": { "weight": "75 g", "kcal": "135", "dose": "11 mg" },
      "White Beans (cooked)": { "weight": "180 g", "kcal": "220", "dose": "7 mg" },
      "Spinach (cooked)": { "weight": "90 g", "kcal": "20", "dose": "3 mg" },
      "Beef (sirloin steak)": { "weight": "75 g", "kcal": "150", "dose": "2 mg" }
    }
  },
  "Magnesium": {
    "description":
      "Seeds, nuts, and greens provide magnesium, but <span class=\"subtitle-highlight-darkmode\">hitting optimal levels requires multiple servings daily</span>. Supplements help sustain sleep, recovery, and muscle function.",
    "foods": {
      "Pumpkin Seeds": { "weight": "28 g", "kcal": "160", "dose": "150 mg" },
      "Almonds": { "weight": "28 g", "kcal": "170", "dose": "80 mg" },
      "Spinach (cooked)": { "weight": "180 g", "kcal": "40", "dose": "157 mg" },
      "Black Beans (cooked)": { "weight": "170 g", "kcal": "220", "dose": "120 mg" },
      "Quinoa (cooked)": { "weight": "185 g", "kcal": "220", "dose": "118 mg" }
    }
  },
  "Omega 3": {
    "description":
      "Fatty fish give EPA and DHA, yet <span class=\"subtitle-highlight-darkmode\">most diets don’t include enough for optimal levels</span>. Supplements ensure consistent intake for heart, brain, and recovery.",
    "foods": {
      "Mackerel (Atlantic)": { "weight": "75 g", "kcal": "200", "dose": "1700 mg" },
      "Salmon": { "weight": "75 g", "kcal": "150", "dose": "1500 mg" },
      "Sardines": { "weight": "75 g", "kcal": "150", "dose": "1100 mg" },
      "Flaxseed (ground)": { "weight": "14 g", "kcal": "75", "dose": "3200 mg (ALA)" },
      "Chia Seeds": { "weight": "28 g", "kcal": "140", "dose": "5000 mg (ALA)" }
    }
  },
  "Probiotics": {
    "description":
      "Fermented foods contain probiotics, but <span class=\"subtitle-highlight-darkmode\">their potency and strains vary widely</span>. Supplements provide consistent, high-CFU support for gut and immune health.",
    "foods": {
      "Yogurt (with live cultures)": { "weight": "245 g", "kcal": "150", "dose": "1–10 billion CFU" },
      "Kefir": { "weight": "240 g", "kcal": "160", "dose": "10–20b CFU" },
      "Kimchi": { "weight": "85 g", "kcal": "20", "dose": "1–5b CFU" },
      "Sauerkraut (raw)": { "weight": "85 g", "kcal": "15", "dose": "1–3b CFU" }
    }
  },
  "Vitamin B12": {
    "description":
      "B12 is abundant in animal foods, but <span class=\"subtitle-highlight-darkmode\">even top sources provide far below optimal doses</span>. Supplementation ensures adequacy, especially with absorption issues or vegan diets.",
    "foods": {
      "Clams": { "weight": "75 g", "kcal": "125", "dose": "84 mcg" },
      "Beef Liver": { "weight": "75 g", "kcal": "150", "dose": "71 mcg" },
      "Mussels": { "weight": "75 g", "kcal": "130", "dose": "20 mcg" },
      "Salmon": { "weight": "75 g", "kcal": "150", "dose": "5 mcg" }
    }
  },
  "Vitamin B2": {
    "description":
      "Riboflavin is scattered across foods, but <span class=\"subtitle-highlight-darkmode\">getting high-dose levels from diet alone is unrealistic</span>. Supplements are the practical way to meet performance needs.",
    "foods": {
      "Beef Liver": { "weight": "75 g", "kcal": "150", "dose": "2.9 mg" },
      "Yogurt (low-fat)": { "weight": "245 g", "kcal": "135", "dose": "0.6 mg" },
      "Milk (low-fat)": { "weight": "240 g", "kcal": "120", "dose": "0.5 mg" },
      "Mushrooms (portabella)": { "weight": "69 g", "kcal": "15", "dose": "0.3 mg" },
      "Almonds": { "weight": "28 g", "kcal": "170", "dose": "0.3 mg" }
    }
  },
  "Vitamin B6": {
    "description":
      "B6 shows up in many foods, but <span class=\"subtitle-highlight-darkmode\">performance-focused intake is hard to reach naturally</span>. Supplementation supports higher needs for recovery and energy.",
    "foods": {
      "Chickpeas (boiled)": { "weight": "165 g", "kcal": "270", "dose": "1.1 mg" },
      "Tuna": { "weight": "75 g", "kcal": "100", "dose": "0.88 mg" },
      "Beef Liver": { "weight": "75 g", "kcal": "150", "dose": "0.9 mg" },
      "Potato": { "weight": "150 g", "kcal": "130", "dose": "0.63 mg" },
      "Banana": { "weight": "118 g", "kcal": "105", "dose": "0.4 mg" }
    }
  },
  "Vitamin C": {
    "description":
      "Fruits and vegetables contain vitamin C, but <span class=\"subtitle-highlight-darkmode\">servings rarely reach the high doses used for recovery</span>. Supplements make optimal levels practical and consistent.",
    "foods": {
      "Red Bell Pepper": { "weight": "75 g", "kcal": "20", "dose": "142 mg" },
      "Kiwi": { "weight": "76 g", "kcal": "45", "dose": "70 mg" },
      "Orange": { "weight": "131 g", "kcal": "62", "dose": "70 mg" },
      "Strawberries": { "weight": "144 g", "kcal": "46", "dose": "85 mg" },
      "Broccoli (cooked)": { "weight": "78 g", "kcal": "25", "dose": "51 mg" }
    }
  },
  "Vitamin D": {
    "description":
      "Only a few foods contain vitamin D, and <span class=\"subtitle-highlight-darkmode\">diet alone rarely provides enough for optimal levels</span>. With sun exposure inconsistent, supplementation becomes essential.",
    "foods": {
      "Salmon": { "weight": "75 g", "kcal": "150", "dose": "500 IU" },
      "Sardines": { "weight": "75 g", "kcal": "150", "dose": "300 IU" },
      "Egg Yolk": { "weight": "20 g", "kcal": "55", "dose": "40 IU" },
      "Mushrooms (UV-exposed)": { "weight": "70 g", "kcal": "20", "dose": "400 IU" },
      "Fortified Milk": { "weight": "240 g", "kcal": "150", "dose": "120 IU" }
    }
  },
  "Vitamin E": {
    "description":
      "Oils, nuts, and seeds provide vitamin E, but <span class=\"subtitle-highlight-darkmode\">optimal levels usually require supplementation</span>. It’s difficult to reach the target consistently from diet alone.",
    "foods": {
      "Wheat Germ Oil": { "weight": "14 g", "kcal": "120", "dose": "20.3 mg" },
      "Sunflower Seeds": { "weight": "28 g", "kcal": "165", "dose": "7.4 mg" },
      "Almonds": { "weight": "28 g", "kcal": "170", "dose": "6.8 mg" },
      "Hazelnuts": { "weight": "28 g", "kcal": "178", "dose": "4.3 mg" },
      "Peanut Butter": { "weight": "32 g", "kcal": "190", "dose": "2.9 mg" }
    }
  },
  "Zinc": {
    "description":
      "Zinc is rich in shellfish and meat, but <span class=\"subtitle-highlight-darkmode\">most diets don’t include enough consistently</span>. Supplements ensure steady levels for strength, immunity, and recovery.",
    "foods": {
      "Oysters": { "weight": "75 g", "kcal": "65", "dose": "32 mg" },
      "Beef (chuck roast)": { "weight": "75 g", "kcal": "180", "dose": "5 mg" },
      "Pumpkin Seeds": { "weight": "30 g", "kcal": "170", "dose": "2.5 mg" },
      "Baked Beans": { "weight": "175 g", "kcal": "210", "dose": "4 mg" },
      "Chicken Thigh": { "weight": "75 g", "kcal": "135", "dose": "2 mg" }
    }
  }
};




const foodImages = {
  "Almonds": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/almonds-min.png?v=1754955582",
  "Asparagus": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/aspargus-min.png?v=1754955581",
  "Baked Beans (canned)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/baked-beans-min.png?v=1754955581",
  "Baked Beans": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/baked-beans-min.png?v=1754955581",
  "Banana": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/banana-min.png?v=1754955578",
  "Bananas": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/banana-min.png?v=1754955578",
  "Beef (chuck roast)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/beef-roast-min.png?v=1754955583",
  "Beef": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/beef-roast-min.png?v=1754955583",
  "Beef (sirloin steak)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/beef-steak-min.png?v=1754955585",
  "Beef Heart": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/beef-heart-min.png?v=1754955582",
  "Beef Liver": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/beef-liver-min.png?v=1754955582",
  "Black Beans (cooked)":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/black-beans-min.png?v=1755239588",
  "Beans": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/black-beans-min.png?v=1755239588",
  "Broccoli (cooked)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/broccoli-min.png?v=1754955582",
  "Chia Seeds": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/chia_seeds-min.png?v=1754894681",
  "Chicken Liver": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/chicken-liver-min.png?v=1754955582",
  "Chicken Thigh": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/chicken-tigh-min.png?v=1754955581",
  "Chicken": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/chicken-min.png?v=1759635262",
  "Chickpeas (boiled)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/chickpeas-min.png?v=1754955581",
  "Clams": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/clams-min.png?v=1754955582",
  "Clams (canned)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/clams-min.png?v=1754955582",
  "Cruciferous Vegetables": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/broccoli-min.png?v=1754955582",
  "Egg (whole, cooked)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/eggs-min.png?v=1754894681",
  "Eggs": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/eggs-min.png?v=1754894681",
  "Egg Yolk": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/eggs-min.png?v=1754894681",
  "Fish": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/mackerel-min.png?v=1754894681",
  "Flaxseed (ground)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/flaxseed-min.png?v=1754955582",
  "Fortified Milk": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/milk-min.png?v=1754955582",
  "Grapes": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/grapes-min.png?v=1759631645",
  "Hazelnuts": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/hazelnuts-min.png?v=1754955581",
  "Kefir": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/kefir-min.png?v=1754955581",
  "Kimchi": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/kimchi-min.png?v=1754955582",
  "Kiwi": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/kiwi-min.png?v=1754955466",
  "Leafy greens": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/spinach-min.png?v=1754955466",
  "Lentils (cooked)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/lentils-min.png?v=1754955467",
  "Mackerel": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/mackerel-min.png?v=1754894681",
  "Mackerel (Atlantic)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/mackerel-min.png?v=1754894681",
  "Mango": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/mango-min.png?v=1759631644",
  "Milk": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/milk-min.png?v=1754955582",
  "Melon": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/melon-min.png?v=1759631645",
  "Milk (low-fat)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/milk-min.png?v=1754955582",
  "Milk (whole)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/milk-min.png?v=1754955582",
  "Mozzarella Cheese": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/mozarella-min.png?v=1754955466",
  "Mushrooms": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/mushroom-min.png?v=1754955467",
  "Mushrooms (UV-exposed)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/mushroom-min.png?v=1754955467",
  "Mushrooms (portabella)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/mushroom-min.png?v=1754955467",
  "Mussels": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/mussels-min.png?v=1754955467",
  "No Food": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/no-food.png?v=1757057222",
  "Nightshades": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/nightshades-min.png?v=1759577946",
  "Nuts": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/nuts-min.png?v=1759577946",
  "Oats": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/oats-min.png?v=1759631645",
  "Oysters": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/oysters-min.png?v=1754955467",
  "Orange": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/orange-min.png?v=1754955465",
  "Citrus Fruit": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/citrusFruits-min.png?v=1759577945",
  "Peanut Butter": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/peanut-butter-min.png?v=1754955467",
  "Peanuts": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/peanut-min.png?v=1754955466",
  "Pork": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/pork-min.png?v=1759631645",
  "Potato (baked w/skin)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/potato-min.png?v=1754955466",
  "Potato": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/potato-min.png?v=1754955466",
  "Pineapple": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/pineapple-min.png?v=1759631644",
  "Pumpkin Seeds": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/pumpkin-seeds-min.png?v=1754955467",
  "Quinoa": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/quinoa-min.png?v=1754955467",
  "Quinoa (cooked)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/quinoa-min.png?v=1754955467",
  "Red Bell Pepper": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/red-bell-pepper-min.png?v=1754955466",
  "Root vegetables": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/rootVegetables-min.png?v=1759577946",
  "Salmon": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/salmon-min.png?v=1754894681",
  "Salmon (farmed)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/salmon-min.png?v=1754894681",
  "Sardines": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/sardines-min.png?v=1754894681",
  "Sardines (canned)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/sardines-min.png?v=1754894681",
  "Sardines (with bones)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/sardines-min.png?v=1754894681",
  "Sauerkraut (raw)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/sauerkraut-min.png?v=1754955467",
  "Seeds": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/chia_seeds-min.png?v=1754894681",
  "Shellfish": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/shellfish-min.png?v=1759635262",
  "Spinach (cooked)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/spinach-min.png?v=1754955466",
  "Strawberries": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/strawberry-min.png?v=1754955466",
  "Berries": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/strawberry-min.png?v=1754955466",
  "Sunflower Seeds": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/sunflower-seed-min.png?v=1754955467",
  "Sunlight": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/sunlight-min.png?v=1759577945",
  "Sweet Potato": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/sweet-potato-min.png?v=1754955466",
  "Tofu": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/tofu-min.png?v=1754955466",
  "Tuna": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/tuna-min.png?v=1754894681",
  "White Beans (cooked)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/white-beans-min.png?v=1754955466",
  "Wheat Germ Oil": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/wheat_oil-min.png?v=1754894680",
  "Yogurt (fat-free)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/yogurt-min.png?v=1754955466",
  "Yogurt (plain, low-fat)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/yogurt-min.png?v=1754955466",
  "Yogurt (low-fat)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/yogurt-min.png?v=1754955466",
  "Yogurt (with live cultures)": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/yogurt-min.png?v=1754955466"
};





const disclaimerTextDict = {
    "Ashwagandha": "This information is provided for educational purposes only and is not a substitute for professional medical advice. Consult your healthcare provider before use, especially if you are pregnant, nursing, have a medical condition, or are taking prescription medication.",
    "Biotin": "This content is for educational purposes only and should not replace medical guidance. Speak with your doctor or healthcare professional before use, particularly if you have underlying health conditions, are pregnant or nursing, or are taking other supplements or medications.",
    "Calcium": "For educational purposes only. Always consult a qualified healthcare provider before starting this supplement, especially if you have a history of kidney problems, calcium disorders, or are taking prescription medications that may interact with calcium.",
    "CoQ10": "This information is for educational purposes only and should not be taken as medical advice. Consult your doctor before using CoQ10, particularly if you have heart conditions, are on blood thinners, or take other prescription medications.",
    "Folic Acid": "Provided for educational purposes only and not as a substitute for medical advice. Always speak with a healthcare professional before use, especially if you are pregnant, planning to become pregnant, nursing, or taking medication.",
    "Iron": "This information is for educational purposes only and should not replace professional medical advice. Consult your doctor before use, as excessive iron can be harmful and may cause health issues. Iron supplements should be kept out of reach of children at all times.",
    "Magnesium": "For educational purposes only. Always consult your doctor or healthcare provider before use, particularly if you have kidney disease, heart conditions, or are taking medications that may interact with magnesium.",
    "Omega 3": "This information is provided for educational purposes only and does not replace medical advice. Consult a healthcare professional before use, especially if you take blood-thinning medication, have bleeding disorders, or are scheduled for surgery.",
    "Probiotics": "Educational use only — not intended as medical advice. Speak with your doctor before use, particularly if you have a compromised immune system, chronic illness, or are taking other supplements or medications.",
    "Vitamin B12": "For educational purposes only and not a replacement for professional medical advice. Always consult your healthcare provider before use, especially if you have a medical condition, take medications, or have specific dietary requirements.",
    "Vitamin B2": "Provided for educational purposes only. Consult your doctor before starting supplementation, especially if you have underlying medical conditions or are taking other medications or supplements.",
    "Vitamin B6": "For educational purposes only and not intended as medical advice. Speak with your healthcare professional before use, especially if you take other supplements or prescription medications.",
    "Vitamin C": "This content is for educational purposes only and is not a substitute for medical advice. Consult your doctor before use, particularly if you have a history of kidney stones, metabolic conditions, or are taking other medications.",
    "Vitamin D": "For educational purposes only and not a substitute for professional healthcare advice. Speak to your doctor before use, as excessive vitamin D can be harmful, especially if you have certain medical conditions or take other supplements.",
    "Vitamin E": "This information is for educational purposes only and should not be considered medical advice. Always consult your healthcare provider before use, particularly if you are on blood thinners or have bleeding disorders.",
    "Zinc": "For educational purposes only and not a replacement for medical advice. Consult your doctor before use, especially if you take other supplements, have health conditions, or are on prescription medications.",
    "The Sleep Protocol": "This pack combines several supplements to support better sleep and recovery. It is provided for educational purposes only and should not replace professional medical advice. Please review the individual supplement pages for detailed facts, potential allergens, and dietary considerations. If you have any medical conditions, are pregnant or nursing, or take prescription medications, consult your healthcare provider before use.",
    "The Fitness Protocol": "This pack is designed to support strength, endurance, and recovery with a combination of supplements. It is provided for educational purposes only and is not intended as medical advice. Be sure to review the individual supplement pages for full details on ingredients, potential allergens, and dietary restrictions. If you have health concerns, existing conditions, or take prescription medications, consult a qualified healthcare professional before use."
};






const faqProductPage = {
    "Your Protocol": [
      {
        "question": "How can I manage my subscription?",
        "answer": "You can manage everything directly in the Nutricode App or on our website. Pause or cancel you subscription anytime."
      },
      {
        "question": "Will I always have 4 supplements?",
        "answer": "No. Your protocol can include 4 to 6 supplements, always at the same price, based on your wearable data, health metrics, and objective, and selecte from our curated list of 16 supplements."
      },
      {
        "question": "When will I receive my Nutricode Box?",
        "answer": "Your first box ships within 3–5 business days after purchase. Future boxes are delivered monthly, aligned with your new recommendations."
      },
      {
        "question": "Can I use Nutricode if I already take other supplements?",
        "answer": "Yes. You can log other supplements in the app, and we will update your protocol to avoid overlaps or unnecessary combinations."
      },
      {
        "question": "How do I log into the Nutricode App?",
        "answer": "After subscribing, you’ll get your login details with your first box. Use your registered email or reset your password anytime."
      },
      {
        "question": "Which wearable devices are supported?",
        "answer": "Nutricode currently integrates with Apple Watch, WHOOP, and Garmin to analyze your health data and personalize your supplement protocol."
      }
    ],

    "Recommendation": [
      {
        "question": "How were these supplements chosen from my answers?",
        "answer": "Your answers show your goals and what might be holding your metrics back. We use that to build your protocol."
      },
      {
        "question": "What does the tag on each card mean (Recovery, Sleep, Energy, etc.)?",
        "answer": "The tag is the main goal that supplement supports. It shows what metric area it is meant to improve."
      },
      {
        "question": "Can I remove a supplement or swap it for something else?",
        "answer": "Yes. Tap Continue to edit your protocol and swap or remove supplements. The quiz is your best first protocol based on your answers."
      },
      {
        "question": "I already take some of these, should I keep them or replace them?",
        "answer": "You can keep them if the dose and quality match the protocol. The key is consistency so your data can show clear changes."
      },
      {
        "question": "What is “Diet Gaps” and how is “already getting from food” calculated?",
        "answer": "Diet Gaps estimates how much of the protocol nutrients you already get from food. It uses your quiz diet answers, not a blood test."
      },
      {
        "question": "Why does a nutrient show low or 0 even if I eat some of those foods?",
        "answer": "Some nutrients are hard to get enough of from food alone. It can also be because the quiz only counts foods you said you eat often."
      },
      {
        "question": "What does the score out of 10 mean in the Benefits section?",
        "answer": "It is a strength score based on the research and the size of the effect seen. Higher means stronger evidence for that benefit."
      },
      {
        "question": "Where does the supporting research come from and how should I read it?",
        "answer": "We link to published studies from major research databases. We look for human studies, the dose used, and how long the study ran so you can compare it to your protocol."
      },
      {
        "question": "How long until I should expect to notice changes, and what should I track to know it’s working?",
        "answer": "Small changes in your metrics can show in 1 to 2 weeks, but stronger changes usually take 8 to 16 weeks."
      },
      {
        "question": "Are there any interactions with medications or other supplements I might be taking?",
        "answer": "Yes, some supplements can interact or overlap. If you take medication or have a condition, check with your healthcare professional first."
      },
      {
        "question": "If I improve my diet, will these recommendations change (and how often should I retake the quiz)?",
        "answer": "Yes, better diet can change what your protocol needs. Retake the quiz every 4 to 8 weeks or after a big routine change, and we use your tracking data to keep improving the protocol over time."
      }
    ],


    "Ashwagandha": [
      {
        "question": "Why might I take ashwagandha?",
        "answer": "Ashwagandha is a well-studied adaptogenic herb that helps the body manage stress, lower cortisol, improve sleep, and enhance mood and resilience during stressful periods."
      },
      {
        "question": "Does ashwagandha support fitness performance?",
        "answer": "Yes—clinical studies and meta-analyses show that taking 300–1,000 mg daily for 8–12 weeks can increase muscle strength, power, and VO₂ max by approximately 6–14%, while also reducing fatigue and boosting recovery."
      },
      {
        "question": "How much should I take and when is the best time?",
        "answer": "Most trials use 300–600 mg of standardized root extract twice daily with meals. Some athlete-focused protocols go up to 1,000 mg per day."
      },
      {
        "question": "How soon can I expect benefits?",
        "answer": "Stress and sleep benefits usually begin within 6–8 weeks, while improvements in strength, endurance, and recovery tend to appear around 8–12 weeks."
      },
      {
        "question": "Is it safe and what side effects should I look out for?",
        "answer": "Short-term use (up to 12 weeks) is generally safe. Mild side effects may include gastrointestinal issues, nausea, or drowsiness. Rare cases of liver enzyme changes and effects on thyroid have been reported."
      },
      {
        "question": "Can ashwagandha interact with medications?",
        "answer": "Yes—ashwagandha may potentiate sedatives, interact with thyroid medications, and slightly elevate testosterone. Individuals on such treatments or with hormone-sensitive conditions should consult a healthcare provider before using it."
      }
    ],
    "Omega 3": [
      {
        "question": "Why might I take an omega‑3 supplement?",
        "answer": "EPA and DHA are important fats that support heart health, reduce mild inflammation, and benefit brain and eye function—especially if you don’t eat oily fish regularly."
      },
      {
        "question": "Should I get omega‑3 from food or supplements?",
        "answer": "While fatty fish like salmon and sardines are excellent sources, achieving a consistent therapeutic intake of around 1–2 g per day can be difficult through diet alone."
      },
      {
        "question": "How much is considered optimal?",
        "answer": "Most studies recommend 1,000–2,000 mg of combined EPA and DHA per day. The FDA considers total intake up to 3 g/day safe."
      },
      {
        "question": "When might I begin to see benefits?",
        "answer": "You may notice improvements in triglycerides, blood pressure, or inflammation within 4–12 weeks. Effects on mood or joint comfort might take longer."
      },
      {
        "question": "Are there any side effects or precautions?",
        "answer": "Some people experience fishy burps, mild aftertaste, or occasional indigestion—these are generally mild and often resolved by taking the supplement with food. If you're unsure about starting omega‑3, especially with pre-existing health conditions or medications, speaking with your healthcare provider is a good idea."
      }
    ],
    "Iron": [
      {
        "question": "Why might I need an iron supplement?",
        "answer": "Iron is essential for carrying oxygen in your blood and supporting overall energy levels. Because absorption from food typically ranges from only 5–35%, supplementing may be necessary to prevent or correct lower iron levels."
      },
      {
        "question": "How should I take iron for best absorption?",
        "answer": "Take your iron supplement on an empty stomach or with vitamin C to enhance absorption. Avoid taking it together with calcium-rich foods, antacids, coffee, or tea, as these can interfere with how much your body absorbs."
      },
      {
        "question": "How soon will I feel better?",
        "answer": "Many people notice improved energy and increased hemoglobin levels within 6–8 weeks, though replenishing your full iron stores may take several months."
      },
      {
        "question": "What side effects should I watch for?",
        "answer": "Mild digestive side effects—such as stomach cramps, nausea, constipation, diarrhea, and dark-colored stools—are common. These often lessen as your body adjusts. If side effects persist or worsen, switching to a gentler iron form or lowering the dose may help. Always consult your healthcare provider if discomfort continues."
      },
      {
        "question": "When should I consult a healthcare provider?",
        "answer": "You should check with your provider if you experience ongoing side effects, symptoms like unusual fatigue or shortness of breath, if your stool is tarry or contains blood, or if you're considering taking iron long-term. They can review your blood test results and guide appropriate dosing and duration."
      }
    ],
    "Magnesium": [
      {
        "question": "Why might I take magnesium?",
        "answer": "Magnesium supports muscle and nerve function, blood pressure regulation, bone health, sleep quality, energy production, and stress response. Many people don’t get enough from their diet, so supplementation helps fill that gap."
      },
      {
        "question": "How much should I take and when?",
        "answer": "The recommended daily intake is typically 310–420 mg. A gentle, well-absorbed option is Nutricode Magnesium Bisglycinate, which is easy on digestion."
      },
      {
        "question": "What side effects should I watch for?",
        "answer": "Minor digestive symptoms—such as diarrhea, nausea, or stomach cramps—can occur, especially at higher doses. These usually lessen with a lower dose or by adjusting timing. If symptoms persist, it’s best to consult your healthcare provider."
      },
      {
        "question": "When should I consult a healthcare provider?",
        "answer": "Speak with your provider if you take medications like diuretics or heart medications, have kidney issues, or plan to take magnesium long-term. They can help determine the appropriate dosage and monitor for any interactions."
      }
    ],
    "CoQ10": [
        {
          "question": "Why might I take CoQ10?",
          "answer": "CoQ10 is a naturally occurring antioxidant and a key player in cellular energy production. It supports heart health, may enhance exercise performance, and could relieve migraine-related symptoms."
        },
        {
          "question": "How much should I take and when is it best?",
          "answer": "Daily doses of 100–200 mg are commonly studied, though some conditions may require higher amounts. Because CoQ10 is fat-soluble, taking it with a meal that contains fat helps improve absorption."
        },
        {
          "question": "When might I notice benefits?",
          "answer": "Depending on the use case — such as improved endurance, heart function, or fewer migraines — benefits may be noticed after several weeks to a few months."
        },
        {
          "question": "What side effects should I watch for?",
          "answer": "CoQ10 is generally well tolerated. Some people report mild side effects like nausea, stomach upset, diarrhea, headache, or insomnia. These are typically dose-dependent and may resolve if the dose is reduced."
        },
        {
          "question": "Can CoQ10 interact with medications or health conditions?",
          "answer": "Yes. CoQ10 may affect the action of warfarin and should be used with caution if you take blood pressure, diabetes, or chemotherapy medications. Pregnant or breastfeeding individuals should consult a healthcare provider before use."
        },
        {
          "question": "Is it safe for long-term use?",
          "answer": "Research shows CoQ10 is safe and non-toxic even at doses up to 1,200 mg/day, although typical doses remain within 100–300 mg/day. Still, it’s best to discuss long-term use and dosing with your healthcare provider."
        }
      ],
      "Calcium": [
        {
          "question": "Why might I take calcium supplements?",
          "answer": "Calcium supports bone strength, muscle and nerve function, and blood vessel health. While many people get enough from food, those with limited dietary intake, older adults, or individuals with certain medical conditions may benefit from supplementation to support bone health."
        },
        {
          "question": "What side effects might I experience?",
          "answer": "The most common side effects are gas, bloating, and mild constipation. Calcium carbonate tends to cause more digestive discomfort, while calcium citrate is usually easier on the stomach."
        },
        {
          "question": "Can calcium interact with other supplements or medications?",
          "answer": "Yes—calcium can reduce the absorption of thyroid medications, antibiotics, bisphosphonates, and certain blood pressure medications. Spacing out doses by a few hours and discussing supplement timing with your healthcare provider can help avoid issues."
        },
        {
          "question": "When should I consult a healthcare provider?",
          "answer": "Consult your provider before starting calcium supplements if you have a history of kidney stones, heart conditions, gastrointestinal disorders, or take medications like blood pressure drugs or antacids. They can assess your dietary calcium intake, recommend an appropriate dose and form, and guide the combination with vitamin D."
        }
      ],
      "Vitamin B12": [
        {
          "question": "Why might I take vitamin B12?",
          "answer": "Vitamin B12 supports red blood cell production, nerve function, DNA synthesis, and energy metabolism. It is especially helpful for vegetarians, vegans, older adults, people with absorption issues, or those taking certain medications that can impair B12 uptake."
        },
        {
          "question": "Can I get enough from food?",
          "answer": "Many people meet their B12 needs through animal-based foods or fortified sources. However, those with low intake or impaired absorption may require a supplement to maintain healthy levels."
        },
        {
          "question": "Is it safe and are there side effects?",
          "answer": "Vitamin B12 is considered very safe since it’s water-soluble and excess is excreted in urine. Oral supplements rarely cause side effects, though injections might occasionally cause mild skin reactions."
        },
        {
          "question": "Can vitamin B12 interact with medications or health conditions?",
          "answer": "Some medications—like metformin, proton-pump inhibitors, and gastrointestinal treatments—can reduce B12 absorption. If you're on such medications or have health conditions affecting digestion, discuss B12 supplementation with your healthcare provider."
        },
        {
          "question": "When should I consult a healthcare provider?",
          "answer": "If you experience fatigue, nerve-related symptoms, low B12 lab results, or belong to at-risk groups, it’s important to seek medical advice. A provider can assess your status and guide appropriate supplementation."
        }
      ],
      "Vitamin B2": [
        {
          "question": "Why might I take vitamin B2?",
          "answer": "Vitamin B2 (riboflavin) plays an essential role in energy production, antioxidant protection, and maintaining healthy blood cells, skin, and nervous system function."
        },
        {
          "question": "Can it help with migraines?",
          "answer": "Yes, research suggests that taking high-dose riboflavin (around 400 mg daily) for several months may reduce the frequency and severity of migraines for some people."
        },
        {
          "question": "Is it safe, and are there side effects?",
          "answer": "Riboflavin is generally well tolerated. One harmless and common side effect is bright yellow urine. In rare cases, doses over 100 mg may cause mild digestive symptoms."
        },
        {
          "question": "Can it interact with medications or health conditions?",
          "answer": "Riboflavin has low potential for interactions. However, if you are pregnant, breastfeeding, have kidney issues, or take multiple medications, checking with your healthcare provider before supplementing is wise."
        },
        {
          "question": "When should I consult a healthcare provider?",
          "answer": "If you experience ongoing symptoms like fatigue, digestive troubles, or changes in urine color that worry you—or if you’re taking high doses for migraine prevention—your provider can review your needs, monitor safety, and check for any nutrient interactions."
        }
      ],
      "Vitamin B6": [
        {
          "question": "Why might I take vitamin B6?",
          "answer": "Vitamin B6 supports immune function, protein and neurotransmitter metabolism, red blood cell production, and healthy nerve function."
        },
        {
          "question": "Can it help with specific conditions like PMS or nausea?",
          "answer": "Yes. Clinical evidence suggests vitamin B6 may help reduce symptoms of premenstrual syndrome and ease mild morning sickness in pregnancy."
        },
        {
          "question": "Is it safe and are there any side effects?",
          "answer": "Vitamin B6 is generally safe in recommended amounts. Occasionally, high-dose supplementation can cause mild digestive symptoms, skin sensitivity, or tingling in hands or feet."
        },
        {
          "question": "Are there risks with long-term or high doses?",
          "answer": "In rare cases, long-term intake of very high doses has been associated with reversible nerve issues. If you're taking high-dose B6 for an extended period, it’s wise to check in regularly with your healthcare provider."
        },
        {
          "question": "Can vitamin B6 interact with medications or medical conditions?",
          "answer": "Yes. Certain drugs, such as those for epilepsy, tuberculosis, or others, may affect B6 levels or vice versa. If you’re taking ongoing medication or have medical conditions, consult your healthcare provider before starting B6 supplements."
        },
        {
          "question": "When should I consult a healthcare provider?",
          "answer": "If you experience symptoms like unusual nerve sensations, persistent skin reactions, or GI issues—or if you’re considering high-dose or long-term B6—it’s best to seek professional guidance for safe and effective use."
        }
      ],
      "Vitamin C": [
    {
      "question": "Why might I take vitamin C?",
      "answer": "Vitamin C supports immune function by aiding white blood cell activity and acts as an antioxidant that helps protect cells and promote wound healing."
    },
    {
      "question": "Can diet alone provide enough vitamin C?",
      "answer": "While many people meet basic needs through fruits and vegetables, supplementing may help ensure sufficient intake—especially during times of illness, heavy physical activity, or limited sun exposure."
    },
    {
      "question": "When might I notice benefits?",
      "answer": "Regular intake of vitamin C can modestly shorten the duration of colds and reduce symptom severity. Immune and tissue support effects are typically seen within a few weeks to a couple of months."
    },
    {
      "question": "Are there side effects I should consider?",
      "answer": "Common side effects at higher supplemental doses include diarrhea, nausea, abdominal cramps, heartburn, and headache — generally mild and dose-dependent."
    },
    {
      "question": "Is it safe to take long-term?",
      "answer": "Vitamin C is water-soluble and excess is excreted in urine. It has low toxicity and is well tolerated. To avoid gastrointestinal discomfort, it’s best to keep supplemental doses below 2,000 mg per day."
    },
    {
      "question": "Can vitamin C interact with medications or health conditions?",
      "answer": "Yes. Vitamin C may reduce the effectiveness of certain medications, increase aluminum absorption, and alter blood sugar readings. If you are taking medications or have health conditions, it's best to discuss with your healthcare provider before supplementing."
    },
    {
      "question": "When should I see a healthcare provider?",
      "answer": "Consult your provider if you experience unusual symptoms such as persistent gastrointestinal discomfort, kidney issues, or changes in lab results. They can help assess whether supplementation is appropriate."
    }
  ],
  "Vitamin D": [
    {
      "question": "Why might I take vitamin D?",
      "answer": "Vitamin D supports healthy bones, muscles, and immune function. It’s particularly helpful when sun exposure is limited or dietary intake is low, ensuring more reliable nutrient levels."
    },
    {
      "question": "When might I notice benefits?",
      "answer": "Consistent supplementation often leads to improved blood markers and bone health within 4–12 weeks, though individual responses can vary."
    },
    {
      "question": "Are there side effects or precautions?",
      "answer": "Vitamin D is generally well tolerated at typical doses. Mild digestive symptoms may occur. Since it affects calcium metabolism, it’s advisable to consult your healthcare provider before starting supplementation."
    },
    {
      "question": "Which form of vitamin D is appropriate for me—pills or injections?",
      "answer": "For most people, oral pills are convenient and suitable. Injections are typically used when absorption issues exist or deficiency is confirmed, and should be administered under medical supervision."
    },
    {
      "question": "When should I consult a healthcare provider?",
      "answer": "If you have health conditions affecting calcium or vitamin D metabolism, take related medications, or experience fatigue or muscle weakness, it’s best to speak with your provider. They can test blood levels and guide appropriate dosing."
    }
  ],
  "Vitamin E": [
    {
      "question": "Why might I take vitamin E?",
      "answer": "Vitamin E is a powerful fat-soluble antioxidant that helps protect cells from oxidative stress, supporting immune function, skin health, and cardiovascular well-being."
    },
    {
      "question": "Can I get enough vitamin E from food?",
      "answer": "Most healthy people obtain sufficient vitamin E from dietary sources like nuts, seeds, and vegetable oils. Supplementation is typically reserved for those with dietary gaps or specific health conditions involving malabsorption."
    },
    {
      "question": "Are there side effects I should know about?",
      "answer": "When taken within typical supplement doses, vitamin E is generally well tolerated. Some individuals may experience mild symptoms such as nausea, stomach discomfort, or headache."
    },
    {
      "question": "Can vitamin E interact with medications?",
      "answer": "Yes—it may increase the risk of bleeding when taken alongside anticoagulants or antiplatelet drugs. High-dose vitamin E may also affect certain heart medications and immunosuppressants."
    },
    {
      "question": "When should I consult a healthcare provider?",
      "answer": "Speak with your provider if you have bleeding disorders, take medications that impact blood clotting, have conditions affecting fat absorption, or are considering high-dose vitamin E for a prolonged period."
    }
  ],
  "Zinc": [
    {
      "question": "Why might I take zinc?",
      "answer": "Zinc is an essential mineral that supports immune function, protein synthesis, wound healing, taste perception, and cell health. Supplementation may be helpful for individuals with restricted diets, digestive issues, or increased physical activity."
    },
    {
      "question": "Can zinc benefit my fitness or athletic performance?",
      "answer": "Yes. Adequate zinc supports protein synthesis, hormone production, and muscle recovery after exercise. In athletes, low zinc levels have been linked to decreased endurance, reduced strength, and slower recovery."
    },
    {
      "question": "Can zinc shorten the duration of a cold?",
      "answer": "Some studies suggest zinc taken early may modestly reduce the duration of cold symptoms, although evidence varies based on dosage and form."
    },
    {
      "question": "Is zinc supplementation safe?",
      "answer": "Zinc is generally well tolerated in recommended doses. Exceeding the recommended daily dose may cause mild stomach upset, nausea, metallic taste, or diarrhea. Long-term high-dose use can interfere with copper absorption and should be monitored."
    },
    {
      "question": "Can zinc interfere with medications or other nutrients?",
      "answer": "Yes—zinc can reduce the absorption of certain antibiotics and may compete with copper over time. To minimize interactions, take zinc separately from medications and multivitamins, and consult your healthcare provider."
    },
    {
      "question": "When should I consult a healthcare provider?",
      "answer": "If you experience lasting digestive symptoms, unusual side effects, plan long-term supplementation, or are using other medications or supplements, you should talk to your provider."
    }
  ],
  "Biotin": [
    {
      "question": "Why might I take biotin?",
      "answer": "Biotin is a B-vitamin involved in energy metabolism—the breakdown of fats, carbohydrates, and proteins. It also supports skin, hair, and nail health, especially in people with low or deficient levels."
    },
    {
      "question": "Can biotin really improve hair, skin, or nails?",
      "answer": "There is limited clinical evidence supporting biotin for general beauty benefits. Most benefits have been documented in individuals who were deficient. For people with normal biotin levels, benefits are less clear."
    },
    {
      "question": "Is biotin safe and are there side effects?",
      "answer": "Biotin is considered extremely safe even at high supplemental doses, with no established upper limit. One caveat: high levels may interfere with certain lab tests, so it’s best to stop taking biotin before blood work and inform your provider."
    },
    {
      "question": "Can it interact with medications or conditions?",
      "answer": "Biotin generally has a low risk of interactions. However, if you're undergoing surgery, taking high-dose supplements, or have health conditions or multiple medications, it’s wise to check with your healthcare provider."
    },
    {
      "question": "When should I consult a healthcare provider?",
      "answer": "If you’re considering high-dose biotin supplements or have upcoming lab tests, a healthcare provider can guide you on timing and dosage."
    }
  ],
  "Probiotics": [
    {
      "question": "Which probiotic strains are considered effective?",
      "answer": "Evidence supports strains from the genera Lactobacillus and Bifidobacterium, as well as the yeast Saccharomyces boulardii. These strains have been shown to support digestive health, immune function, and maintenance of gut barrier integrity."
    },
    {
      "question": "Why is strain selection important?",
      "answer": "Each strain can have different effects. For example, some are useful for diarrhea prevention while others benefit IBS or immune modulation. Selecting the right strain helps target specific health needs."
    },
    {
      "question": "Is supplementation better than getting probiotics from food?",
      "answer": "While fermented foods like yogurt and kimchi contain beneficial bacteria, supplements provide specific strains in controlled amounts—ensuring consistency and targeted support for health goals."
    },
    {
      "question": "How safe are probiotics?",
      "answer": "Probiotics are generally safe for healthy individuals, with mild side effects like gas or bloating being the most common. Those with weakened immune systems or serious conditions should consult a healthcare provider before use."
    },
    {
      "question": "When should I consult a healthcare provider?",
      "answer": "If you are immunocompromised, critically ill, pregnant, taking complex medications, or considering probiotics for infants or children, consult your provider for guidance."
    }
  ],
  "Folic Acid": [
    {
      "question": "Why might I take folic acid?",
      "answer": "Folic acid supports DNA synthesis, red blood cell formation, and fetal development. It is especially beneficial during early pregnancy to help promote healthy neural tube development."
    },
    {
      "question": "Can I rely on diet to meet this need?",
      "answer": "While leafy greens, legumes, and fortified grains provide folate, it can be difficult to consistently reach key intake levels through diet alone. A supplement adds a reliable source."
    },
    {
      "question": "Is it safe and are there side effects?",
      "answer": "Folic acid is generally well tolerated at typical doses. In rare cases, it may mask a vitamin B12 deficiency—if you’re concerned or undergoing testing, it’s best to consult your healthcare provider."
    },
    {
      "question": "Do I need folic acid for other health reasons?",
      "answer": "Adequate folate plays a key role in maintaining healthy blood cell production. If you're unsure whether you need a supplement for additional benefits, consulting a healthcare provider is a good step."
    }
  ],
  "The Energy Protocol": [
    {
      "question": "What is the main purpose of The Energy Protocol?",
      "answer": "The Energy Protocol is designed to support sustained energy production, reduce fatigue, and enhance mental clarity. It combines CoQ10 for cellular energy, Omega-3 for brain and cardiovascular health, Vitamin B12 for red blood cell and nerve function, and Vitamin B2 to optimize energy metabolism."
    },
    {
      "question": "How do the supplements inside work together to support energy?",
      "answer": "CoQ10 helps generate ATP—the body’s main energy currency—while Omega-3 supports brain function and circulation. Vitamin B12 and Vitamin B2 act as coenzymes in energy-yielding reactions, ensuring your cells can efficiently convert nutrients into usable fuel."
    },
    {
      "question": "When should I take these supplements for best results?",
      "answer": "Take CoQ10 and Omega-3 with a meal containing healthy fats to boost absorption, and B-vitamins with food to improve tolerance. Most people find taking them in the morning or early afternoon helps maintain steady energy throughout the day."
    },
    {
      "question": "How soon might I notice an increase in energy or focus?",
      "answer": "Energy benefits from B-vitamins can appear within a few days to weeks. CoQ10’s effects on stamina and vitality often build over several weeks, while Omega-3 benefits on cognitive performance and inflammation typically appear after 4–12 weeks."
    },
    {
      "question": "Are there any side effects I should be aware of?",
      "answer": "All ingredients are generally well tolerated. Mild digestive discomfort can occur with Omega-3 or high-dose B-vitamins. CoQ10 may rarely cause nausea, headache, or insomnia. Taking supplements with food reduces most issues."
    },
    {
      "question": "Can I combine The Energy Protocol with other supplements or medications?",
      "answer": "Yes, though caution is advised if you take blood thinners, blood pressure medication, or certain chemotherapy drugs due to potential interactions with CoQ10 and Omega-3. If you’re on prescription medication, consult your healthcare provider before starting."
    },
    {
      "question": "Is The Energy Protocol suitable for long-term use?",
      "answer": "Yes—these nutrients are safe for daily, ongoing use when taken at recommended dosages. Long-term supplementation may help maintain optimal energy production, cognitive health, and metabolic efficiency."
    },
    {
      "question": "Who would benefit most from The Energy Protocol?",
      "answer": "Ideal for individuals experiencing low energy, fatigue, or poor concentration—especially those with high physical or mental demands, limited dietary nutrient intake, or higher cardiovascular and metabolic needs."
    }
  ],

  "The Sleep Protocol": [
    {
      "question": "What is the main purpose of The Sleep Protocol?",
      "answer": "The Sleep Protocol is formulated to promote deeper, more restorative sleep and improved nighttime recovery. It blends Ashwagandha for stress reduction, Magnesium for muscle relaxation, Omega-3 for brain and nervous system health, and Vitamin B6 for neurotransmitter balance."
    },
    {
      "question": "How do these supplements help improve sleep quality and recovery?",
      "answer": "Ashwagandha supports cortisol regulation, helping the body wind down, while Magnesium promotes muscle and nerve relaxation. Omega-3 helps reduce nighttime inflammation and supports brain function, and Vitamin B6 aids in the production of melatonin and serotonin—key sleep-regulating neurotransmitters."
    },
    {
      "question": "Should I take all the supplements at night or spread them out during the day?",
      "answer": "Ashwagandha and Magnesium are best taken in the evening to promote calmness before bed. Omega-3 can be taken with dinner or earlier in the day with food. Vitamin B6 is flexible, but evening timing may enhance its sleep-related benefits."
    },
    {
      "question": "How quickly might I notice improvements in sleep?",
      "answer": "Some people notice more restful sleep within 1–2 weeks from Magnesium and Ashwagandha, while the full effects—such as reduced nighttime waking and improved morning energy—may build over 6–8 weeks."
    },
    {
      "question": "Are there any side effects to watch for?",
      "answer": "These supplements are generally well tolerated. Ashwagandha may cause mild digestive upset or drowsiness in some people, Magnesium can cause loose stools if taken in excess, and Omega-3 may cause mild aftertaste. Taking them with food and adjusting timing usually helps."
    },
    {
      "question": "Can I take The Sleep Protocol if I’m already using sleep aids or other supplements?",
      "answer": "Yes, but check with your healthcare provider if you are taking sedatives, antidepressants, or high-dose melatonin, as there may be additive effects or interactions."
    },
    {
      "question": "Is The Sleep Protocol safe for long-term, nightly use?",
      "answer": "Yes—when taken at recommended doses, these nutrients are safe for ongoing nightly use and can support sustained improvements in sleep quality and recovery."
    },
    {
      "question": "Who would benefit most from The Sleep Protocol?",
      "answer": "Best suited for those experiencing stress-related sleep issues, frequent waking, or non-restorative sleep—particularly athletes, shift workers, and high-stress professionals."
    }
  ],

  "The Fitness Protocol": [
    {
      "question": "What is the main purpose of The Fitness Protocol?",
      "answer": "The Fitness Protocol is designed to enhance strength, endurance, and recovery. It combines Ashwagandha for performance and resilience, Magnesium for muscle function, Vitamin C for antioxidant protection, and Zinc for muscle repair and immune health."
    },
    {
      "question": "How do these supplements work together to support performance and recovery?",
      "answer": "Ashwagandha may boost VO₂ max, strength, and recovery capacity, while Magnesium supports muscle contraction and relaxation. Vitamin C helps reduce exercise-induced oxidative stress, and Zinc plays a role in protein synthesis, hormone production, and tissue repair."
    },
    {
      "question": "Should I take these supplements before, during, or after training?",
      "answer": "Ashwagandha can be taken any time with food, Magnesium is often best in the evening for muscle recovery, Vitamin C can be taken post-workout to combat oxidative stress, and Zinc is typically taken with a meal to improve absorption and reduce stomach upset."
    },
    {
      "question": "How soon might I notice improvements in strength, endurance, or recovery time?",
      "answer": "Performance benefits from Ashwagandha often appear after 8–12 weeks, while Magnesium’s effects on cramps and muscle relaxation may be noticeable within 1–2 weeks. Vitamin C and Zinc support recovery and immune function continuously with daily use."
    },
    {
      "question": "Are there any side effects or precautions to keep in mind?",
      "answer": "These supplements are generally safe when taken as directed. High-dose Vitamin C may cause mild digestive upset, excess Zinc can cause nausea, and Magnesium may cause loose stools in sensitive individuals."
    },
    {
      "question": "Can I combine The Fitness Protocol with pre-workout or protein supplements?",
      "answer": "Yes—The Fitness Protocol complements most sports nutrition products. However, avoid excessive Zinc or Vitamin C intake from multiple sources, and consult your provider if combining with stimulant-heavy pre-workouts."
    },
    {
      "question": "Is The Fitness Protocol safe for daily, long-term use?",
      "answer": "Yes—when taken at recommended dosages, it’s safe for ongoing daily use and may help maintain consistent training progress and recovery capacity."
    },
    {
      "question": "Who would benefit most from The Fitness Protocol?",
      "answer": "Ideal for athletes, active individuals, and anyone seeking to improve training performance, reduce fatigue, and support muscle repair and recovery."
    },
  ],
   "Home Page": [
  {
    question: "How does Nutricode work?",
    answer: [
      "You start by connecting your wearable device and get your first metric analysis and supplement recommendation.",
      "Once you receive your first box, you can start taking your daily sachets.",
      "Each month, you receive an insight report showing how your metrics changed and whether your supplements are helping.",
      "Based on that, Nutricode updates your protocol every month so it evolves with your data."
    ]
  },
  {
    question: "Is Nutricode a subscription service?",
    answer: [
      "Yes. Nutricode is a subscription because consistency is what allows supplements to deliver meaningful results.",
      "You can cancel anytime through the Nutricode app or from your account page on our website."
    ]
  },
  {
    question: "How long should I follow Nutricode’s recommendations?",
    answer: [
      "Nutricode works best over time because your protocol is updated month after month based on your data.",
      "The longer you follow it, the more we can learn from your metrics and refine your plan."
    ]
  },
  {
    question: "What makes Nutricode unique compared to other supplement brands?",
    answer: [
      "Most supplement brands stop after giving you a one time recommendation.",
      "Nutricode connects to your wearable, tracks how your metrics respond, sends you a monthly insight report, and updates your protocol based on what is actually working."
    ]
  }
]
}



   const backgroundStyles = {
      "Ashwagandha": {
        background: `
          radial-gradient(circle at center, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 100%),
          linear-gradient(135deg, rgba(160,154,149,0.6) 0%, rgba(145,139,134,0.6) 50%, rgba(186,77,0,0.6) 100%),
          #FFFFFF
        `
      },
      "Biotin": {
        background: `
          radial-gradient(circle at center, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 100%),
          linear-gradient(135deg, rgba(171,71,188,0.6) 0%, rgba(123,31,162,0.6) 100%),
          #FFFFFF
        `
      },
      "Calcium": {
        background: `
          radial-gradient(circle at center, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 100%),
          linear-gradient(135deg, rgba(156,224,255,0.6) 0%, rgba(6,162,255,0.6) 100%),
          #FFFFFF
        `
      },
      "CoQ10": {
        background: `
          radial-gradient(circle at center, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 100%),
          linear-gradient(135deg, rgba(255,107,157,0.6) 0%, rgba(171,71,188,0.6) 80%, rgba(255,230,109,0.6) 150%),
          #FFFFFF
        `
      },
      "Folic Acid": {
        background: `
          radial-gradient(circle at center, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 100%),
          linear-gradient(135deg, rgba(251,140,0,0.6) 0%, rgba(255,224,178,0.6) 100%),
          #FFFFFF
        `
      },
      "Iron": {
        background: `
          radial-gradient(circle at center, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 100%),
          linear-gradient(135deg, rgba(79,195,247,0.6) 0%, rgba(2,119,189,0.6) 100%),
          #FFFFFF
        `
      },
      "Magnesium": {
        background: `
          radial-gradient(circle at center, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 100%),
          linear-gradient(135deg, rgba(0,164,237,0.6) 0%, rgba(179,229,252,0.6) 100%),
          #FFFFFF
        `
      },
      "Omega 3": {
        background: `
          radial-gradient(circle at center, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 100%),
          linear-gradient(135deg, rgba(171,71,188,0.6) 0%, rgba(225,190,231,0.6) 100%),
          #FFFFFF
        `
      },
      "Probiotics": {
        background: `
          radial-gradient(circle at center, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 100%),
          linear-gradient(135deg, rgba(38,166,154,0.6) 0%, rgba(128,203,196,0.6) 100%),
          #FFFFFF
        `
      },
      "Vitamin B12": {
        background: `
          radial-gradient(circle at center, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 100%),
          linear-gradient(135deg, rgba(230,81,0,0.6) 0%, rgba(251,140,0,0.6) 50%, rgba(255,224,178,0.6) 100%),
          #FFFFFF
        `
      },
      "Vitamin B2": {
        background: `
          radial-gradient(circle at center, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 100%),
          linear-gradient(135deg, rgba(251,140,0,0.6) 0%, rgba(255,152,0,0.6) 50%, rgba(255,204,2,0.6) 100%),
          #FFFFFF
        `
      },
      "Vitamin B6": {
        background: `
          radial-gradient(circle at center, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 100%),
          linear-gradient(135deg, rgba(251,140,0,0.6) 0%, rgba(245,124,0,0.6) 100%),
          #FFFFFF
        `
      },
      "Vitamin C": {
        background: `
          radial-gradient(circle at center, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 100%),
          linear-gradient(135deg, rgba(216,67,21,0.6) 0%, rgba(255,197,52,0.6) 100%),
          #FFFFFF
        `
      },
      "Vitamin D": {
        background: `
          radial-gradient(circle at center, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 100%),
          linear-gradient(135deg, rgba(251,140,0,0.6) 0%, rgba(255,224,178,0.6) 100%),
          #FFFFFF
        `
      },
      "Vitamin E": {
        background: `
          radial-gradient(circle at center, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 100%),
          linear-gradient(135deg, rgba(251,140,0,0.6) 0%, rgba(255,167,38,0.6) 50%, rgba(255,204,2,0.6) 100%),
          #FFFFFF
        `
      },
      "Zinc": {
        background: `
          radial-gradient(circle at center, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 100%),
          linear-gradient(135deg, rgba(79,195,247,0.6) 0%, rgba(2,119,189,0.6) 100%),
          #FFFFFF
        `
      }
    };



const supplementFeatureCards = {
  "Ashwagandha": [
    { emoji: "🧘", title: "Stress Relief", subtitle: "Lowers cortisol naturally" },
    { emoji: "😴", title: "Better Sleep", subtitle: "Deep, restorative rest" },
    { emoji: "🏃", title: "Endurance", subtitle: "Improves stamina" },
    { emoji: "💪", title: "Strength & Power", subtitle: "Supports muscle performance" }
  ],
  "Biotin": [
    { emoji: "🌟", title: "Skin Health", subtitle: "Healthy glow & resilience" },
    { emoji: "💇", title: "Hair Strength", subtitle: "Reduces breakage" },
    { emoji: "💅", title: "Stronger Nails", subtitle: "Less brittleness" },
    { emoji: "⏳", title: "Longevity", subtitle: "Cellular health & vitality" }
  ],
  "Calcium": [
    { emoji: "🦴", title: "Bone Density", subtitle: "Strong bones & teeth" },
    { emoji: "💪", title: "Musculoskeletal", subtitle: "Muscle & joint health" },
    { emoji: "❤️", title: "Heart & Circulation", subtitle: "Blood flow & pressure" },
    { emoji: "🌿", title: "Gut Health", subtitle: "Supports digestion" }
  ],
  "CoQ10": [
    { emoji: "⚡", title: "Energy Production", subtitle: "Mitochondria & ATP" },
    { emoji: "🏃", title: "Endurance", subtitle: "Improves stamina & recovery" },
    { emoji: "⏳", title: "Longevity", subtitle: "Cellular defense & aging" },
    { emoji: "⚖️", title: "Hormonal Balance", subtitle: "Reproductive support" }
  ],
  "Folic Acid": [
    { emoji: "❤️", title: "Heart Health", subtitle: "Homocysteine balance" },
    { emoji: "⏳", title: "Longevity", subtitle: "Cell & DNA support" },
    { emoji: "🧠", title: "Mental Health", subtitle: "Cognitive function" },
    { emoji: "🛡️", title: "Disease Prevention", subtitle: "Protective benefits" }
  ],
  "Iron": [
    { emoji: "🏃", title: "Endurance", subtitle: "Oxygen transport efficiency" },
    { emoji: "⚡", title: "Energy", subtitle: "Beats fatigue" },
    { emoji: "🔴", title: "Blood Health", subtitle: "Hemoglobin & circulation" },
    { emoji: "🎯", title: "Focus", subtitle: "Sharper mental clarity" }
  ],
  "Magnesium": [
    { emoji: "💪", title: "Strength & Power", subtitle: "Muscle & nerve function" },
    { emoji: "🔄", title: "Recovery", subtitle: "Reduce soreness & cramps" },
    { emoji: "⚖️", title: "Hormonal Health", subtitle: "Reproductive support" },
    { emoji: "😴", title: "Sleep", subtitle: "Promotes relaxation & rest" }
  ],
  "Omega 3": [
    { emoji: "🧠", title: "Organ Health", subtitle: "Heart, Brain, Vascular" },
    { emoji: "💡", title: "Cognitive", subtitle: "Mental clarity & focus" },
    { emoji: "🏃", title: "Endurance", subtitle: "Circulation & performance" },
    { emoji: "🔥", title: "Fat Loss", subtitle: "Supports metabolism" }
  ],
  "Probiotics": [
    { emoji: "🦠", title: "Gut Balance", subtitle: "Better digestion" },
    { emoji: "🌿", title: "Organ Health", subtitle: "Whole-body wellness" }
  ],
  "Vitamin B12": [
    { emoji: "❤️", title: "Heart & Circulation", subtitle: "Protects vessels" },
    { emoji: "🌿", title: "Organ Health", subtitle: "Cellular support" }
  ],
  "Vitamin B2": [
    { emoji: "🌿", title: "Organ Health", subtitle: "Cell energy & function" },
    { emoji: "❤️", title: "Heart & Circulation", subtitle: "Metabolic support" },
    { emoji: "🧠", title: "Brain Health", subtitle: "Nervous system balance" }
  ],
  "Vitamin B6": [
    { emoji: "🏃", title: "Endurance", subtitle: "Energy during exercise" },
    { emoji: "🔄", title: "Recovery", subtitle: "Supports repair & healing" },
    { emoji: "😴", title: "Sleep Quality", subtitle: "Restful nights" },
    { emoji: "⚖️", title: "Hormonal Balance", subtitle: "PMS & reproduction" }
  ],
  "Vitamin C": [
    { emoji: "🛡️", title: "Immunity", subtitle: "Daily defense" },
    { emoji: "🔄", title: "Recovery", subtitle: "Tissue & repair" },
    { emoji: "⏳", title: "Longevity", subtitle: "Cellular protection" },
    { emoji: "🏃", title: "Endurance", subtitle: "Performance boost" }
  ],
  "Vitamin D": [
    { emoji: "🛡️", title: "Immunity", subtitle: "Defense & balance" },
    { emoji: "💪", title: "Strength & Power", subtitle: "Muscle & bone" },
    { emoji: "⚖️", title: "Hormonal Health", subtitle: "Reproductive support" },
    { emoji: "🔥", title: "Fat Loss", subtitle: "Supports metabolism" }
  ],
  "Vitamin E": [
    { emoji: "⏳", title: "Longevity", subtitle: "Cell protection" },
    { emoji: "🌿", title: "Organ Health", subtitle: "Vital system support" },
    { emoji: "🛡️", title: "Immunity", subtitle: "Protective response" },
    { emoji: "⚖️", title: "Hormonal Health", subtitle: "Reproductive support" }
  ],
  "Zinc": [
    { emoji: "🏃", title: "Endurance", subtitle: "Performance boost" },
    { emoji: "🧬", title: "Hormonal Health", subtitle: "Balanced levels" },
    { emoji: "⏳", title: "Longevity", subtitle: "Cell repair & healthy aging" },
    { emoji: "⚖️", title: "Weight Management", subtitle: "Metabolic control" }
  ],
   "The Sleep Protocol": [
    { emoji: "💤", title: "Sleep Quality", subtitle: "Sleep faster & longer" },
    { emoji: "🧠", title: "Boosted REM & DEEP", subtitle: "Support memory & recovery" },
    { emoji: "❤️", title: "Improved HRV", subtitle: "Nervous system balance" },
    { emoji: "🔋", title: "Morning Energy", subtitle: "Wake up refreshed" }
  ],
  "The Fitness Protocol": [
    { emoji: "💪", title: "Strength Gains", subtitle: "Support power & muscle growth" },
    { emoji: "🏃", title: "Endurance Boost", subtitle: "Sustain energy & stamina" },
    { emoji: "🔄", title: "Faster Recovery", subtitle: "Reduce fatigue & repair muscles" },
    { emoji: "🔥", title: "Performance Edge", subtitle: "Train harder & push limits" }
  ]
};



const supplementDescriptionImages = {
    "Ashwagandha":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Ashwagandha_Overview.webp?v=1763536645",
    "Biotin":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Biotin_Overview.webp?v=1763544701",
    "Calcium":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Calcium_Overview.webp?v=1763544762",
    "CoQ10":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/CoQ10_Overview.webp?v=1763698659",
    "Folic Acid":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Folic_Acid_Overview.webp?v=1763544897",
    "Iron":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Iron_Overview.webp?v=1763544953",
    "Magnesium":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Magnesium_Overview.webp?v=1763545022",
    "Omega 3":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Omega3_Overview.webp?v=1763545103",
    "Probiotics":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Probiotics_Overview.webp?v=1763545168",
    "Vitamin B12":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminB12_Overview.webp?v=1763545218",
    "Vitamin B2":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminB2_Overview.webp?v=1763545273",
    "Vitamin B6":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminB6_Overview.webp?v=1763545363",
    "Vitamin C":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminC_Overview.webp?v=1763545436",
    "Vitamin D":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminD_Overview.webp?v=1763545500",
    "Vitamin E":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminE_Overview.webp?v=1763545567",
    "Zinc":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Zinc_Overview.webp?v=1763545621",
    "The Sleep Protocol":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/description_SleepStack-min.png?v=1757295511",
    "The Fitness Protocol":"https://cdn.shopify.com/s/files/1/0781/4522/4995/files/description_FitnessStack-min.png?v=1757295512"
    };




const gradeGoals = {
  "Ashwagandha": {
    "Stress": 10,
    "Sleep": 9,
    "Sleep Quality": 9,
    "Endurance": 8,
    "Strength & Power": 8,
    "Energy": 7,
    "Hormones & Reproduction": 8,
    "Fitness": 10,
    "Recovery": 8,
    "Falling Asleep": 6,
  },
  "Biotin": {
    "Skin & Beauty": 10,
    "Nails": 10,
    "Longevity": 7
  },
  "Calcium": {
    "Musculoskeletal Health": 10,
    "Heart & Circulation": 9,
    "Gut Health": 6,
    "Hormones & Reproduction": 7
  },
  "CoQ10": {
    "Energy": 10,
    "Endurance": 8,
    "Longevity": 9,
    "Hormones & Reproduction": 7,
    "Brain Health": 7,
    "Heart & Circulation": 9,
    "Recovery": 9,
    "Eye Health": 6,
    "Skin Health": 7
  },
  "Folic Acid": {
    "Heart & Circulation": 9,
    "Longevity": 8,
    "Mental Health": 7,
    "Disease Prevention": 8
  },
  "Iron": {
    "Endurance": 8,
    "Energy": 9,
    "Blood Health": 10,
    "Focus": 7,
    "Hormones & Reproduction": 7,
    "Heart & Circulation": 8
  },
  "Magnesium": {
    "Strength & Power": 10,
    "Recovery": 9,
    "Hormones & Reproduction": 9,
    "Sleep": 10,
    "Sleep Quality": 8,
    "Endurance": 8,
    "Heart & Circulation": 7,
    "Bones": 7,
    "Fitness": 10,
    "Falling Asleep": 7,
    "Energy": 7,
  },
  "Omega 3": {
    "Endurance": 9,
    "Organ Health": 10,
    "Cognitive Performance": 9,
    "Fat Loss": 7,
    "Recovery": 9,
    "Energy": 7,
    "Hormones & Reproduction": 8,
    "Sleep": 7,
    "Sleep Quality": 7,
    "Mood Improvement": 9,
    "Immunity": 8,
    "Falling Asleep": 7,
  },
  "Probiotics": {
    "Organ Health": 8,
    "Gut Health": 10
  },
  "Vitamin B12": {
    "Heart & Circulation": 9,
    "Organ Health": 9
  },
  "Vitamin B2": {
    "Organ Health": 8,
    "Heart & Circulation": 8,
    "Brain Health": 7
  },
  "Vitamin B6": {
    "Endurance": 7,
    "Recovery": 8,
    "Sleep": 8,
    "Hormones & Reproduction": 8,
    "Sleep Quality": 7,
  },
  "Vitamin C": {
    "Immunity": 10,
    "Recovery": 9,
    "Longevity": 9,
    "Endurance": 8,
    "Hormones & Reproduction": 7,
    "Heart & Circulation": 8,
    "Bones": 7,
    "Weight Management": 6,
    "Fitness": 9,
  },
  "Vitamin D": {
    "Hormones & Reproduction": 10,
    "Immunity": 9,
    "Strength & Power": 9,
    "Fat Loss": 7,
    "Muscle Mass": 9,
    "Recovery": 8,
    "Longevity": 8,
    "Sleep": 7,
    "Bones": 10,
    "Sleep Quality": 9,
     "Staying Asleep": 8,
  },
  "Vitamin E": {
    "Longevity": 9,
    "Organ Health": 8,
    "Immunity": 8,
    "Hormones & Reproduction": 7,
    "Skin & Beauty": 8,
    "Hair": 7
  },
  "Zinc": {
    "Endurance": 9,
    "Hormones & Reproduction": 10,
    "Longevity": 8,
    "Weight Management": 7,
    "Strength & Power": 8,
    "Recovery": 8,
    "Immunity": 9,
    "Cognitive Performance": 7,
    "Fitness": 10,
  }
};


const resultPageWhatToExpect = {
   "Your Protocol": [
    {
      "title": "Connect Device &",
      "title_highlight": "Start Your Protocol",
      "timeline": "Day 1",
      "description":
        "Your box arrives. <span class=\"body-semibold-black darkmode\">Connect your wearable and take your first sachet.</span> From this moment, your metrics start shaping your adaptive protocol.",
      "cards": [
        { "emoji": "🧘", "title": "Connect Your Device", "subtitle": "Connect and start tracking instantly." },
        { "emoji": "😴", "title": "Take Your First Supplements", "subtitle": "Open your first sachet. Your protocol starts!" }
      ]
    },
    {
      "title": "Early Signals &",
      "title_highlight": "First Assessment",
      "timeline": "Day 7",
      "description":
        "After your first week, your metrics start to tell their story. <span class=\"body-semibold-black darkmode\">Your dashboard reveals early sleep, recovery, and training trends</span>, and your first weekly check-in adds your own perspective beyond the numbers.",
      "cards": [
        { "emoji": "💤", "title": "Review Your Dashboard", "subtitle": "See early trends in your metrics." },
        { "emoji": "📈", "title": "Complete Your Weekly Check-In", "subtitle": "Add context with the weekly assessment." }
      ]
    },
    {
      "title": "View Suggestions &",
      "title_highlight": "Optimize Your Protocol",
      "timeline": "Day 30",
      "description":
        "After 4 to 8 weeks, your metrics tells a clear story. We can now see what’s improving your metrics and what isn’t. <span class=\"body-semibold-black darkmode\">Using your health data, Nutricode analyzes your progress and suggests updates to your protocol</span>, to help you get the best possible impact.",
      "cards": [
        { "emoji": "⚡", "title": "View Your Suggestions", "subtitle": "See recommended updates to your protocol." },
        { "emoji": "🔄", "title": "Optimize Your Protocol", "subtitle": "Apply the updates to improve your metrics." }
      ]
    }
  ],

}

const supplementWhatToExpect = {
  "Ashwagandha": [
    {
      "title": "Early Calm &",
      "title_highlight": "Sleep Improvements",
      "timeline": "Week 2",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Ashwagandha_Phase_1.webp?v=1763536645",
      "description":
        "Ashwagandha begins lowering cortisol and easing stress. <span class=\"body-semibold-black darkmode\">Calmer moods and smoother nights</span> are often noticed during weekly check-ins.",
      "cards": [
        { "emoji": "🧘", "title": "Stress Relief", "subtitle": "Noticeably calmer mindset" },
        { "emoji": "😴", "title": "Sleep Ease", "subtitle": "Fall asleep more smoothly" }
      ]
    },
    {
      "title": "Stronger Sleep &",
      "title_highlight": "Performance Gains",
      "timeline": "Week 6",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Ashwagandha_Phase_2.webp?v=1763536645",
      "description":
        "Deeper sleep cycles and steadier energy become clear. <span class=\"body-semibold-black darkmode\">Recovery improves and stamina rises</span>, with wearable data often showing higher HRV.",
      "cards": [
        { "emoji": "💤", "title": "Restorative Sleep", "subtitle": "Longer deep sleep cycles" },
        { "emoji": "📈", "title": "HRV Score", "subtitle": "Higher recovery readings" }
      ]
    },
    {
      "title": "Peak Benefits &",
      "title_highlight": "Reset Period",
      "timeline": "Week 16",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Ashwagandha_Phase_3.webp?v=1763536645",
      "description":
        "Ashwagandha reaches full effect with <span class=\"body-semibold-black darkmode\">stronger resilience and steady energy</span>. To maintain results, the app cycles this supplement, pausing for 1 month before restarting.",
      "cards": [
        { "emoji": "⚡", "title": "Energy Balance", "subtitle": "Consistent daily energy" },
        { "emoji": "🔄", "title": "Cycle Break", "subtitle": "Pause 1 month to reset" }
      ]
    }
  ],
  "Biotin": [
    {
      "title": "Early",
      "title_highlight": "Beauty Support",
      "timeline": "Week 4",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Biotin_Phase_1.webp?v=1763544701",
      "description":
        "Biotin begins supporting keratin production. <span class=\"body-semibold-black darkmode\">Stronger nails and smoother skin</span> are often noticed within the first month.",
      "cards": [
        { "emoji": "💅", "title": "Nail Strength", "subtitle": "Less brittleness & cracks" },
        { "emoji": "🌟", "title": "Skin Glow", "subtitle": "Hydrated, smoother texture" }
      ]
    },
    {
      "title": "Visible Results &",
      "title_highlight": "Longevity",
      "timeline": "Week 8",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Biotin_Phase_2.webp?v=1763544701",
      "description":
        "Hair grows stronger with <span class=\"body-semibold-black darkmode\">less shedding and better resilience</span>. The app may also detect improved cardiovascular markers as Biotin lowers triglycerides.",
      "cards": [
        { "emoji": "💇", "title": "Hair Strength", "subtitle": "Less breakage, fuller look" },
        { "emoji": "❤️", "title": "Longevity", "subtitle": "Supports heart health" }
      ]
    }
  ],
  "Calcium": [
    {
      "title": "Foundational",
      "title_highlight": "Support",
      "timeline": "Week 4",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Calcium_Phase_1.webp?v=1763544762",
      "description":
        "Calcium reinforces bone mineralization and muscle contraction. <span class=\"body-semibold-black darkmode\">Fewer cramps and steadier performance</span> are often reported early on.",
      "cards": [
        { "emoji": "🦴", "title": "Bone Health", "subtitle": "Stronger bone foundation" },
        { "emoji": "💪", "title": "Muscle Support", "subtitle": "Reduced cramps & tension" }
      ]
    },
    {
      "title": "Peak Strength &",
      "title_highlight": "Circulation",
      "timeline": "Week 12",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Calcium_Phase_2.webp?v=1763544761",
      "description":
        "Calcium strengthens density and circulation. <span class=\"body-semibold-black darkmode\">Endurance and recovery trends</span> often show measurable improvements in the app.",
      "cards": [
        { "emoji": "🏋️", "title": "Bone Density", "subtitle": "Improved structural strength" },
        { "emoji": "❤️", "title": "Heart Health", "subtitle": "Supports healthy circulation" }
      ]
    }
  ],
  "CoQ10": [
    {
      "title": "Early Energy &",
      "title_highlight": "Fatigue Support",
      "timeline": "Week 4",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/CoQ10_Phase_1.webp?v=1763544826",
      "description":
        "CoQ10 boosts mitochondrial function. <span class=\"body-semibold-black darkmode\">Steadier energy and less fatigue</span> are usually noticed within weeks.",
      "cards": [
        { "emoji": "⚡", "title": "Energy Lift", "subtitle": "More steady daily energy" },
        { "emoji": "😌", "title": "Less Fatigue", "subtitle": "Reduced daily exhaustion" }
      ]
    },
    {
      "title": "Endurance &",
      "title_highlight": "Performance Gains",
      "timeline": "Week 8",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/CoQ10_Phase_2.webp?v=1763544826",
      "description":
        "Endurance improves with <span class=\"body-semibold-black darkmode\">better oxygen use and longer training</span>. Wearable data often shows higher VO₂ max.",
      "cards": [
        { "emoji": "🏃", "title": "Stamina Boost", "subtitle": "Longer training sessions" },
        { "emoji": "📊", "title": "VO₂ Max", "subtitle": "Improved aerobic capacity" }
      ]
    },
    {
      "title": "Longevity &",
      "title_highlight": "Hormonal Support",
      "timeline": "Week 12",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/CoQ10_Phase_3_0fce738d-5a4b-496a-a90a-92bf13161bb9.webp?v=1763566208",
      "description":
        "CoQ10 reduces oxidative stress and supports hormones. <span class=\"body-semibold-black darkmode\">Vitality and energy balance</span> are common feedback points.",
      "cards": [
        { "emoji": "🛡️", "title": "Cell Defense", "subtitle": "Stronger antioxidant shield" },
        { "emoji": "🧬", "title": "Repro Health", "subtitle": "Supports fertility & balance" }
      ]
    }
  ],
  "Folic Acid": [
    {
      "title": "Heart &",
      "title_highlight": "Circulation Support",
      "timeline": "Week 4",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Folic_Acid_Phase_1.webp?v=1763544898",
      "description":
        "Folic acid lowers homocysteine. <span class=\"body-semibold-black darkmode\">Better circulation and cardiovascular protection</span> are often seen in early check-ins.",
      "cards": [
        { "emoji": "❤️", "title": "Heart Health", "subtitle": "Supports vessel function" },
        { "emoji": "💨", "title": "Circulation", "subtitle": "Improved blood flow" }
      ]
    },
    {
      "title": "Longevity &",
      "title_highlight": "Mental Wellness",
      "timeline": "Week 8",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Folic_Acid_Phase_2.webp?v=1763544898",
      "description":
        "Antioxidant defenses strengthen and DNA repair improves. <span class=\"body-semibold-black darkmode\">Sharper mood balance and mental clarity</span> are common in weekly reports.",
      "cards": [
        { "emoji": "⏳", "title": "Longevity", "subtitle": "Protects against aging" },
        { "emoji": "🧠", "title": "Mental Health", "subtitle": "Better mood balance" }
      ]
    }
  ],
  "Iron": [
    {
      "title": "Early Energy &",
      "title_highlight": "Endurance",
      "timeline": "Week 2",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Iron_Phase_1.webp?v=1763544953",
      "description":
        "Iron supports hemoglobin and oxygen delivery. <span class=\"body-semibold-black darkmode\">Less fatigue and more stamina</span> are often reported in early weeks.",
      "cards": [
        { "emoji": "🔋", "title": "Energy Boost", "subtitle": "Less daily fatigue" },
        { "emoji": "🏃", "title": "Endurance", "subtitle": "Better oxygen delivery" }
      ]
    },
    {
      "title": "Blood Health &",
      "title_highlight": "Focus",
      "timeline": "Week 6",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Iron_Phase_2.webp?v=1763544953",
      "description":
        "Oxygen transport improves, fueling energy production. <span class=\"body-semibold-black darkmode\">Sharper focus and steadier stamina</span> are often reflected in app data.",
      "cards": [
        { "emoji": "🔴", "title": "Blood Health", "subtitle": "Higher hemoglobin levels" },
        { "emoji": "🎯", "title": "Focus", "subtitle": "Sharper concentration" }
      ]
    },
    {
      "title": "Peak Benefits &",
      "title_highlight": "Reset Period",
      "timeline": "Week 8",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Iron_Phase_3.webp?v=1763708961",
      "description":
        "Iron reaches full effect with <span class=\"body-semibold-black darkmode\">better endurance and consistent energy</span>. The app will automatically cycle this supplement for 1 month before restarting.",
      "cards": [
        { "emoji": "⚡", "title": "Energy Balance", "subtitle": "Steady daily vitality" },
        { "emoji": "🔄", "title": "Cycle Break", "subtitle": "Pause 1 month to reset" }
      ]
    }
  ],
  "Magnesium": [
    {
      "title": "Early Relaxation &",
      "title_highlight": "Sleep Support",
      "timeline": "Week 2",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Magnesium_Phase_1.webp?v=1763545022",
      "description":
        "Magnesium begins calming the nervous system. <span class=\"body-semibold-black darkmode\">Smoother sleep and faster recovery</span> are often reported after workouts.",
      "cards": [
        { "emoji": "😴", "title": "Sleep Ease", "subtitle": "Fall asleep faster" },
        { "emoji": "🔄", "title": "Recovery", "subtitle": "Reduced soreness & cramps" }
      ]
    },
    {
      "title": "Strength &",
      "title_highlight": "Hormonal Balance",
      "timeline": "Week 6",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Magnesium_Phase_2.webp?v=1763545022",
      "description":
        "Consistent intake supports <span class=\"body-semibold-black darkmode\">muscle power and hormone balance</span>. Wearable data may reflect stronger lifts and faster recovery.",
      "cards": [
        { "emoji": "💪", "title": "Strength", "subtitle": "Improved muscle function" },
        { "emoji": "🧬", "title": "Hormone Health", "subtitle": "Balanced reproductive support" }
      ]
    },
    {
      "title": "Peak Rest &",
      "title_highlight": "Performance",
      "timeline": "Week 12",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Magnesium_Phase_3.webp?v=1763545023",
      "description":
        "Magnesium optimizes <span class=\"body-semibold-black darkmode\">sleep efficiency and energy metabolism</span>, confirmed by steadier recovery trends in app data.",
      "cards": [
        { "emoji": "💤", "title": "Deep Sleep", "subtitle": "More restorative nights" },
        { "emoji": "🏃", "title": "Endurance", "subtitle": "Sustained athletic output" }
      ]
    }
  ],
  "Omega 3": [
    {
      "title": "Early Organ &",
      "title_highlight": "Mood Support",
      "timeline": "Week 2",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Omega3_Phase_1.webp?v=1763545103",
      "description":
        "Omega-3 begins reducing inflammation. <span class=\"body-semibold-black darkmode\">Steadier mood and clearer focus</span> are common early benefits.",
      "cards": [
        { "emoji": "🌿", "title": "Organ Health", "subtitle": "Better heart & liver support" },
        { "emoji": "🧠", "title": "Focus", "subtitle": "Sharper mental clarity" }
      ]
    },
    {
      "title": "Endurance &",
      "title_highlight": "Cognitive Gains",
      "timeline": "Week 6",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Omega3_Phase_2.webp?v=1763545103",
      "description":
        "Endurance improves as oxygen cost drops. <span class=\"body-semibold-black darkmode\">Sharper memory and mental clarity</span> are often noted in weekly check-ins.",
      "cards": [
        { "emoji": "🏃", "title": "Endurance", "subtitle": "Greater workout efficiency" },
        { "emoji": "💡", "title": "Cognitive Boost", "subtitle": "Better memory & focus" }
      ]
    },
    {
      "title": "Peak Benefits &",
      "title_highlight": "Reset Period",
      "timeline": "Week 16",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Omega3_Phase_3.webp?v=1763545104",
      "description":
        "Omega-3 strengthens <span class=\"body-semibold-black darkmode\">cardiovascular and metabolic health</span>. To maintain effectiveness, the app will cycle this supplement for 1 month.",
      "cards": [
        { "emoji": "🔥", "title": "Fat Metabolism", "subtitle": "Supports body composition" },
        { "emoji": "🔄", "title": "Cycle Break", "subtitle": "Pause 1 month to reset" }
      ]
    }
  ],
  "Probiotics": [
    {
      "title": "Early",
      "title_highlight": "Gut Balance",
      "timeline": "Week 2",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Probiotics_Phase_1.webp?v=1763545167",
      "description":
        "Probiotics begin restoring flora. <span class=\"body-semibold-black darkmode\">Smoother digestion and lighter comfort</span> are often reported early.",
      "cards": [
        { "emoji": "🦠", "title": "Gut Health", "subtitle": "Better daily digestion" },
        { "emoji": "😌", "title": "Comfort", "subtitle": "Reduced bloating & gas" }
      ]
    },
    {
      "title": "Organ &",
      "title_highlight": "Immune Support",
      "timeline": "Week 8",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Probiotics_Phase_2.webp?v=1763545168",
      "description":
        "Probiotics strengthen the gut–brain axis. <span class=\"body-semibold-black darkmode\">Lower inflammation and stronger immunity</span> are often detected over time.",
      "cards": [
        { "emoji": "🌿", "title": "Organ Health", "subtitle": "System-wide wellness" },
        { "emoji": "🛡️", "title": "Immunity", "subtitle": "Stronger defense system" }
      ]
    }
  ],
  "Vitamin B12": [
    {
      "title": "Energy &",
      "title_highlight": "Focus Support",
      "timeline": "Week 2",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminB12_Phase_1.webp?v=1763545217",
      "description":
        "Vitamin B12 boosts red blood cells and <span class=\"body-semibold-black darkmode\">sharpens focus with steadier energy</span>. Early vitality gains are common.",
      "cards": [
        { "emoji": "⚡", "title": "Energy Boost", "subtitle": "Less fatigue, more drive" },
        { "emoji": "🎯", "title": "Focus", "subtitle": "Sharper mental clarity" }
      ]
    },
    {
      "title": "Heart &",
      "title_highlight": "Organ Protection",
      "timeline": "Week 8",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminB12_Phase_2.webp?v=1763545218",
      "description":
        "B12 supports circulation and <span class=\"body-semibold-black darkmode\">stronger organ resilience</span>. The app often reflects better energy stability.",
      "cards": [
        { "emoji": "❤️", "title": "Circulation", "subtitle": "Supports vessel health" },
        { "emoji": "🌿", "title": "Organ Health", "subtitle": "Protects brain & body" }
      ]
    }
  ],
  "Vitamin B2": [
    {
      "title": "Early Energy &",
      "title_highlight": "Organ Support",
      "timeline": "Week 2",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminB2_Phase_1.webp?v=1763545273",
      "description":
        "Vitamin B2 supports mitochondria. <span class=\"body-semibold-black darkmode\">Steadier energy and better organ function</span> are often noticed quickly.",
      "cards": [
        { "emoji": "🌿", "title": "Organ Health", "subtitle": "Better cell energy use" },
        { "emoji": "⚡", "title": "Energy", "subtitle": "More steady vitality" }
      ]
    },
    {
      "title": "Brain &",
      "title_highlight": "Circulation Gains",
      "timeline": "Week 6",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminB2_Phase_2.webp?v=1763545273",
      "description":
        "Vitamin B2 helps brain clarity and <span class=\"body-semibold-black darkmode\">stabilizes circulation</span>. Migraines may reduce over time.",
      "cards": [
        { "emoji": "🧠", "title": "Brain Health", "subtitle": "Fewer migraines & clearer mind" },
        { "emoji": "❤️", "title": "Circulation", "subtitle": "Supports healthy vessels" }
      ]
    },
    {
      "title": "Peak Benefits &",
      "title_highlight": "Reset Period",
      "timeline": "Week 12",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminB2_Phase_3.webp?v=1763545273",
      "description":
        "Vitamin B2 protects cells from stress. <span class=\"body-semibold-black darkmode\">Antioxidant and circulation support</span> peak at this stage, before a cycle break.",
      "cards": [
        { "emoji": "🛡️", "title": "Cell Defense", "subtitle": "Stronger antioxidant shield" },
        { "emoji": "🔄", "title": "Cycle Break", "subtitle": "Pause 1 month to reset" }
      ]
    }
  ],
  "Vitamin B6": [
    {
      "title": "Early Energy &",
      "title_highlight": "Recovery",
      "timeline": "Week 2",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminB6_Phase_1.webp?v=1763545363",
      "description":
        "Vitamin B6 supports amino acid metabolism. <span class=\"body-semibold-black darkmode\">More workout energy and faster recovery</span> are common.",
      "cards": [
        { "emoji": "🏃", "title": "Endurance", "subtitle": "More energy in training" },
        { "emoji": "🔋", "title": "Recovery", "subtitle": "Faster muscle repair" }
      ]
    },
    {
      "title": "Sleep &",
      "title_highlight": "Hormone Balance",
      "timeline": "Week 6",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminB6_Phase_2.webp?v=1763545364",
      "description":
        "B6 improves neurotransmitters and <span class=\"body-semibold-black darkmode\">deeper sleep cycles</span>. Hormone balance aids overall wellness.",
      "cards": [
        { "emoji": "😴", "title": "Sleep Quality", "subtitle": "Deeper, restful nights" },
        { "emoji": "🧬", "title": "Hormone Balance", "subtitle": "Supports PMS relief" }
      ]
    },
    {
      "title": "Peak Benefits &",
      "title_highlight": "Reset Period",
      "timeline": "Week 12",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminB6_Phase_3.webp?v=1763545364",
      "description":
        "Vitamin B6 sustains <span class=\"body-semibold-black darkmode\">endurance, recovery, and balance</span>. Then cycled safely for long-term effect.",
      "cards": [
        { "emoji": "⚡", "title": "Performance", "subtitle": "Stronger overall output" },
        { "emoji": "🔄", "title": "Cycle Break", "subtitle": "Pause 1 month to reset" }
      ]
    }
  ],
  "Vitamin C": [
    {
      "title": "Immunity &",
      "title_highlight": "Recovery Boost",
      "timeline": "Week 2",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminC_Phase_1.webp?v=1763545436",
      "description":
        "Vitamin C strengthens immunity. <span class=\"body-semibold-black darkmode\">Fewer colds and faster recovery</span> are commonly reported.",
      "cards": [
        { "emoji": "🛡️", "title": "Immunity", "subtitle": "Fewer colds, stronger defense" },
        { "emoji": "🔄", "title": "Recovery", "subtitle": "Faster muscle repair" }
      ]
    },
    {
      "title": "Longevity &",
      "title_highlight": "Endurance Support",
      "timeline": "Week 8",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminC_Phase_2.webp?v=1763545436",
      "description":
        "Vitamin C reduces oxidative stress. <span class=\"body-semibold-black darkmode\">More resilience and vascular support</span> are often noticed in performance logs.",
      "cards": [
        { "emoji": "⏳", "title": "Longevity", "subtitle": "Protects cells from aging" },
        { "emoji": "🏃", "title": "Endurance", "subtitle": "More resilient training" }
      ]
    }
  ],
  "Vitamin D": [
    {
      "title": "Hormonal &",
      "title_highlight": "Immune Support",
      "timeline": "Week 4",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminD_Phase_1.webp?v=1763545500",
      "description":
        "Vitamin D balances hormones and <span class=\"body-semibold-black darkmode\">strengthens immune defenses</span>. Steadier mood is also common.",
      "cards": [
        { "emoji": "🧬", "title": "Hormones", "subtitle": "Improves reproductive balance" },
        { "emoji": "🛡️", "title": "Immunity", "subtitle": "Lower risk of infections" }
      ]
    },
    {
      "title": "Strength, Muscle &",
      "title_highlight": "Fat Loss",
      "timeline": "Week 12",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminD_Phase_2.webp?v=1763545500",
      "description":
        "Vitamin D enhances <span class=\"body-semibold-black darkmode\">muscle power and fat metabolism</span>, often shown in improved training output.",
      "cards": [
        { "emoji": "💪", "title": "Strength", "subtitle": "Better muscle performance" },
        { "emoji": "🔥", "title": "Fat Loss", "subtitle": "Supports body composition" }
      ]
    }
  ],
  "Vitamin E": [
    {
      "title": "Immune &",
      "title_highlight": "Organ Support",
      "timeline": "Week 4",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminE_Phase_1.webp?v=1763545566",
      "description":
        "Vitamin E protects cells. <span class=\"body-semibold-black darkmode\">Fewer colds and stronger vitality</span> are often noted in reports.",
      "cards": [
        { "emoji": "🛡️", "title": "Immunity", "subtitle": "Stronger daily defenses" },
        { "emoji": "🌿", "title": "Organ Health", "subtitle": "Protects vital systems" }
      ]
    },
    {
      "title": "Longevity &",
      "title_highlight": "Beauty Benefits",
      "timeline": "Week 12",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/VitaminE_Phase_2.webp?v=1763545567",
      "description":
        "Vitamin E sustains antioxidant protection. <span class=\"body-semibold-black darkmode\">Healthier skin and hair</span> are commonly highlighted.",
      "cards": [
        { "emoji": "⏳", "title": "Longevity", "subtitle": "Protects cells from aging" },
        { "emoji": "✨", "title": "Skin & Hair", "subtitle": "Healthier beauty support" }
      ]
    }
  ],
  "Zinc": [
    {
      "title": "Endurance &",
      "title_highlight": "Hormone Balance",
      "timeline": "Week 2",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Zinc_Phase_1.webp?v=1763545621",
      "description":
        "Zinc supports protein synthesis and <span class=\"body-semibold-black darkmode\">stabilizes hormones</span>. Stamina often rises quickly.",
      "cards": [
        { "emoji": "🏃", "title": "Endurance", "subtitle": "Boosts training output" },
        { "emoji": "🧬", "title": "Hormones", "subtitle": "Supports balance & vitality" }
      ]
    },
    {
      "title": "Strength &",
      "title_highlight": "Recovery Gains",
      "timeline": "Week 6",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Zinc_Phase_2.webp?v=1763545621",
      "description":
        "Zinc improves <span class=\"body-semibold-black darkmode\">muscle performance and speeds recovery</span>. Wearable data confirms faster bounce-back.",
      "cards": [
        { "emoji": "💪", "title": "Strength", "subtitle": "Improved muscle power" },
        { "emoji": "🔋", "title": "Recovery", "subtitle": "Faster repair after exercise" }
      ]
    },
    {
      "title": "Peak Benefits &",
      "title_highlight": "Reset Period",
      "timeline": "Week 8",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Zinc_Phase_3.webp?v=1763545622",
      "description":
        "Zinc delivers peak <span class=\"body-semibold-black darkmode\">endurance, immunity, and vitality</span>. Then cycled 1 month before restarting.",
      "cards": [
        { "emoji": "🛡️", "title": "Immunity", "subtitle": "Stronger daily defenses" },
        { "emoji": "🔄", "title": "Cycle Break", "subtitle": "Pause 1 month to reset" }
      ]
    }
  ],
  "The Sleep Protocol": [
    {
      "title": "Calmer Nights &",
      "title_highlight": "Early Rest",
      "timeline": "Week 2",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Sleep_Phase_1.webp?v=1763566209",
      "description":
        "Ashwagandha and Magnesium reduce stress. <span class=\"body-semibold-black darkmode\">Smoother sleep onset and calmer evenings</span> are often reported.",
      "cards": [
        { "emoji": "😴", "title": "Sleep Ease", "subtitle": "Fall asleep more smoothly" },
        { "emoji": "🧘", "title": "Calm Evenings", "subtitle": "Reduced stress at night" }
      ]
    },
    {
      "title": "Deeper Sleep &",
      "title_highlight": "Recovery Gains",
      "timeline": "Week 6",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Sleep_Phase_2.webp?v=1763566209",
      "description":
        "Omega 3, Magnesium, and B6 strengthen rest. <span class=\"body-semibold-black darkmode\">Deeper sleep cycles and higher HRV</span> are confirmed in app trends.",
      "cards": [
        { "emoji": "📊", "title": "HRV Score", "subtitle": "Higher recovery readings" },
        { "emoji": "💤", "title": "Deep Sleep", "subtitle": "Longer restorative cycles" }
      ]
    },
    {
      "title": "Peak Benefits &",
      "title_highlight": "Reset Period",
      "timeline": "Week 16",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Sleep_Phase_3.webp?v=1763566209",
      "description":
        "The full stack balances cortisol and <span class=\"body-semibold-black darkmode\">enhances resilience</span>. Ashwagandha, Omega 3, and B6 are cycled 1 month.",
      "cards": [
        { "emoji": "🧬", "title": "Hormone Balance", "subtitle": "Steadier night rhythms" },
        { "emoji": "🔄", "title": "Cycle Break", "subtitle": "Pause 1 month to reset" }
      ]
    }
  ],
  "The Fitness Protocol": [
    {
      "title": "Early Energy &",
      "title_highlight": "Recovery Support",
      "timeline": "Week 2",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Fitness_Phase_1.webp?v=1763566209",
      "description":
        "Ashwagandha and Magnesium support strength. <span class=\"body-semibold-black darkmode\">Steadier workouts and faster recovery</span> are often noticed.",
      "cards": [
        { "emoji": "🏃", "title": "Training Boost", "subtitle": "Steadier workout output" },
        { "emoji": "🔋", "title": "Recovery", "subtitle": "Faster bounce-back" }
      ]
    },
    {
      "title": "Strength &",
      "title_highlight": "Endurance Gains",
      "timeline": "Week 6",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Fitness_Phase_2.webp?v=1763709033",
      "description":
        "Vitamin C and Zinc support repair, while Ashwagandha boosts stamina. <span class=\"body-semibold-black darkmode\">Better VO₂ max and recovery</span> are often tracked in the app.",
      "cards": [
        { "emoji": "💪", "title": "Strength", "subtitle": "Improved muscle power" },
        { "emoji": "📊", "title": "VO₂ Max", "subtitle": "Better aerobic capacity" }
      ]
    },
    {
      "title": "Peak Performance &",
      "title_highlight": "Reset Period",
      "timeline": "Week 8",
      "timeline_image": "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/Fitness_Phase_3.webp?v=1763566209",
      "description":
        "The stack delivers peak <span class=\"body-semibold-black darkmode\">training resilience and reduced fatigue</span>. Ashwagandha and Zinc are cycled for 1 month.",
      "cards": [
        { "emoji": "⚡", "title": "Performance", "subtitle": "Steady training progress" },
        { "emoji": "🔄", "title": "Cycle Break", "subtitle": "Pause 1 month to reset" }
      ]
    }
  ]
};


const benefitsIcon = {
  'all': {"icon": "newspaper", "color": "#FF6900" }, 
  '101-faqs': {"icon": "circle-question-mark", "color": "#A2A2A2" }, 
  'dosage': {"icon": "scale", "color": "#A6A6A6" }, 
  'supplements': {"icon": "pill", "color": "#FF6900" },
  'Supplements': {"icon": "pill", "color": "#FF6900" },
  "nutrition": {"icon": "apple", "color": "#236F21" },
  "Nutrition": {"icon": "apple", "color": "#236F21" },
  "Training Boost": { "icon": "rocket", "color": "#FF6900" },
  "Performance": { "icon": "rocket", "color": "#FF6900" },
  "performance": { "icon": "rocket", "color": "#FF6900" },
  "Performance Edge": { "icon": "rocket", "color": "#FF6900" },

  "discount tag": { "icon": "tag", "color": "#FFA361" },

  "VO2 Max": { "icon": "gauge", "color": "#FF7778" },
  "VO₂ Max": { "icon": "gauge", "color": "#FF7778" },

  "Strength": { "icon": "dumbbell", "color": "#FF8905" },
  "Strength Gains": { "icon": "dumbbell", "color": "#FF8905" },
  "Strength & Power": { "icon": "dumbbell", "color": "#FF8905" },

  "Energy Production": { "icon": "battery", "color": "#FDC800" },
  "Energy": { "icon": "battery", "color": "#FDC800" },
  "Energy Boost": { "icon": "battery", "color": "#FDC800" },
  "Energy Balance": { "icon": "battery", "color": "#FDC800" },
  "Morning Energy": { "icon": "battery", "color": "#FDC800" },
  "Energy Lift": { "icon": "battery", "color": "#FDC800" },

  "Less Fatigue": { "icon": "battery-charging", "color": "#F4A300" },

  "Endurance": { "icon": "zap", "color": "#FFB869" },
  "fitness": { "icon": "zap", "color": "#FFB869" },
  "Fitness": { "icon": "zap", "color": "#FFB869" },
  "Stamina Boost": { "icon": "zap", "color": "#FFB869" },
  "Endurance Boost": { "icon": "zap", "color": "#FFB869" },

  "Recovery": { "icon": "rotate-ccw", "color": "#06DF73" },
  "recovery": { "icon": "rotate-ccw", "color": "#06DF73" },
  "Faster Recovery": { "icon": "rotate-ccw", "color": "#06DF73" },

  "Skin Health": { "icon": "bandage", "color": "#FFC6C6" },
  "Skin Glow": { "icon": "bandage", "color": "#FFC6C6" },
  "Skin & Hair": { "icon": "bandage", "color": "#FFC6C6" },
  "Skin & Beauty": { "icon": "bandage", "color": "#FFC6C6" }, // added
  "Skin": { "icon": "bandage", "color": "#FFC6C6" },

  "Calm Evenings": { "icon": "wind", "color": "#00BCFF" },
  "Stress Relief": { "icon": "wind", "color": "#00BCFF" },
  "Stress": { "icon": "wind", "color": "#00BCFF" }, // added
  "Anxiety": { "icon": "shell", "color": "#00D5BE" },

  "Stronger Nails": { "icon": "sparkles", "color": "#00D3F2" },
  "Nail Strength": { "icon": "sparkles", "color": "#00D3F2" },
  "Nails": { "icon": "sparkles", "color": "#00D3F2" }, // added

  "Eye Health": { "icon": "eye", "color": "#00D3F2" }, // added

  "Brain Health": { "icon": "brain", "color": "#7C68FF" },
  "Brain": { "icon": "brain", "color": "#7C68FF" },
  "Focus": { "icon": "lightbulb", "color": "#A3B4FF" }, // added
  "Memory": { "icon": "lightbulb", "color": "#A3B4FF" }, // added
  "Cognitive Performance": { "icon": "lightbulb", "color": "#A3B4FF" },

  "Heart & Circulation": { "icon": "heart", "color": "#FF575B" },
  "Heart Health": { "icon": "heart", "color": "#FF575B" },
  "Heart": { "icon": "heart", "color": "#FF575B" },

  "Circulation": { "icon": "heart-pulse", "color": "#E24C4B" },

  "Weight Management": { "icon": "scale", "color": "#D6BFFF" },
  "Weight": { "icon": "scale", "color": "#D6BFFF" },

  "Hair Strength": { "icon": "waves", "color": "#FFE875" },
  "Hair": { "icon": "waves", "color": "#FFE875" }, // added

  "Mental Health": { "icon": "smile", "color": "#A684FF" },
  "Mood Improvement": { "icon": "smile", "color": "#A684FF" },
  "Mood": { "icon": "smile", "color": "#A684FF" }, // added // added

  "Cognitive": { "icon": "lightbulb", "color": "#A3B4FF" },

  "Immunity": { "icon": "shield", "color": "#00D5BE" },

  "Organ Health": { "icon": "heart-plus", "color": "#00DE72" },
  "Organ": { "icon": "heart-plus", "color": "#00DE72" },
  "Kidney Health": { "icon": "droplet", "color": "#00DE72" }, // added
  "Liver Health": { "icon": "droplet", "color": "#00DE72" }, // added

  "Bone Health": { "icon": "bone", "color": "#AFCFFF" },
  "Bone Density": { "icon": "bone", "color": "#AFCFFF" },
  "Bones": { "icon": "bone", "color": "#AFCFFF" }, // added
  "Joints": { "icon": "bone", "color": "#AFCFFF" },

  "Blood Health": { "icon": "droplets", "color": "#FA2C37" },
  "Blood": { "icon": "droplets", "color": "#FA2C37" },

  "Repro Health": { "icon": "baby", "color": "#F7339A" },
  "Hormones & Reproduction": { "icon": "baby", "color": "#F7339A" }, // added

  "Hormonal Health": { "icon": "circuit-board", "color": "#FEA5D5" },
  "Hormones": { "icon": "circuit-board", "color": "#FEA5D5" },
  "Hormone Balance": { "icon": "circuit-board", "color": "#FEA5D5" },
  "Hormonal Balance": { "icon": "circuit-board", "color": "#FEA5D5" },
  "Hormone Health": { "icon": "circuit-board", "color": "#FEA5D5" },
  "Male Health": { "icon": "mars", "color": "#00BCFF" }, // added
  "male health": { "icon": "mars", "color": "#00BCFF" }, // added
  "Female Health": { "icon": "venus", "color": "#FA2A55" }, // added
  "female health": { "icon": "venus", "color": "#FA2A55" }, // added


  "Improved HRV": { "icon": "activity", "color": "#50A2FF" },
  "HRV Score": { "icon": "activity", "color": "#50A2FF" },
  "HRV": { "icon": "activity", "color": "#50A2FF" },

  "Gut Health": { "icon": "apple", "color": "#7AF2A8" },
  "Gut": { "icon": "apple", "color": "#7AF2A8" },
  "Gut Balance": { "icon": "apple", "color": "#7AF2A8" },

  "Comfort": { "icon": "heart-handshake", "color": "#2DBE8D" },

  "Deep Sleep": { "icon": "moon", "color": "#8EC6FF" },
  "Sleep Ease": { "icon": "moon", "color": "#8EC6FF" },
  "Restorative Sleep": { "icon": "moon", "color": "#8EC6FF" },
  "Sleep Quality": { "icon": "moon", "color": "#8EC6FF" },
  "Sleep": { "icon": "moon", "color": "#8EC6FF" },
  "sleep": { "icon": "moon", "color": "#8EC6FF" },
  "Better Sleep": { "icon": "moon", "color": "#8EC6FF" },
  "Falling Asleep": { "icon": "moon", "color": "#8EC6FF" }, // added
  "Staying Asleep": { "icon": "moon", "color": "#8EC6FF" }, // added

  "Boosted REM & Deep Sleep": { "icon": "moon-star", "color": "#4A90E2" },
  "Boosted REM & DEEP": { "icon": "moon-star", "color": "#4A90E2" },
  "Deep & REM": { "icon": "moon-star", "color": "#4A90E2" },

  "longevity": { "icon": "leaf", "color": "#00D492" },
  "Longevity": { "icon": "leaf", "color": "#00D492" },

  "Disease Prevention": { "icon": "cross", "color": "#0FFF6E" },

  "Cell Defense": { "icon": "shield-check", "color": "#47ECD5" },

  "Fat Loss": { "icon": "trending-down", "color": "#C27BFF" },
  "Fat Metabolism": { "icon": "trending-down", "color": "#C27BFF" },

  "Cycle Break": { "icon": "calendar", "color": "#afafaf" },

  "Musculoskeletal": { "icon": "biceps-flexed", "color": "#FFB900" },
  
  "Muscle Support": { "icon": "biceps-flexed", "color": "#FFB900" },
  "Muscle Mass": { "icon": "biceps-flexed", "color": "#FFB900" }, // added
  "Musculoskeletal Health": { "icon": "biceps-flexed", "color": "#FFB900" }, // added

  "Connect Your Device": { "icon": "bluetooth-connected", "color": "#31FF9B" },
  "Take Your First Supplements": { "icon": "pill", "color": "#F9770A" },

  "Review Your Dashboard": { "icon": "chart-line", "color": "#31FF9B" },
  "Complete Your Weekly Check-In": { "icon": "clipboard-list", "color": "#F9770A" },

  "View Your Suggestions": { "icon": "sliders-horizontal", "color": "#31FF9B" },
  "Optimize Your Protocol": { "icon": "rotate-cw", "color": "#F9770A" },
}


const deviceLogoImages = {
  'whoop': 'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/logo_whoop.webp?v=1762332571',
  'apple watch': 'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/logo_apple-watch.webp?v=1762332571',
  'samsung galaxy': 'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/logo_samsung-galaxy-watch.webp?v=1762332571',
  'oura': 'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/logo_oura.webp?v=1762332571',
  'coros': 'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/logo_coros.webp?v=1762332571',
  'fitbit': 'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/logo_fitbit.webp?v=1762332571', 
  'garmin': 'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/logo_garmin.webp?v=1762332570',
  'polar': 'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/polar-logo.png?v=1781073493'
}


const guideSupplementArticle = {
    "Ashwagandha":'ashwagandha-the-calm-switch-for-a-wired-brain',
      "Biotin":'biotin-the-beauty-vitamin-you-notice-in-the-mirror',
      "Calcium":'calcium-the-foundation-for-optimal-health',
      "CoQ10":'coq10-the-quiet-engine-behind-your-energy',
      "Folic Acid":'folic-acid-the-blueprint-behind-new-cells',
      "Iron":'iron-the-missing-link-in-everyday-energy',
      "Magnesium":'magnesium-the-reset-button-for-muscles-and-mind',
      "Omega 3":'omega-3-the-tiny-routine-behind-a-sharper-brain',
      "Probiotics":'probiotics-gut-health-myths-vs-science',
      "Vitamin B12":'vitamin-b12-the-line-between-focus-and-fatigue',
      "Vitamin B2":'vitamin-b2-the-vitamin-that-turns-food-into-fuel',
      "Vitamin B6":'vitamin-b6-the-link-between-food-and-mood',
      "Vitamin C":'vitamin-c-the-first-responder-for-recovery',
      "Vitamin D":'vitamin-d-the-way-your-body-turns-sunlight-into-strength',
      "Vitamin E":'vitamin-e-the-protective-coat-around-your-cells',
      "Zinc":'zinc-the-repair-crew-for-your-immune-system'
  }

  const benefitArticle = {
        'Sleep': 'sleep-and-health-your-whole-body-depends-on-it',
        'Energy': 'nutrient-deficiencies-5-common-signs-you-are-ignoring',
        'Fat Loss': 'why-your-fat-burning-workouts-are-not-working',
        'Recovery': 'fitness-recovery-focus-on-what-matters-according-to-science',
        'Hybrid Athlete': 'cardio-and-strength-research-backed-rules-for-hybrid-training' ,
        'Endurance': 'fuel-your-training-what-to-eat-and-drink-around-workouts' ,
        'Strength & Power': 'strength-training-for-health-and-longevity-what-the-science-says' ,
      }


const relatedArticles = {
    "Our Story":['the-4-big-theories-of-aging-why-we-age', 'nutrition-for-physical-performance-the-evidence-based-guide', 'longevity-and-supplements-what-the-science-actually-says'],

    "Nutricode App":['ai-and-wearables-how-close-are-we-to-preventive-healthcare', 'sleep-tracking-explained-stages-hrv-and-what-really-matters', 'wearables-and-fitness-apps-from-collecting-data-to-actionable-insights'],
    
    "Landing Page":['why-you-need-supplements-even-with-a-balanced-diet', 'how-to-make-your-supplements-work-in-real-life', 'how-wearables-can-tell-if-your-supplements-work'],

    "Ashwagandha":['ashwagandha-the-calm-switch-for-a-wired-brain', 'sleep-for-athletes-the-difference-between-fine-and-peak-performance', 'stress-and-longevity-how-cortisol-hits-your-immune-system-and-dna' ],
    "Biotin":['biotin-the-beauty-vitamin-you-notice-in-the-mirror', 'vitamin-e-the-protective-coat-around-your-cells', 'aging-explained-what-is-actually-happening-inside-your-cells' ],
    "Calcium":['calcium-the-foundation-for-optimal-health', 'your-bones-and-joints-need-strength-and-impact', 'vitamin-d-the-way-your-body-turns-sunlight-into-strength' ],
    "CoQ10":['coq10-the-quiet-engine-behind-your-energy', 'longevity-and-supplements-what-the-science-actually-says', 'the-future-of-longevity-exploring-gene-therapy-and-regenerative-medicine' ],
    "Folic Acid":['folic-acid-the-blueprint-behind-new-cells', 'aging-explained-what-is-actually-happening-inside-your-cells', 'natural-vs-synthetic-vitamins-is-there-really-a-difference'],
    "Iron":['iron-the-missing-link-in-everyday-energy', '5-nutrient-deficiencies-silently-ruining-your-health', 'nutrition-for-physical-performance-the-evidence-based-guide'],
    "Magnesium":['magnesium-the-reset-button-for-muscles-and-mind', '5-nutrient-deficiencies-silently-ruining-your-health', 'nutrition-for-physical-performance-the-evidence-based-guide'],
    "Omega 3":['omega-3-the-tiny-routine-behind-a-sharper-brain', 'chronological-vs-biological-age-from-dna-clocks-to-daily-choices', 'longevity-and-supplements-what-the-science-actually-says'],
    "Probiotics":['probiotics-gut-health-myths-vs-science', 'how-your-gut-microbiome-actually-impacts-your-health', 'the-power-of-fiber-on-your-metabolism'],
    "Vitamin B12":['vitamin-b12-the-line-between-focus-and-fatigue', 'plant-based-diets-the-healthiest-diet-according-to-science', '5-nutrition-myths-that-sound-right-but-arent' ],
    "Vitamin B2":['vitamin-b2-the-vitamin-that-turns-food-into-fuel', 'vitamin-b6-the-link-between-food-and-mood', 'nutrition-for-physical-performance-the-evidence-based-guide' ],
    "Vitamin B6":['vitamin-b6-the-link-between-food-and-mood', 'nutrient-deficiencies-5-common-signs-you-are-ignoring', 'how-your-diet-impacts-your-mood' ],
    "Vitamin C":['vitamin-c-the-first-responder-for-recovery', '5-immune-boosting-foods-explained-by-science', 'supplement-absorption-how-to-avoid-wasting-what-you-swallow' ],
    "Vitamin D":['vitamin-d-the-way-your-body-turns-sunlight-into-strength', 'chronological-vs-biological-age-from-dna-clocks-to-daily-choices', 'longevity-and-supplements-what-the-science-actually-says'],
    "Vitamin E":['vitamin-e-the-protective-coat-around-your-cells', 'antiaging-therapies-senolytics-stem-cells-peptides-nad-boosters-and-gene-therapy', 'biotin-the-beauty-vitamin-you-notice-in-the-mirror'],
    "Zinc":['zinc-the-repair-crew-for-your-immune-system', 'why-you-need-supplements-even-with-a-balanced-diet', 'fitness-recovery-focus-on-what-matters-according-to-science'],
    "The Sleep Protocol":['the-science-of-sleep-cycles-rem-deep-and-light-sleep', 'ashwagandha-the-calm-switch-for-a-wired-brain', 'sleep-and-health-your-whole-body-depends-on-it'],
    "The Fitness Protocol":['nutrition-for-physical-performance-the-evidence-based-guide', 'magnesium-the-reset-button-for-muscles-and-mind', 'fitness-recovery-focus-on-what-matters-according-to-science'],



    "Should endurance athletes take Omega-3?": [
      "omega-3-the-tiny-routine-behind-a-sharper-brain",
      "can-magnesium-enhance-exercise-performance",
      "fuel-your-training-what-to-eat-and-drink-around-workouts"
    ],
    "Can Magnesium enhance exercise performance?": [
      "magnesium-the-reset-button-for-muscles-and-mind",
      "should-endurance-athletes-take-omega-3?",
      "5-nutrient-deficiencies-silently-ruining-your-health"
    ],
    "What nutrients do long-distance runners need?": [
      "fuel-your-training-what-to-eat-and-drink-around-workouts",
      "how-hydration-levels-affect-your-physical-and-cognitive-performance",
      "nutrition-for-physical-performance-the-evidence-based-guide"
    ],
    "Nutrient timing for optimal performance": [
      "fuel-your-training-what-to-eat-and-drink-around-workouts",
      "nutrition-for-physical-performance-the-evidence-based-guide",
      "fitness-recovery-focus-on-what-matters-according-to-science"
    ],
    "How many days should you rest after a Half-Marathon?": [
      "fitness-recovery-focus-on-what-matters-according-to-science",
      "overtraining-spot-the-red-flags-before-its-too-late",
      "if-you-are-serious-about-fitness-this-is-how-to-track-your-progress"
    ],
    "CoQ10: The Quiet Engine Behind Your Energy": [
      "vitamin-b12-the-line-between-focus-and-fatigue",
      "longevity-and-supplements-what-the-science-actually-says",
      "iron-the-missing-link-in-everyday-energy"
    ],
    "Iron: The Missing Link in Everyday Energy": [
      "5-nutrient-deficiencies-silently-ruining-your-health",
      "supplement-absorption-how-to-avoid-wasting-what-you-swallow",
      "vitamin-b12-the-line-between-focus-and-fatigue"
    ],
    "How to Make Your Supplements Work in Real Life": [
      "how-to-turn-your-goals-into-a-supplement-strategy",
      "supplements-a-practical-guide-to-safe-doses-and-interactions",
      "why-you-need-supplements-even-with-a-balanced-diet"
    ],
    "How to Turn Your Goals into a Supplement Strategy": [
      "how-to-make-your-supplements-work-in-real-life",
      "supplements-a-practical-guide-to-safe-doses-and-interactions",
      "how-to-build-a-personalized-nutrition-and-supplement-plan"
    ],
    "Supplement Absorption: How to Avoid Wasting What You Swallow": [
      "how-to-make-your-supplements-work-in-real-life",
      "supplements-a-practical-guide-to-safe-doses-and-interactions",
      "how-to-turn-your-goals-into-a-supplement-strategy"
    ],
    "Supplements: A Practical Guide to Safe Doses and Interactions": [
      "how-to-make-your-supplements-work-in-real-life",
      "how-to-turn-your-goals-into-a-supplement-strategy",
      "why-you-need-supplements-even-with-a-balanced-diet"
    ],
    "6 Supplement Myths the Industry Wants You to Believe": [
      "why-you-need-supplements-even-with-a-balanced-diet",
      "supplements-a-practical-guide-to-safe-doses-and-interactions",
      "how-to-make-your-supplements-work-in-real-life"
    ],
    "Natural vs Synthetic Vitamins: Is There Really a Difference?": [
      "why-you-need-supplements-even-with-a-balanced-diet",
      "how-to-make-your-supplements-work-in-real-life",
      "6-supplement-myths-the-industry-wants-you-to-believe"
    ],
    "How to Build a Personalized Nutrition and Supplement Plan": [
      "how-to-turn-your-goals-into-a-supplement-strategy",
      "how-to-make-your-supplements-work-in-real-life",
      "how-wearables-can-tell-if-your-supplements-work"
    ],
    "Wearables and Fitness Apps: From Collecting Data to Actionable Insights": [
      "how-wearables-can-tell-if-your-supplements-work",
      "sleep-tracking-explained-stages-hrv-and-what-really-matters",
      "how-to-build-a-fitness-routine-youll-never-quit"
    ],
    "Naps: The Unsuspected Mental and Physical Benefits": [
      "the-impact-of-sleep-deprivation-on-your-health",
      "morning-light-and-your-circadian-rhythm-a-practical-guide",
      "sleep-wake-cycle-align-your-schedule-with-your-biology"
    ],
    "Sleep Needs by Age: How Many Hours You Actually Need, According to Science": [
      "master-your-sleep-5-evidence-based-tweaks-for-better-nights",
      "the-impact-of-sleep-deprivation-on-your-health",
      "sleep-wake-cycle-align-your-schedule-with-your-biology"
    ],
    "Overtraining: Spot the Red Flags Before It's Too Late": [
      "fitness-recovery-focus-on-what-matters-according-to-science",
      "if-you-are-serious-about-fitness-this-is-how-to-track-your-progress",
      "nutrition-for-physical-performance-the-evidence-based-guide"
    ],
    "Sleep Tracking Explained: Stages, HRV and What Really Matters": [
      "wearables-and-fitness-apps-from-collecting-data-to-actionable-insights",
      "how-wearables-can-tell-if-your-supplements-work",
      "sleep-wake-cycle-align-your-schedule-with-your-biology"
    ],
    "Natural vs Added Sugar: Is There a Difference for Your Health?": [
      "decoding-nutrition-labels-the-lines-you-should-always-check",
      "calories-and-metabolic-health-beyond-simple-in-vs-out",
      "natural-vs-synthetic-vitamins-is-there-really-a-difference"
    ],
    "Nutrition for Physical Performance: The Evidence Based Guide": [
      "fitness-for-busy-people-how-to-personalize-your-routine-around-life",
      "fuel-your-training-what-to-eat-and-drink-around-workouts",
      "why-your-fat-burning-workouts-are-not-working"
    ],
    "Lifestyle vs Genetics: What Actually Controls How Long You Live": [
      "can-healthy-habits-override-bad-genetics-for-longevity",
      "lifespan-vs-healthspan-the-aging-metric-most-people-ignore",
      "aging-explained-what-is-actually-happening-inside-your-cells"
    ],
    "The 5 Pillars of Longevity": [
      "the-5-daily-habits-long-living-people-have-in-common",
      "blue-zones-key-lessons-from-the-worlds-longest-living-communities",
      "happiness-and-longevity-what-the-science-says"
    ],
    "Blue Zones: Key Lessons from the World’s Longest Living Communities": [
      "the-5-pillars-of-longevity",
      "the-5-daily-habits-long-living-people-have-in-common",
      "what-nutrition-and-hydration-habits-matter-most-for-longevity"
    ],
    "The 4 Big Theories of Aging: Why We Age": [
      "aging-explained-what-is-actually-happening-inside-your-cells",
      "antiaging-therapies-senolytics-stem-cells-peptides-nad-boosters-and-gene-therapy",
      "longevity-and-supplements-what-the-science-actually-says"
    ],
    "Stress and Longevity: How Cortisol Hits Your Immune System and DNA": [
      "the-influence-of-lifestyle-on-epigenetics-and-aging",
      "the-5-daily-habits-long-living-people-have-in-common",
      "aging-explained-what-is-actually-happening-inside-your-cells"
    ],
    "Telomeres: The True Biological Clock": [
      "aging-explained-what-is-actually-happening-inside-your-cells",
      "the-influence-of-lifestyle-on-epigenetics-and-aging",
      "the-5-daily-habits-long-living-people-have-in-common"
    ],
    "Lifespan vs Healthspan: The Aging Metric Most People Ignore": [
      "lifestyle-vs-genetics-what-actually-controls-how-long-you-live",
      "the-5-daily-habits-long-living-people-have-in-common",
      "can-healthy-habits-override-bad-genetics-for-longevity"
    ],
    "Chronological vs Biological Age: From DNA Clocks to Daily Choices": [
      "the-influence-of-lifestyle-on-epigenetics-and-aging",
      "aging-explained-what-is-actually-happening-inside-your-cells",
      "the-4-big-theories-of-aging-why-we-age"
    ],
    "Sleep for Athletes: The Difference Between “Fine” and Peak Performance": [
      "fitness-recovery-focus-on-what-matters-according-to-science",
      "sleep-and-health-your-whole-body-depends-on-it",
      "the-impact-of-sleep-deprivation-on-your-health"
    ],
    "HIIT vs Steady-State Cardio: Benefits, Calorie Burn, and Heart Health": [
      "cardio-and-strength-research-backed-rules-for-hybrid-training",
      "these-15-minute-workouts-can-improve-fitness-according-to-science",
      "regular-exercise-the-closest-thing-we-have-to-a-health-pill"
    ],
    "AI and Wearables: How Close Are We to Preventive Healthcare?": [
      "how-wearables-can-tell-if-your-supplements-work",
      "the-future-of-longevity-exploring-gene-therapy-and-regenerative-medicine",
      "wearables-and-fitness-apps-from-collecting-data-to-actionable-insights"
    ],
    "Cardio and Strength: Research Backed Rules for Hybrid Training": [
      "fitness-for-busy-people-how-to-personalize-your-routine-around-life",
      "the-perfect-longevity-workout-week-according-to-research",
      "nutrition-for-physical-performance-the-evidence-based-guide"
    ],
    "Flexibility and Mobility: The Impact on Performance and Health": [
      "why-coaches-and-physios-swear-by-functional-fitness",
      "are-you-exercising-enough-to-actually-live-longer",
      "your-bones-and-joints-need-strength-and-impact"
    ],
    "Fitness Recovery: Focus on What Matters According to Science": [
      "overtraining-spot-the-red-flags-before-its-too-late",
      "if-you-are-serious-about-fitness-this-is-how-to-track-your-progress",
      "fuel-your-training-what-to-eat-and-drink-around-workouts"
    ],
    "Why You Need Supplements Even with a “Balanced” Diet": [
      "how-to-make-your-supplements-work-in-real-life",
      "6-supplement-myths-the-industry-wants-you-to-believe",
      "how-to-turn-your-goals-into-a-supplement-strategy"
    ],
    "How Exercise Impacts Your Brain and Mood": [
      "regular-exercise-the-closest-thing-we-have-to-a-health-pill",
      "how-your-sleep-impacts-your-mood",
      "happiness-and-longevity-what-the-science-says"
    ],
    "Can Strong Relationships Help You Live Longer?": [
      "the-5-daily-habits-long-living-people-have-in-common",
      "happiness-and-longevity-what-the-science-says",
      "the-5-pillars-of-longevity"
    ],
    "The Power of Fiber on Your Metabolism": [
      "how-your-gut-microbiome-actually-impacts-your-health",
      "4-superfoods-explained-by-science",
      "plant-based-diets-the-healthiest-diet-according-to-science"
    ],
    "5 Bodyweight Exercises Everyone Should Master": [
      "why-coaches-and-physios-swear-by-functional-fitness",
      "these-15-minute-workouts-can-improve-fitness-according-to-science",
      "core-and-balance-the-overlooked-keys-to-health-and-performance"
    ],
    "How Hydration Levels Affect Your Physical and Cognitive Performance": [
      "fuel-your-training-what-to-eat-and-drink-around-workouts",
      "what-nutrients-do-long-distance-runners-need-1",
      "nutrition-for-physical-performance-the-evidence-based-guide"
    ],
    "The Impact of Blue Light on Sleep and Eye Health": [
      "morning-light-and-your-circadian-rhythm-a-practical-guide",
      "sleep-environment-3-changes-to-optimize-your-rest",
      "master-your-sleep-5-evidence-based-tweaks-for-better-nights"
    ],
    "From Nuts to Dark Chocolate: 5 Snacks That Deserve the Hype": [
      "4-superfoods-explained-by-science",
      "macronutrients-and-micronutrients-the-foundation-of-every-good-diet",
      "how-your-diet-impacts-your-mood"
    ],
    "Sleep Environment: 3 Changes to Optimize Your Rest": [
      "sleep-wake-cycle-align-your-schedule-with-your-biology",
      "optimizing-sleep-4-strategies-for-better-rest",
      "master-your-sleep-5-evidence-based-tweaks-for-better-nights"
    ],
    "Optimizing Sleep: 4 Strategies for Better Rest": [
      "sleep-wake-cycle-align-your-schedule-with-your-biology",
      "master-your-sleep-5-evidence-based-tweaks-for-better-nights",
      "sleep-environment-3-changes-to-optimize-your-rest"
    ],
    "Whole Foods vs Processed: What Actually Matters for Your Health": [
      "plant-based-diets-the-healthiest-diet-according-to-science",
      "decoding-nutrition-labels-the-lines-you-should-always-check",
      "how-your-diet-impacts-your-mood"
    ],
    "5 Natural Sleep Aids Explained by Science": [
      "master-your-sleep-5-evidence-based-tweaks-for-better-nights",
      "optimizing-sleep-4-strategies-for-better-rest",
      "5-natural-sleep-techniques-backed-by-science"
    ],
    "5 Immune Boosting Foods Explained by Science": [
      "vitamin-c-the-first-responder-for-recovery",
      "4-superfoods-explained-by-science",
      "zinc-the-repair-crew-for-your-immune-system"
    ],
    "4 Superfoods Explained by Science": [
      "from-nuts-to-dark-chocolate-5-snacks-that-deserve-the-hype",
      "what-nutrition-and-hydration-habits-matter-most-for-longevity",
      "5-nutrient-deficiencies-silently-ruining-your-health"
    ],
    "Macronutrients and Micronutrients: The Foundation of Every Good Diet": [
      "5-nutrient-deficiencies-silently-ruining-your-health",
      "how-to-build-a-personalized-nutrition-and-supplement-plan",
      "decoding-nutrition-labels-the-lines-you-should-always-check"
    ],
    "Anti-Aging Therapies: Senolytics, Stem Cells, Peptides, NAD+ Boosters, and Gene Therapy": [
      "the-future-of-longevity-exploring-gene-therapy-and-regenerative-medicine",
      "aging-explained-what-is-actually-happening-inside-your-cells",
      "longevity-and-supplements-what-the-science-actually-says"
    ],
    "Decoding Nutrition Labels: The Lines You Should Always Check": [
      "macronutrients-and-micronutrients-the-foundation-of-every-good-diet",
      "how-to-make-your-supplements-work-in-real-life",
      "natural-vs-synthetic-vitamins-is-there-really-a-difference"
    ],
    "Carbs vs Fats: 5 Myths Debunked by Science": [
      "5-nutrition-myths-that-sound-right-but-arent",
      "why-your-fat-burning-workouts-are-not-working",
      "macronutrients-and-micronutrients-the-foundation-of-every-good-diet"
    ],
    "Biohacking and Longevity: What Actually Works?": [
      "the-5-daily-habits-long-living-people-have-in-common",
      "how-to-build-a-personalized-nutrition-and-supplement-plan",
      "the-future-of-longevity-exploring-gene-therapy-and-regenerative-medicine"
    ],
    "Happiness and Longevity: What the Science Says": [
      "the-5-daily-habits-long-living-people-have-in-common",
      "the-5-pillars-of-longevity",
      "can-strong-relationships-help-you-live-longer"
    ],
    "The Influence of Lifestyle on Epigenetics and Aging": [
      "aging-explained-what-is-actually-happening-inside-your-cells",
      "the-5-daily-habits-long-living-people-have-in-common",
      "the-future-of-longevity-exploring-gene-therapy-and-regenerative-medicine"
    ],
    "The Future of Longevity: Exploring Gene Therapy and Regenerative Medicine": [
      "antiaging-therapies-senolytics-stem-cells-peptides-nad-boosters-and-gene-therapy",
      "aging-explained-what-is-actually-happening-inside-your-cells",
      "longevity-and-supplements-what-the-science-actually-says"
    ],
    "Core and Balance: The Overlooked Keys to Health and Performance": [
      "why-coaches-and-physios-swear-by-functional-fitness",
      "5-bodyweight-exercises-everyone-should-master",
      "strength-training-for-health-and-longevity-what-the-science-says"
    ],
    "The Perfect Longevity Workout Week According to Research": [
      "are-you-exercising-enough-to-actually-live-longer",
      "the-role-of-exercise-at-every-stage-of-life",
      "the-5-daily-habits-long-living-people-have-in-common"
    ],
    "Fuel Your Training: What to Eat and Drink Around Workouts": [
      "nutrient-timing-for-optimal-performance",
      "nutrition-for-physical-performance-the-evidence-based-guide",
      "fitness-recovery-focus-on-what-matters-according-to-science"
    ],
    "Home vs Gym: The Trade Offs Most People Discover Too Late": [
      "fitness-for-busy-people-how-to-personalize-your-routine-around-life",
      "how-to-build-a-fitness-routine-youll-never-quit",
      "these-15-minute-workouts-can-improve-fitness-according-to-science"
    ],
    "These 15 Minute Workouts Can Improve Fitness According to Science": [
      "hiit-vs-steadystate-cardio-benefits-calorie-burn-and-heart-health",
      "5-bodyweight-exercises-everyone-should-master",
      "the-perfect-longevity-workout-week-according-to-research"
    ],
    "Master Your Sleep: 5 Evidence Based Tweaks for Better Nights": [
      "sleep-wake-cycle-align-your-schedule-with-your-biology",
      "5-natural-sleep-techniques-backed-by-science",
      "optimizing-sleep-4-strategies-for-better-rest"
    ],
    "Correct Your Form and Avoid Injuries with These Simple Tips": [
      "strength-training-for-health-and-longevity-what-the-science-says",
      "fitness-for-busy-people-how-to-personalize-your-routine-around-life",
      "your-bones-and-joints-need-strength-and-impact"
    ],
    "How Wearables Can Tell If Your Supplements Work": [
      "how-to-build-a-personalized-nutrition-and-supplement-plan",
      "wearables-and-fitness-apps-from-collecting-data-to-actionable-insights",
      "ai-and-wearables-how-close-are-we-to-preventive-healthcare"
    ],
    "Morning Light and Your Circadian Rhythm: A Practical Guide": [
      "sleep-wake-cycle-align-your-schedule-with-your-biology",
      "sleep-environment-3-changes-to-optimize-your-rest",
      "master-your-sleep-5-evidence-based-tweaks-for-better-nights"
    ],
    "Aging Explained: What Is Actually Happening Inside Your Cells": [
      "the-future-of-longevity-exploring-gene-therapy-and-regenerative-medicine",
      "antiaging-therapies-senolytics-stem-cells-peptides-nad-boosters-and-gene-therapy",
      "the-influence-of-lifestyle-on-epigenetics-and-aging"
    ],
    "5 Longevity Myths You Should Stop Believing Right Now": [
      "longevity-and-supplements-what-the-science-actually-says",
      "what-nutrition-and-hydration-habits-matter-most-for-longevity",
      "the-5-daily-habits-long-living-people-have-in-common"
    ],
    "Is the Keto Diet Actually Good for You?": [
      "carbs-vs-fats-5-myths-debunked-by-science",
      "the-secrets-behind-the-mediterranean-diet",
      "intermittent-fasting-for-metabolic-health-what-the-science-says"
    ],
    "The Secrets Behind the Mediterranean Diet": [
      "plant-based-diets-the-healthiest-diet-according-to-science",
      "how-your-diet-impacts-your-mood",
      "is-the-keto-diet-actually-good-for-you"
    ],
    "Are You Exercising Enough to Actually Live Longer?": [
      "the-perfect-longevity-workout-week-according-to-research",
      "the-role-of-exercise-at-every-stage-of-life",
      "regular-exercise-the-closest-thing-we-have-to-a-health-pill"
    ],
    "The 5 Daily Habits Long Living People Have in Common": [
      "happiness-and-longevity-what-the-science-says",
      "what-nutrition-and-hydration-habits-matter-most-for-longevity",
      "the-5-pillars-of-longevity"
    ],
    "How To Build a Fitness Routine You'll Never Quit": [
      "fitness-for-busy-people-how-to-personalize-your-routine-around-life",
      "the-role-of-exercise-at-every-stage-of-life",
      "if-you-are-serious-about-fitness-this-is-how-to-track-your-progress"
    ],
    "Why Coaches and Physios Swear by Functional Fitness": [
      "5-bodyweight-exercises-everyone-should-master",
      "core-and-balance-the-overlooked-keys-to-health-and-performance",
      "your-bones-and-joints-need-strength-and-impact"
    ],
    "Fitness for Busy People: How to Personalize Your Routine Around Life": [
      "how-to-build-a-fitness-routine-youll-never-quit",
      "if-you-are-serious-about-fitness-this-is-how-to-track-your-progress",
      "the-role-of-exercise-at-every-stage-of-life"
    ],
    "If You Are Serious About Fitness, This Is How to Track Your Progress": [
      "how-to-build-a-fitness-routine-youll-never-quit",
      "fitness-for-busy-people-how-to-personalize-your-routine-around-life",
      "fitness-recovery-focus-on-what-matters-according-to-science"
    ],
    "Can Healthy Habits Override Bad Genetics for Longevity": [
      "lifespan-vs-healthspan-the-aging-metric-most-people-ignore",
      "aging-explained-what-is-actually-happening-inside-your-cells",
      "lifestyle-vs-genetics-what-actually-controls-how-long-you-live"
    ],
    "Ashwagandha: The Calm Switch for a Wired Brain": [
      "sleep-for-athletes-the-difference-between-fine-and-peak-performance", 
      "stress-and-longevity-how-cortisol-hits-your-immune-system-and-dna",
      "magnesium-the-reset-button-for-muscles-and-mind"
    ],
    "Biotin: The Beauty Vitamin You Notice in the Mirror": [
      "vitamin-b12-the-line-between-focus-and-fatigue",
      "nutrient-deficiencies-5-common-signs-you-are-ignoring",
      "vitamin-e-the-protective-coat-around-your-cells"
    ],
    "Calcium: The Foundation for Optimal Health?": [
      "vitamin-d-the-way-your-body-turns-sunlight-into-strength",
      "5-nutrient-deficiencies-silently-ruining-your-health",
      "how-to-make-your-supplements-work-in-real-life"
    ],
    "Folic Acid: The Blueprint Behind New Cells": [
      "5-nutrient-deficiencies-silently-ruining-your-health",
      "iron-the-missing-link-in-everyday-energy",
      "the-power-of-fiber-on-your-metabolism"
    ],
    "Magnesium: The Reset Button for Muscles and Mind": [
      "can-magnesium-enhance-exercise-performance",
      "5-nutrient-deficiencies-silently-ruining-your-health",
      "zinc-the-repair-crew-for-your-immune-system"
    ],
    "Omega 3: The Tiny Routine Behind a Sharper Brain": [
      "should-endurance-athletes-take-omega-3",
      "how-your-diet-impacts-your-mood",
      "5-nutrient-deficiencies-silently-ruining-your-health"
    ],
    "Probiotics: Gut Health Myths vs Science": [
      "how-your-gut-microbiome-actually-impacts-your-health",
      "how-to-make-your-supplements-work-in-real-life",
      "the-power-of-fiber-on-your-metabolism"
    ],
    "Vitamin B12: The Line Between Focus and Fatigue": [
      "vitamin-b2-the-vitamin-that-turns-food-into-fuel",
      "vitamin-b6-the-link-between-food-and-mood",
      "iron-the-missing-link-in-everyday-energy"
    ],
    "Vitamin B2: The Vitamin that Turns Food into Fuel": [
      "vitamin-b12-the-line-between-focus-and-fatigue",
      "vitamin-b6-the-link-between-food-and-mood",
      "iron-the-missing-link-in-everyday-energy"
    ],
    "Vitamin B6: The Link Between Food and Mood": [
      "vitamin-b12-the-line-between-focus-and-fatigue",
      "5-nutrient-deficiencies-silently-ruining-your-health",
      "vitamin-b2-the-vitamin-that-turns-food-into-fuel"
    ],
    "Vitamin C: The First Responder for Recovery": [
      "vitamin-d-the-way-your-body-turns-sunlight-into-strength",
      "5-immune-boosting-foods-explained-by-science",
      "zinc-the-repair-crew-for-your-immune-system"
    ],
    "Vitamin D: The Way Your Body Turns Sunlight into Strength": [
      "vitamin-c-the-first-responder-for-recovery",
      "calcium-the-foundation-for-optimal-health",
      "5-nutrient-deficiencies-silently-ruining-your-health"
    ],
    "Vitamin E: The Protective Coat Around Your Cells": [
      "vitamin-c-the-first-responder-for-recovery",
      "vitamin-d-the-way-your-body-turns-sunlight-into-strength",
      "natural-vs-synthetic-vitamins-is-there-really-a-difference"
    ],
    "Zinc: The Repair Crew for Your Immune System": [
      "vitamin-c-the-first-responder-for-recovery",
      "vitamin-d-the-way-your-body-turns-sunlight-into-strength",
      "5-nutrient-deficiencies-silently-ruining-your-health"
    ],
    "Nutrient Deficiencies: 5 Common Signs You Are Ignoring": [
      "5-nutrient-deficiencies-silently-ruining-your-health",
      "biotin-the-beauty-vitamin-you-notice-in-the-mirror",
      "vitamin-b12-the-line-between-focus-and-fatigue"
    ],
    "Meal Planning: The Strategy that Simplifies Healthy Eating": [
      "macronutrients-and-micronutrients-the-foundation-of-every-good-diet",
      "how-to-build-a-personalized-nutrition-and-supplement-plan",
      "plant-based-diets-the-healthiest-diet-according-to-science"
    ],
    "Protein: How Much You Really Need, Based on Science": [
      "macronutrients-and-micronutrients-the-foundation-of-every-good-diet",
      "how-to-build-a-personalized-nutrition-and-supplement-plan",
      "5-nutrient-deficiencies-silently-ruining-your-health"
    ],
    "Sleep Disorders: The Warning Signs You Should Not Ignore": [
      "sleep-and-health-your-whole-body-depends-on-it",
      "sleep-needs-by-age-how-many-hours-you-actually-need-according-to-science",
      "the-impact-of-sleep-deprivation-on-your-health"
    ],
    "Calories and Metabolic Health: Beyond Simple “In vs Out”": [
      "decoding-nutrition-labels-the-lines-you-should-always-check",
      "carbs-vs-fats-5-myths-debunked-by-science",
      "macronutrients-and-micronutrients-the-foundation-of-every-good-diet"
    ],
    "Sleep and Health: Your Whole Body Depends on It": [
      "the-impact-of-sleep-deprivation-on-your-health",
      "master-your-sleep-5-evidence-based-tweaks-for-better-nights",
      "how-your-sleep-impacts-your-mood"
    ],
    "Regular Exercise: The Closest Thing We Have to a Health Pill": [
      "are-you-exercising-enough-to-actually-live-longer",
      "the-perfect-longevity-workout-week-according-to-research",
      "the-role-of-exercise-at-every-stage-of-life"
    ],
    "Plant Based Diets: The Healthiest Diet According to Science": [
      "whole-foods-vs-processed-what-actually-matters-for-your-health",
      "the-secrets-behind-the-mediterranean-diet",
      "meal-planning-the-strategy-that-simplifies-healthy-eating"
    ],
    "Sleep and Longevity: What the Science Says": [
      "the-5-daily-habits-long-living-people-have-in-common",
      "master-your-sleep-5-evidence-based-tweaks-for-better-nights",
      "the-5-pillars-of-longevity"
    ],
    "The Science of Sleep Cycles: REM, Deep and Light Sleep": [
      "sleep-needs-by-age-how-many-hours-you-actually-need-according-to-science",
      "the-impact-of-sleep-deprivation-on-your-health",
      "sleep-wake-cycle-align-your-schedule-with-your-biology"
    ],
    "Longevity and Supplements: What the Science Actually Says": [
      "antiaging-therapies-senolytics-stem-cells-peptides-nad-boosters-and-gene-therapy",
      "the-future-of-longevity-exploring-gene-therapy-and-regenerative-medicine",
      "5-longevity-myths-you-should-stop-believing-right-now"
    ],
    "What Nutrition and Hydration Habits Matter Most for Longevity": [
      "the-5-daily-habits-long-living-people-have-in-common",
      "5-longevity-myths-you-should-stop-believing-right-now",
      "longevity-and-supplements-what-the-science-actually-says"
    ],
    "How Your Gut Microbiome Actually Impacts Your Health": [
      "probiotics-gut-health-myths-vs-science",
      "macronutrients-and-micronutrients-the-foundation-of-every-good-diet",
      "the-power-of-fiber-on-your-metabolism"
    ],
    "How Your Sleep Impacts Your Mood": [
      "sleep-and-health-your-whole-body-depends-on-it",
      "the-impact-of-sleep-deprivation-on-your-health",
      "master-your-sleep-5-evidence-based-tweaks-for-better-nights"
    ],
    "The Impact of Sleep Deprivation on Your Health": [
      "sleep-and-health-your-whole-body-depends-on-it",
      "sleep-needs-by-age-how-many-hours-you-actually-need-according-to-science",
      "master-your-sleep-5-evidence-based-tweaks-for-better-nights"
    ],
    "How Your Diet Impacts Your Mood": [
      "macronutrients-and-micronutrients-the-foundation-of-every-good-diet",
      "whole-foods-vs-processed-what-actually-matters-for-your-health",
      "5-nutrient-deficiencies-silently-ruining-your-health"
    ],
    "Sleep Wake Cycle: Align Your Schedule with Your Biology": [
      "master-your-sleep-5-evidence-based-tweaks-for-better-nights",
      "sleep-environment-3-changes-to-optimize-your-rest",
      "optimizing-sleep-4-strategies-for-better-rest"
    ],
    "Strength Training for Health and Longevity: What the Science Says": [
      "are-you-exercising-enough-to-actually-live-longer",
      "are-you-training-the-right-way-for-your-age",
      "the-role-of-exercise-at-every-stage-of-life"
    ],
    "Your Bones and Joints Need Strength and Impact": [
      "are-you-training-the-right-way-for-your-age",
      "are-you-exercising-enough-to-actually-live-longer",
      "the-perfect-longevity-workout-week-according-to-research"
    ],
    "The Role of Exercise at Every Stage of Life": [
      "are-you-exercising-enough-to-actually-live-longer",
      "the-perfect-longevity-workout-week-according-to-research",
      "are-you-training-the-right-way-for-your-age"
    ],
    "5 Natural Sleep Techniques Backed by Science": [
      "master-your-sleep-5-evidence-based-tweaks-for-better-nights",
      "sleep-wake-cycle-align-your-schedule-with-your-biology",
      "5-natural-sleep-aids-explained-by-science"
    ],
    "Intermittent Fasting for Metabolic Health: What the Science Says": [
      "can-caloric-restriction-and-fasting-really-help-you-live-longer",
      "is-the-keto-diet-actually-good-for-you",
      "5-nutrition-myths-that-sound-right-but-arent"
    ],
    "Can Caloric Restriction and Fasting Really Help You Live Longer?": [
      "intermittent-fasting-for-metabolic-health-what-the-science-says",
      "5-longevity-myths-you-should-stop-believing-right-now",
      "the-5-daily-habits-long-living-people-have-in-common"
    ],
    "Why Your “Fat Burning” Workouts Are Not Working": [
      "5-nutrition-myths-that-sound-right-but-arent",
      "nutrition-for-physical-performance-the-evidence-based-guide",
      "carbs-vs-fats-5-myths-debunked-by-science"
    ],
    "Are You Training the Right Way for Your Age?": [
      "the-role-of-exercise-at-every-stage-of-life",
      "your-bones-and-joints-need-strength-and-impact",
      "are-you-exercising-enough-to-actually-live-longer"
    ],
    "5 Nutrition Myths that Sound Right but Aren’t": [
      "carbs-vs-fats-5-myths-debunked-by-science",
      "6-supplement-myths-the-industry-wants-you-to-believe",
      "why-your-fat-burning-workouts-are-not-working"
    ],
    "5 Nutrient Deficiencies Silently Ruining Your Health": [
      "macronutrients-and-micronutrients-the-foundation-of-every-good-diet",
      "nutrient-deficiencies-5-common-signs-you-are-ignoring",
      "why-you-need-supplements-even-with-a-balanced-diet"
    ]

  };


const supplement_metrics = {
  "supplements": [
    {
      "name": "Iron",
      "dosage": "60 mg/day",
      "metrics": {
        "VO2 Max": {
          "9": {
            "placebo": "+0%",
            "treatment": "+6.5%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "1RM": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "HRV": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "REM Sleep": {
          "8": {
            "placebo": "+0%",
            "treatment": "+15%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Deep Sleep": {
          "8": {
            "placebo": "+0%",
            "treatment": "+4%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Latency": {
          "12": {
            "placebo": "+0%",
            "treatment": "-38%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Disturbances": {
          "12": {
            "placebo": "+0%",
            "treatment": "-35%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "RHR": {
          "10": {
            "placebo": "+0%",
            "treatment": "-6.5%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "BMR": {
          "12": {
            "placebo": "+0%",
            "treatment": "+4%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        }
      }
    },
    {
      "name": "Magnesium",
      "dosage": "400 mg/day",
      "metrics": {
        "VO2 Max": {
          "24": {
            "placebo": "+1%",
            "treatment": "+11%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "1RM": {
          "4": {
            "placebo": "+4%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "HRV": {
          "13": {
            "placebo": "+0%",
            "treatment": "+17%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "REM Sleep": {
          "3": {
            "placebo": "+0%",
            "treatment": "+5%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Deep Sleep": {
          "3": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Latency": {
          "8": {
            "placebo": "+0%",
            "treatment": "-15%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Disturbances": {
          "4": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "RHR": {
          "6": {
            "placebo": "+0%",
            "treatment": "-2%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "BMR": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        }
      }
    },
    {
      "name": "Omega 3",
      "dosage": "3 g/day",
      "metrics": {
        "VO2 Max": {
          "12": {
            "placebo": "+3.1%",
            "treatment": "+8%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "1RM": {
          "10": {
            "placebo": "+9.7%",
            "treatment": "+14.2%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "HRV": {
          "8": {
            "placebo": "+0%",
            "treatment": "+9.9%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "REM Sleep": {
          "26": {
            "placebo": "+0%",
            "treatment": "+17%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Deep Sleep": {
          "26": {
            "placebo": "+0%",
            "treatment": "+25%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Latency": {
          "16": {
            "placebo": "+0%",
            "treatment": "-45%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Disturbances": {
          "16": {
            "placebo": "+0%",
            "treatment": "-55%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "RHR": {
          "16": {
            "placebo": "+0%",
            "treatment": "-6.8%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "BMR": {
          "12": {
            "placebo": "+0%",
            "treatment": "+22.9%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        }
      }
    },
    {
      "name": "Zinc",
      "dosage": "50 mg/day",
      "metrics": {
        "VO2 Max": {
          "6": {
            "placebo": "+0%",
            "treatment": "+4.4%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "1RM": {
          "8": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "HRV": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "REM Sleep": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Deep Sleep": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Latency": {
          "8": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Disturbances": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "RHR": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "BMR": {
          "8": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        }
      }
    },
    {
      "name": "Vitamin C",
      "dosage": "1000 mg/day",
      "metrics": {
        "VO2 Max": {
          "6": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "1RM": {
          "8": {
            "placebo": "+0%",
            "treatment": "+6%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "HRV": {
          "4": {
            "placebo": "+0%",
            "treatment": "+9.1%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "REM Sleep": {
          "3": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Deep Sleep": {
          "3": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Latency": {
          "2": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Disturbances": {
          "2": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "RHR": {
          "4": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "BMR": {
          "8": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        }
      }
    },
    {
      "name": "Vitamin B6",
      "dosage": "200 mg/day",
      "metrics": {
        "VO2 Max": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "1RM": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "HRV": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "REM Sleep": {
          "1": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Deep Sleep": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Latency": {
          "1": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Disturbances": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "RHR": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "BMR": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        }
      }
    },
    {
      "name": "CoQ10",
      "dosage": "200 mg/day",
      "metrics": {
        "VO2 Max": {
          "2": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "1RM": {
          "12": {
            "placebo": "+0%",
            "treatment": "+17.7%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "HRV": {
          "2": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "REM Sleep": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Deep Sleep": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Latency": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Disturbances": {
          "6": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "RHR": {
          "6": {
            "placebo": "+0%",
            "treatment": "-5%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "BMR": {
          "12": {
            "placebo": "+0%",
            "treatment": "+14%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        }
      }
    },
    {
      "name": "Ashwagandha",
      "dosage": "900 mg/day",
      "metrics": {
        "VO2 Max": {
          "8": {
            "placebo": "+2.7%",
            "treatment": "+4.5%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "1RM": {
          "8": {
            "placebo": "+8%",
            "treatment": "+12%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "HRV": {
          "12": {
            "placebo": "+0%",
            "treatment": "+10%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "REM Sleep": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Deep Sleep": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Latency": {
          "10": {
            "placebo": "+0%",
            "treatment": "-30%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Disturbances": {
          "8": {
            "placebo": "+0%",
            "treatment": "-20%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "RHR": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "BMR": {
          "0": {
            "placebo": "+0%",
            "treatment": "+0%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        }
      }
    }
  ]
}